/* eslint-disable */
// Generated by scripts/generateWikiSnapshot.js from the official Dead by Daylight Wiki.
// Keep this file committed so the app never depends on a live third-party API.
export default {
  "schemaVersion": 2,
  "generatedAt": "2026-07-28",
  "liveVersion": "10.0.3",
  "source": "https://deadbydaylight.wiki.gg/wiki/Module:Datatable/Loadout",
  "survivors": [
    {
      "id": 1,
      "slug": "dwight_fairfield",
      "name": "Dwight Fairfield",
      "realName": null,
      "power": null,
      "difficulty": null
    },
    {
      "id": 2,
      "slug": "meg_thomas",
      "name": "Meg Thomas",
      "realName": null,
      "power": null,
      "difficulty": null
    },
    {
      "id": 3,
      "slug": "claudette_morel",
      "name": "Claudette Morel",
      "realName": null,
      "power": null,
      "difficulty": null
    },
    {
      "id": 4,
      "slug": "jake_park",
      "name": "Jake Park",
      "realName": null,
      "power": null,
      "difficulty": null
    },
    {
      "id": 5,
      "slug": "nea_karlsson",
      "name": "Nea Karlsson",
      "realName": null,
      "power": null,
      "difficulty": null
    },
    {
      "id": 6,
      "slug": "laurie_strode",
      "name": "Laurie Strode",
      "realName": null,
      "power": null,
      "difficulty": null
    },
    {
      "id": 7,
      "slug": "ace_visconti",
      "name": "Ace Visconti",
      "realName": null,
      "power": null,
      "difficulty": null
    },
    {
      "id": 9,
      "slug": "feng_min",
      "name": "Feng Min",
      "realName": null,
      "power": null,
      "difficulty": null
    },
    {
      "id": 10,
      "slug": "david_king",
      "name": "David King",
      "realName": null,
      "power": null,
      "difficulty": null
    },
    {
      "id": 11,
      "slug": "quentin_smith",
      "name": "Quentin Smith",
      "realName": null,
      "power": null,
      "difficulty": null
    },
    {
      "id": 12,
      "slug": "detective_david_tapp",
      "name": "Detective David Tapp",
      "realName": null,
      "power": null,
      "difficulty": null
    },
    {
      "id": 13,
      "slug": "kate_denson",
      "name": "Kate Denson",
      "realName": null,
      "power": null,
      "difficulty": null
    },
    {
      "id": 14,
      "slug": "adam_francis",
      "name": "Adam Francis",
      "realName": null,
      "power": null,
      "difficulty": null
    },
    {
      "id": 16,
      "slug": "jane_romero",
      "name": "Jane Romero",
      "realName": null,
      "power": null,
      "difficulty": null
    },
    {
      "id": 17,
      "slug": "ashley_j_williams",
      "name": "Ashley J. Williams",
      "realName": null,
      "power": null,
      "difficulty": null
    },
    {
      "id": 18,
      "slug": "nancy_wheeler",
      "name": "Nancy Wheeler",
      "realName": null,
      "power": null,
      "difficulty": null
    },
    {
      "id": 19,
      "slug": "steve_harrington",
      "name": "Steve Harrington",
      "realName": null,
      "power": null,
      "difficulty": null
    },
    {
      "id": 20,
      "slug": "yui_kimura",
      "name": "Yui Kimura",
      "realName": null,
      "power": null,
      "difficulty": null
    },
    {
      "id": 21,
      "slug": "zarina_kassir",
      "name": "Zarina Kassir",
      "realName": null,
      "power": null,
      "difficulty": null
    },
    {
      "id": 22,
      "slug": "cheryl_mason",
      "name": "Cheryl Mason",
      "realName": null,
      "power": null,
      "difficulty": null
    },
    {
      "id": 23,
      "slug": "felix_richter",
      "name": "Felix Richter",
      "realName": null,
      "power": null,
      "difficulty": null
    },
    {
      "id": 24,
      "slug": "elodie_rakoto",
      "name": "Élodie Rakoto",
      "realName": null,
      "power": null,
      "difficulty": null
    },
    {
      "id": 25,
      "slug": "lee_yun_jin",
      "name": "Lee Yun-jin",
      "realName": null,
      "power": null,
      "difficulty": null
    },
    {
      "id": 26,
      "slug": "jill_valentine",
      "name": "Jill Valentine",
      "realName": null,
      "power": null,
      "difficulty": null
    },
    {
      "id": 27,
      "slug": "leon_scott_kennedy",
      "name": "Leon Scott Kennedy",
      "realName": null,
      "power": null,
      "difficulty": null
    },
    {
      "id": 28,
      "slug": "mikaela_reid",
      "name": "Mikaela Reid",
      "realName": null,
      "power": null,
      "difficulty": null
    },
    {
      "id": 29,
      "slug": "jonah_vasquez",
      "name": "Jonah Vasquez",
      "realName": null,
      "power": null,
      "difficulty": null
    },
    {
      "id": 30,
      "slug": "yoichi_asakawa",
      "name": "Yoichi Asakawa",
      "realName": null,
      "power": null,
      "difficulty": null
    },
    {
      "id": 31,
      "slug": "haddie_kaur",
      "name": "Haddie Kaur",
      "realName": null,
      "power": null,
      "difficulty": null
    },
    {
      "id": 32,
      "slug": "ada_wong",
      "name": "Ada Wong",
      "realName": null,
      "power": null,
      "difficulty": null
    },
    {
      "id": 33,
      "slug": "rebecca_chambers",
      "name": "Rebecca Chambers",
      "realName": null,
      "power": null,
      "difficulty": null
    },
    {
      "id": 34,
      "slug": "vittorio_toscano",
      "name": "Vittorio Toscano",
      "realName": null,
      "power": null,
      "difficulty": null
    },
    {
      "id": 35,
      "slug": "thalita_lyra",
      "name": "Thalita Lyra",
      "realName": null,
      "power": null,
      "difficulty": null
    },
    {
      "id": 36,
      "slug": "renato_lyra",
      "name": "Renato Lyra",
      "realName": null,
      "power": null,
      "difficulty": null
    },
    {
      "id": 37,
      "slug": "gabriel_soma",
      "name": "Gabriel Soma",
      "realName": null,
      "power": null,
      "difficulty": null
    },
    {
      "id": 38,
      "slug": "nicolas_cage",
      "name": "Nicolas Cage",
      "realName": null,
      "power": null,
      "difficulty": null
    },
    {
      "id": 39,
      "slug": "ellen_ripley",
      "name": "Ellen Ripley",
      "realName": null,
      "power": null,
      "difficulty": null
    },
    {
      "id": 40,
      "slug": "alan_wake",
      "name": "Alan Wake",
      "realName": null,
      "power": null,
      "difficulty": null
    },
    {
      "id": 41,
      "slug": "sable_ward",
      "name": "Sable Ward",
      "realName": null,
      "power": null,
      "difficulty": null
    },
    {
      "id": 42,
      "slug": "aestri_yazar_baermar_uraz",
      "name": "Aestri Yazar & Baermar Uraz",
      "realName": null,
      "power": null,
      "difficulty": null
    },
    {
      "id": 43,
      "slug": "lara_croft",
      "name": "Lara Croft",
      "realName": null,
      "power": null,
      "difficulty": null
    },
    {
      "id": 44,
      "slug": "trevor_belmont",
      "name": "Trevor Belmont",
      "realName": null,
      "power": null,
      "difficulty": null
    },
    {
      "id": 45,
      "slug": "taurie_cain",
      "name": "Taurie Cain",
      "realName": null,
      "power": null,
      "difficulty": null
    },
    {
      "id": 46,
      "slug": "orela_rose",
      "name": "Orela Rose",
      "realName": null,
      "power": null,
      "difficulty": null
    },
    {
      "id": 47,
      "slug": "rick_grimes",
      "name": "Rick Grimes",
      "realName": null,
      "power": null,
      "difficulty": null
    },
    {
      "id": 48,
      "slug": "michonne_grimes",
      "name": "Michonne Grimes",
      "realName": null,
      "power": null,
      "difficulty": null
    },
    {
      "id": 49,
      "slug": "vee_boonyasak",
      "name": "Vee Boonyasak",
      "realName": null,
      "power": null,
      "difficulty": null
    },
    {
      "id": 50,
      "slug": "dustin_henderson",
      "name": "Dustin Henderson",
      "realName": null,
      "power": null,
      "difficulty": null
    },
    {
      "id": 51,
      "slug": "eleven",
      "name": "Eleven",
      "realName": null,
      "power": null,
      "difficulty": null
    },
    {
      "id": 52,
      "slug": "kwon_tae_young",
      "name": "Kwon Tae-young",
      "realName": null,
      "power": null,
      "difficulty": null
    },
    {
      "id": 53,
      "slug": "shane_wiigwaas",
      "name": "Shane Wiigwaas",
      "realName": null,
      "power": null,
      "difficulty": null
    }
  ],
  "killers": [
    {
      "id": 1,
      "slug": "trapper",
      "name": "Trapper",
      "realName": "Evan MacMillan",
      "power": null,
      "difficulty": 1
    },
    {
      "id": 2,
      "slug": "wraith",
      "name": "Wraith",
      "realName": "Philip Ojomo",
      "power": null,
      "difficulty": 1
    },
    {
      "id": 3,
      "slug": "hillbilly",
      "name": "Hillbilly",
      "realName": "Max Thompson Jr.",
      "power": null,
      "difficulty": 2
    },
    {
      "id": 4,
      "slug": "nurse",
      "name": "Nurse",
      "realName": "Sally Smithson",
      "power": null,
      "difficulty": 4
    },
    {
      "id": 5,
      "slug": "shape",
      "name": "Shape",
      "realName": "Michael Myers",
      "power": null,
      "difficulty": 2
    },
    {
      "id": 6,
      "slug": "hag",
      "name": "Hag",
      "realName": "Lisa Sherwood",
      "power": "Blackened Catalyst",
      "difficulty": 4
    },
    {
      "id": 7,
      "slug": "doctor",
      "name": "Doctor",
      "realName": "Herman Carter",
      "power": "Carter",
      "difficulty": 3
    },
    {
      "id": 8,
      "slug": "huntress",
      "name": "Huntress",
      "realName": "Anna",
      "power": "Hunting Hatchets",
      "difficulty": 2
    },
    {
      "id": 9,
      "slug": "cannibal",
      "name": "Cannibal",
      "realName": "Bubba Sawyer",
      "power": "Bubba",
      "difficulty": 2
    },
    {
      "id": 10,
      "slug": "nightmare",
      "name": "Nightmare",
      "realName": "Freddy Krueger",
      "power": "Dream Demon",
      "difficulty": 2
    },
    {
      "id": 11,
      "slug": "pig",
      "name": "Pig",
      "realName": "Amanda Young",
      "power": "Jigsaw",
      "difficulty": 3
    },
    {
      "id": 12,
      "slug": "clown",
      "name": "Clown",
      "realName": "Kenneth Chase alias Jeffrey Hawk",
      "power": "The Afterpiece Tonic",
      "difficulty": 2
    },
    {
      "id": 13,
      "slug": "spirit",
      "name": "Spirit",
      "realName": "Rin Yamaoka",
      "power": "Yamaoka",
      "difficulty": 3
    },
    {
      "id": 14,
      "slug": "legion",
      "name": "Legion",
      "realName": "Frank Morrison, Julie Kostenko, Susie Lavoie, Joey Cadogan",
      "power": "Feral Frenzy",
      "difficulty": 1
    },
    {
      "id": 15,
      "slug": "plague",
      "name": "Plague",
      "realName": "Adiris",
      "power": "Vile Purge",
      "difficulty": 3
    },
    {
      "id": 16,
      "slug": "ghost_face",
      "name": "Ghost Face",
      "realName": "Danny Johnson alias Jed Olsen",
      "power": "Night Shroud",
      "difficulty": 3
    },
    {
      "id": 17,
      "slug": "demogorgon",
      "name": "Demogorgon",
      "realName": null,
      "power": "Of the Abyss",
      "difficulty": 3
    },
    {
      "id": 18,
      "slug": "oni",
      "name": "Oni",
      "realName": "Kazan Yamaoka",
      "power": "Yamaoka",
      "difficulty": 4
    },
    {
      "id": 19,
      "slug": "deathslinger",
      "name": "Deathslinger",
      "realName": "Caleb Quinn",
      "power": "The Redeemer",
      "difficulty": 3
    },
    {
      "id": 20,
      "slug": "executioner",
      "name": "Executioner",
      "realName": "Pyramid Head",
      "power": "Rites of Judgement",
      "difficulty": 4
    },
    {
      "id": 21,
      "slug": "blight",
      "name": "Blight",
      "realName": "Talbot Grimes",
      "power": "Blighted Corruption",
      "difficulty": 4
    },
    {
      "id": 22,
      "slug": "twins",
      "name": "Twins",
      "realName": "Charlotte & Victor Deshayes",
      "power": "Blood Bond",
      "difficulty": 4
    },
    {
      "id": 23,
      "slug": "trickster",
      "name": "Trickster",
      "realName": "Hak Ji-woon",
      "power": "Showstopper",
      "difficulty": 2
    },
    {
      "id": 24,
      "slug": "nemesis",
      "name": "Nemesis",
      "realName": "Nemesis T-Type",
      "power": "T-Virus",
      "difficulty": 3
    },
    {
      "id": 25,
      "slug": "cenobite",
      "name": "Cenobite",
      "realName": "Elliot Spencer",
      "power": "Summons of Pain",
      "difficulty": 4
    },
    {
      "id": 26,
      "slug": "artist",
      "name": "Artist",
      "realName": "Carmina Mora",
      "power": "Birds of Torment",
      "difficulty": 2
    },
    {
      "id": 27,
      "slug": "onryo",
      "name": "Onryō",
      "realName": "Sadako Yamamura",
      "power": "Deluge of Fear",
      "difficulty": 3
    },
    {
      "id": 28,
      "slug": "dredge",
      "name": "Dredge",
      "realName": null,
      "power": "Reign of Darkness",
      "difficulty": 2
    },
    {
      "id": 29,
      "slug": "mastermind",
      "name": "Mastermind",
      "realName": "Albert Wesker",
      "power": "Virulent Bound",
      "difficulty": 2
    },
    {
      "id": 30,
      "slug": "knight",
      "name": "Knight",
      "realName": "Tarhos Kovács",
      "power": "Guardia Compagnia",
      "difficulty": 2
    },
    {
      "id": 31,
      "slug": "skull_merchant",
      "name": "Skull Merchant",
      "realName": "Adriana Imai",
      "power": "Eyes in the Sky",
      "difficulty": 3
    },
    {
      "id": 32,
      "slug": "singularity",
      "name": "Singularity",
      "realName": "HUX-A7-13",
      "power": "Quantum Instantiation",
      "difficulty": 3
    },
    {
      "id": 33,
      "slug": "xenomorph",
      "name": "Xenomorph",
      "realName": null,
      "power": "Hidden Pursuit",
      "difficulty": 2
    },
    {
      "id": 34,
      "slug": "good_guy",
      "name": "Good Guy",
      "realName": "Charles Lee Ray",
      "power": "Playtime",
      "difficulty": 2
    },
    {
      "id": 35,
      "slug": "unknown",
      "name": "Unknown",
      "realName": null,
      "power": "UVX",
      "difficulty": 2
    },
    {
      "id": 36,
      "slug": "lich",
      "name": "Lich",
      "realName": "Vecna",
      "power": "Vile Darkness",
      "difficulty": 2
    },
    {
      "id": 37,
      "slug": "dark_lord",
      "name": "Dark Lord",
      "realName": "Dracula",
      "power": "Vampiric Shift",
      "difficulty": 2
    },
    {
      "id": 38,
      "slug": "houndmaster",
      "name": "Houndmaster",
      "realName": "Portia Maye",
      "power": "Scent of Blood",
      "difficulty": 2
    },
    {
      "id": 39,
      "slug": "ghoul",
      "name": "Ghoul",
      "realName": "Ken Kaneki",
      "power": "One-Eyed Terror",
      "difficulty": null
    },
    {
      "id": 40,
      "slug": "animatronic",
      "name": "Animatronic",
      "realName": "William Afton",
      "power": "Fazbear",
      "difficulty": null
    },
    {
      "id": 41,
      "slug": "krasue",
      "name": "Krasue",
      "realName": "Burong Sukapat",
      "power": "Unbodied Flesh",
      "difficulty": 2
    },
    {
      "id": 42,
      "slug": "first",
      "name": "First",
      "realName": "Henry Creel",
      "power": "Test Subject #001",
      "difficulty": null
    },
    {
      "id": 43,
      "slug": "slasher",
      "name": "Slasher",
      "realName": "Jason Voorhees",
      "power": "Omnipresent Evil",
      "difficulty": null
    }
  ],
  "items": [
    {
      "id": "broken_key",
      "name": "Broken Key",
      "rarity": 1,
      "patch": "9.1.0",
      "tags": [
        "Auras"
      ],
      "mechanics": {
        "charges": "6 Charges",
        "cost": "-1 Charge",
        "auraRange": "48 metres",
        "auraDuration": "8 seconds"
      },
      "category": 1
    },
    {
      "id": "dull_key",
      "name": "Dull Key",
      "rarity": 2,
      "patch": "9.1.0",
      "tags": [
        "Auras",
        "Chests",
        "Hatch",
        "RarityBonus",
        "RummageAbility"
      ],
      "mechanics": {
        "charges": "5 Charges",
        "cost": "-1 Charge",
        "auraRange": "56 metres",
        "auraDuration": "9 seconds",
        "chestAura": "42 metres",
        "survivorCount": 1,
        "rummageCount": "once",
        "hatch": "2.5 seconds"
      },
      "category": 1
    },
    {
      "id": "skeleton_key",
      "name": "Skeleton Key",
      "rarity": 3,
      "patch": "9.1.0",
      "tags": [
        "Auras",
        "Chests",
        "Hatch",
        "RarityBonus",
        "RummageAbility"
      ],
      "mechanics": {
        "charges": "6 Charges",
        "cost": "-1 Charge",
        "auraRange": "64 metres",
        "auraDuration": "10 seconds",
        "chestAura": "42 metres",
        "survivorCount": 1,
        "rummageCount": "once",
        "hatch": "2.5 seconds"
      },
      "category": 1
    },
    {
      "id": "anniversary_flashlight",
      "name": "Anniversary Flashlight",
      "rarity": 8,
      "tags": [
        "anniversaryEvent",
        "KillerBlind"
      ],
      "category": 3
    },
    {
      "id": "banquet_flashlight",
      "name": "Banquet Flashlight",
      "rarity": 8,
      "tags": [
        "anniversaryEvent",
        "KillerBlind"
      ],
      "category": 3
    },
    {
      "id": "flashlight",
      "name": "Flashlight",
      "rarity": 2,
      "tags": [
        "KillerBlind"
      ],
      "category": 3
    },
    {
      "id": "masquerade_flashlight",
      "name": "Masquerade Flashlight",
      "rarity": 8,
      "tags": [
        "anniversaryEvent",
        "KillerBlind"
      ],
      "category": 3
    },
    {
      "id": "sport_flashlight",
      "name": "Sport Flashlight",
      "rarity": 3,
      "tags": [
        "KillerBlind"
      ],
      "category": 3
    },
    {
      "id": "utility_flashlight",
      "name": "Utility Flashlight",
      "rarity": 4,
      "tags": [
        "KillerBlind"
      ],
      "category": 3
    },
    {
      "id": "will_o_wisp",
      "name": "Will O' Wisp",
      "rarity": 8,
      "tags": [
        "halloweenEvent",
        "KillerBlind"
      ],
      "category": 3
    },
    {
      "id": "apprentice_s_fog_vial",
      "name": "Apprentice's Fog Vial",
      "rarity": 1,
      "patch": "9.5.0",
      "tags": [
        "Auras",
        "Occlusion",
        "ScratchMarks",
        "Stealth"
      ],
      "mechanics": {
        "charges": "4 Charges",
        "opacity": "33 %",
        "radius": "8 metres",
        "expansion": "2 seconds",
        "duration": "8 seconds",
        "rechargeTime": "70 seconds"
      },
      "category": 8
    },
    {
      "id": "artisan_s_fog_vial",
      "name": "Artisan's Fog Vial",
      "rarity": 2,
      "patch": "9.5.0",
      "tags": [
        "Auras",
        "Occlusion",
        "ScratchMarks",
        "Stealth"
      ],
      "mechanics": {
        "charges": "4 Charges",
        "opacity": "33 %",
        "radius": "8 metres",
        "expansion": "1.5 seconds",
        "duration": "10 seconds",
        "rechargeTime": "65 seconds"
      },
      "category": 8
    },
    {
      "id": "vigo_s_fog_vial",
      "name": "Vigo's Fog Vial",
      "rarity": 3,
      "patch": "9.5.0",
      "tags": [
        "Auras",
        "Occlusion",
        "ScratchMarks",
        "Stealth"
      ],
      "mechanics": {
        "charges": "4 Charges",
        "opacity": "33 %",
        "radius": "8 metres",
        "expansion": "1.2 seconds",
        "duration": "12 seconds",
        "rechargeTime": "60 seconds"
      },
      "category": 8
    },
    {
      "id": "annotated_map",
      "name": "Annotated Map",
      "rarity": 3,
      "patch": "9.1.0",
      "tags": [
        "Auras",
        "Tracking"
      ],
      "mechanics": {
        "charges": "6 Charges",
        "cost": "-1 Charge",
        "aura_Vaultables": [
          "40 metres",
          "14 seconds"
        ],
        "aura_BOL": [
          "32 metres",
          "16 seconds"
        ]
      },
      "category": 5
    },
    {
      "id": "bloodsense_map",
      "name": "Bloodsense Map",
      "rarity": 8,
      "patch": "9.1.0",
      "tags": [
        "Auras",
        "Tracking"
      ],
      "mechanics": {
        "charges": "8 Charges",
        "cost": "-1 Charge",
        "aura_Vaultables": [
          "48 metres",
          "14 seconds"
        ],
        "aura_BOL": [
          "32 metres",
          "16 seconds"
        ]
      },
      "category": 5
    },
    {
      "id": "cryptic_map",
      "name": "Cryptic Map",
      "rarity": 1,
      "patch": "9.1.0",
      "tags": [
        "Auras",
        "Tracking"
      ],
      "mechanics": {
        "charges": "4 Charges",
        "cost": "-1 Charge",
        "aura_Vaultables": [
          "24 metres",
          "10 seconds"
        ],
        "aura_BOL": [
          "32 metres",
          "16 seconds"
        ]
      },
      "category": 5
    },
    {
      "id": "scribbled_map",
      "name": "Scribbled Map",
      "rarity": 2,
      "patch": "9.1.0",
      "tags": [
        "Auras",
        "Tracking"
      ],
      "mechanics": {
        "charges": "5 Charges",
        "cost": "-1 Charge",
        "aura_Vaultables": [
          "32 metres",
          "12 seconds"
        ],
        "aura_BOL": [
          "32 metres",
          "16 seconds"
        ]
      },
      "category": 5
    },
    {
      "id": "anniversary_med_kit",
      "name": "Anniversary Med-Kit",
      "rarity": 8,
      "patch": "6.7.0",
      "tags": [
        "anniversaryEvent",
        "HealingProficiency",
        "SelfHeal"
      ],
      "category": 6
    },
    {
      "id": "banquet_med_kit",
      "name": "Banquet Med-Kit",
      "rarity": 8,
      "patch": "10.0.1",
      "tags": [
        "anniversaryEvent",
        "HealingProficiency",
        "SelfHeal"
      ],
      "category": 6
    },
    {
      "id": "all_hallows_eve_lunchbox",
      "name": "All Hallows' Eve Lunchbox",
      "rarity": 8,
      "patch": "6.7.0",
      "tags": [
        "halloweenEvent",
        "HealingProficiency",
        "SelfHeal"
      ],
      "category": 6
    },
    {
      "id": "camping_aid_kit",
      "name": "Camping Aid Kit",
      "rarity": 1,
      "patch": "6.7.0",
      "tags": [
        "HealingProficiency",
        "SelfHeal"
      ],
      "category": 6
    },
    {
      "id": "emergency_med_kit",
      "name": "Emergency Med-Kit",
      "rarity": 3,
      "patch": "6.7.0",
      "tags": [
        "HealingProficiency",
        "SelfHeal"
      ],
      "category": 6
    },
    {
      "id": "first_aid_kit",
      "name": "First Aid Kit",
      "rarity": 2,
      "patch": "6.7.0",
      "tags": [
        "HealingProficiency",
        "SelfHeal"
      ],
      "category": 6
    },
    {
      "id": "masquerade_med_kit",
      "name": "Masquerade Med-Kit",
      "rarity": 8,
      "patch": "6.7.0",
      "tags": [
        "anniversaryEvent",
        "HealingProficiency",
        "SelfHeal"
      ],
      "category": 6
    },
    {
      "id": "ranger_med_kit",
      "name": "Ranger Med-Kit",
      "rarity": 4,
      "patch": "6.7.0",
      "tags": [
        "HealingProficiency",
        "SelfHeal"
      ],
      "category": 6
    },
    {
      "id": "anniversary_toolbox",
      "name": "Anniversary Toolbox",
      "rarity": 8,
      "patch": "8.0.0",
      "tags": [
        "anniversaryEvent",
        "Generators",
        "SkillCheckProbability",
        "RepairingProficiency",
        "SabotageProficiency"
      ],
      "category": 7
    },
    {
      "id": "banquet_toolbox",
      "name": "Banquet Toolbox",
      "rarity": 8,
      "patch": "10.0.1",
      "tags": [
        "anniversaryEvent",
        "Generators",
        "SkillCheckProbability",
        "RepairingProficiency",
        "SabotageProficiency"
      ],
      "category": 7
    },
    {
      "id": "alex_s_toolbox",
      "name": "Alex's Toolbox",
      "rarity": 4,
      "patch": "8.0.0",
      "tags": [
        "Generators",
        "RepairingProficiency",
        "SabotageProficiency",
        "SkillCheckProbability"
      ],
      "category": 7
    },
    {
      "id": "commodious_toolbox",
      "name": "Commodious Toolbox",
      "rarity": 3,
      "patch": "8.0.0",
      "tags": [
        "Generators",
        "RepairingProficiency",
        "SkillCheckProbability",
        "SabotageProficiency"
      ],
      "category": 7
    },
    {
      "id": "festive_toolbox",
      "name": "Festive Toolbox",
      "rarity": 8,
      "patch": "8.0.0",
      "tags": [
        "Generators",
        "springEvent",
        "RepairingProficiency",
        "SkillCheckProbability",
        "SabotageProficiency"
      ],
      "category": 7
    },
    {
      "id": "engineer_s_toolbox",
      "name": "Engineer's Toolbox",
      "rarity": 4,
      "patch": "8.0.0",
      "tags": [
        "Generators",
        "RepairingProficiency",
        "SabotageProficiency",
        "SkillCheckProbability"
      ],
      "category": 7
    },
    {
      "id": "masquerade_toolbox",
      "name": "Masquerade Toolbox",
      "rarity": 8,
      "patch": "8.0.0",
      "tags": [
        "anniversaryEvent",
        "Generators",
        "RepairingProficiency",
        "SkillCheckProbability",
        "SabotageProficiency"
      ],
      "category": 7
    },
    {
      "id": "mechanic_s_toolbox",
      "name": "Mechanic's Toolbox",
      "rarity": 3,
      "patch": "8.0.0",
      "tags": [
        "Generators",
        "RepairingProficiency",
        "SabotageProficiency",
        "SkillCheckProbability"
      ],
      "category": 7
    },
    {
      "id": "toolbox",
      "name": "Toolbox",
      "rarity": 2,
      "patch": "8.0.0",
      "tags": [
        "Generators",
        "RepairingProficiency",
        "SabotageProficiency",
        "SkillCheckProbability"
      ],
      "category": 7
    },
    {
      "id": "worn_out_tools",
      "name": "Worn-Out Tools",
      "rarity": 1,
      "tags": [
        "Generators",
        "RepairingProficiency",
        "SkillCheckDifficulty",
        "SkillCheckProbability"
      ],
      "category": 7
    }
  ],
  "survivorAddons": [
    {
      "id": "blood_amber",
      "name": "Blood Amber",
      "rarity": 5,
      "patch": "9.1.0",
      "tags": [
        "Auras",
        "Charges",
        "ExtendedAbility",
        "EffectDuration"
      ],
      "mechanics": {
        "charges": "-2",
        "aura": "-6 seconds"
      },
      "itemsCategory": 1
    },
    {
      "id": "braided_bauble",
      "name": "Braided Bauble",
      "rarity": 3,
      "patch": "9.1.0",
      "tags": [
        "Auras",
        "EffectDuration"
      ],
      "mechanics": {
        "effect": "+2 seconds"
      },
      "itemsCategory": 1
    },
    {
      "id": "friendship_charm",
      "name": "Friendship Charm",
      "rarity": 1,
      "patch": "9.1.0",
      "tags": [
        "Charges"
      ],
      "mechanics": {
        "charges": "+1"
      },
      "itemsCategory": 1
    },
    {
      "id": "shrill_whistle",
      "name": "Shrill Whistle",
      "rarity": 2,
      "patch": "9.1.0",
      "tags": [
        "ActionTime"
      ],
      "mechanics": {
        "effect": "-35 %"
      },
      "itemsCategory": 1
    },
    {
      "id": "unique_wedding_ring",
      "name": "Unique Wedding Ring",
      "rarity": 4,
      "patch": "9.1.0",
      "tags": [
        "Auras",
        "ExtendedAbility",
        "Obsession"
      ],
      "itemsCategory": 1
    },
    {
      "id": "battery",
      "name": "Battery",
      "rarity": 1,
      "tags": [
        "Charges"
      ],
      "itemsCategory": 3
    },
    {
      "id": "broken_bulb",
      "name": "Broken Bulb",
      "rarity": 8,
      "tags": [
        "Beam"
      ],
      "mechanics": {
        "halloweenEvent": true,
        "notAvailable": true
      },
      "itemsCategory": 3
    },
    {
      "id": "focus_lens",
      "name": "Focus Lens",
      "rarity": 2,
      "tags": [
        "Beam",
        "KillerBlind"
      ],
      "itemsCategory": 3
    },
    {
      "id": "heavy_duty_battery",
      "name": "Heavy Duty Battery",
      "rarity": 2,
      "tags": [
        "Charges"
      ],
      "itemsCategory": 3
    },
    {
      "id": "high_end_sapphire_lens",
      "name": "High-End Sapphire Lens",
      "rarity": 4,
      "tags": [
        "Beam",
        "KillerBlind"
      ],
      "itemsCategory": 3
    },
    {
      "id": "intense_halogen",
      "name": "Intense Halogen",
      "rarity": 3,
      "tags": [
        "Beam",
        "KillerBlind"
      ],
      "itemsCategory": 3
    },
    {
      "id": "leather_grip",
      "name": "Leather Grip",
      "rarity": 1,
      "tags": [
        "Accuracy"
      ],
      "itemsCategory": 3
    },
    {
      "id": "long_life_battery",
      "name": "Long Life Battery",
      "rarity": 3,
      "tags": [
        "Charges"
      ],
      "itemsCategory": 3
    },
    {
      "id": "low_amp_filament",
      "name": "Low Amp Filament",
      "rarity": 2,
      "tags": [
        "Charges",
        "Efficiency"
      ],
      "itemsCategory": 3
    },
    {
      "id": "odd_bulb",
      "name": "Odd Bulb",
      "rarity": 5,
      "tags": [
        "Beam",
        "Efficiency",
        "KillerBlind"
      ],
      "itemsCategory": 3
    },
    {
      "id": "power_bulb",
      "name": "Power Bulb",
      "rarity": 1,
      "tags": [
        "Beam",
        "KillerBlind"
      ],
      "itemsCategory": 3
    },
    {
      "id": "rubber_grip",
      "name": "Rubber Grip",
      "rarity": 2,
      "tags": [
        "Accuracy"
      ],
      "itemsCategory": 3
    },
    {
      "id": "tir_optic",
      "name": "TIR Optic",
      "rarity": 2,
      "tags": [
        "Brightness",
        "KillerBlind"
      ],
      "itemsCategory": 3
    },
    {
      "id": "wide_lens",
      "name": "Wide Lens",
      "rarity": 1,
      "tags": [
        "Beam"
      ],
      "itemsCategory": 3
    },
    {
      "id": "battered_tape",
      "name": "Battered Tape",
      "rarity": 3,
      "patch": "9.1.0",
      "tags": [
        "Auras",
        "EffectRange"
      ],
      "mechanics": {
        "effect": "+8 metres"
      },
      "itemsCategory": 5
    },
    {
      "id": "crimson_stamp",
      "name": "Crimson Stamp",
      "rarity": 5,
      "patch": "9.1.0",
      "tags": [
        "Auras",
        "Charges",
        "EffectDuration"
      ],
      "mechanics": {
        "aura": "8 metres",
        "charges": "-2",
        "duration": "-10 seconds"
      },
      "itemsCategory": 5
    },
    {
      "id": "glowing_ink",
      "name": "Glowing Ink",
      "rarity": 1,
      "patch": "9.1.0",
      "tags": [
        "Auras",
        "EffectDuration"
      ],
      "mechanics": {
        "effect": "+2 seconds"
      },
      "itemsCategory": 5
    },
    {
      "id": "gnarled_compass",
      "name": "Gnarled Compass",
      "rarity": 2,
      "patch": "9.1.0",
      "tags": [
        "Charges"
      ],
      "mechanics": {
        "effect": "+2"
      },
      "itemsCategory": 5
    },
    {
      "id": "sharpened_flint",
      "name": "Sharpened Flint",
      "rarity": 4,
      "patch": "9.1.0",
      "tags": [
        "Auras",
        "Totems",
        "Tracking"
      ],
      "itemsCategory": 5
    },
    {
      "id": "abdominal_dressing",
      "name": "Abdominal Dressing",
      "rarity": 4,
      "tags": [
        "ActionSpeed",
        "Healing",
        "HealingProficiency"
      ],
      "itemsCategory": 6
    },
    {
      "id": "anti_exhaustion_syringe",
      "name": "Anti-Exhaustion Syringe",
      "rarity": 5,
      "patch": "9.3.0",
      "tags": [
        "Exhaustion",
        "Healing"
      ],
      "itemsCategory": 6
    },
    {
      "id": "bandages",
      "name": "Bandages",
      "rarity": 1,
      "tags": [
        "Charges"
      ],
      "itemsCategory": 6
    },
    {
      "id": "butterfly_tape",
      "name": "Butterfly Tape",
      "rarity": 1,
      "tags": [
        "ActionSpeed",
        "Healing",
        "HealingProficiency"
      ],
      "itemsCategory": 6
    },
    {
      "id": "gauze_roll",
      "name": "Gauze Roll",
      "rarity": 3,
      "tags": [
        "Charges"
      ],
      "itemsCategory": 6
    },
    {
      "id": "gel_dressings",
      "name": "Gel Dressings",
      "rarity": 5,
      "tags": [
        "Charges"
      ],
      "itemsCategory": 6
    },
    {
      "id": "medical_scissors",
      "name": "Medical Scissors",
      "rarity": 2,
      "tags": [
        "ActionSpeed",
        "Healing",
        "HealingProficiency"
      ],
      "itemsCategory": 6
    },
    {
      "id": "needle_thread",
      "name": "Needle & Thread",
      "rarity": 2,
      "tags": [
        "Healing",
        "HealingProficiency",
        "SkillCheckProbability",
        "SkillChecks"
      ],
      "itemsCategory": 6
    },
    {
      "id": "refined_serum",
      "name": "Refined Serum",
      "rarity": 8,
      "tags": [
        "Haste",
        "Healing",
        "MovementSpeed"
      ],
      "mechanics": {
        "notAvailable": true
      },
      "itemsCategory": 6
    },
    {
      "id": "rubber_gloves",
      "name": "Rubber Gloves",
      "rarity": 1,
      "tags": [
        "Healing",
        "SkillChecks"
      ],
      "itemsCategory": 6
    },
    {
      "id": "self_adherent_wrap",
      "name": "Self Adherent Wrap",
      "rarity": 2,
      "tags": [
        "ActionSpeed",
        "Charges",
        "Healing",
        "HealingProficiency"
      ],
      "itemsCategory": 6
    },
    {
      "id": "sponge",
      "name": "Sponge",
      "rarity": 2,
      "tags": [
        "Healing",
        "SkillChecks"
      ],
      "itemsCategory": 6
    },
    {
      "id": "styptic_agent",
      "name": "Styptic Agent",
      "rarity": 4,
      "patch": "9.3.0",
      "tags": [
        "Healing",
        "HealingProficiency"
      ],
      "mechanics": {
        "bonus": "+15 %"
      },
      "itemsCategory": 6
    },
    {
      "id": "surgical_suture",
      "name": "Surgical Suture",
      "rarity": 3,
      "tags": [
        "Healing",
        "HealingProficiency",
        "SkillCheckProbability",
        "SkillChecks"
      ],
      "itemsCategory": 6
    },
    {
      "id": "brand_new_part",
      "name": "Brand New Part",
      "rarity": 5,
      "patch": "7.1.0",
      "tags": [
        "Generators",
        "Repairing",
        "SkillChecks",
        "RepairRequirement"
      ],
      "mechanics": {
        "effect": "-10 Charges"
      },
      "itemsCategory": 7
    },
    {
      "id": "clean_rag",
      "name": "Clean Rag",
      "rarity": 1,
      "patch": "3.6.0",
      "tags": [
        "ActionSpeed",
        "Repairing",
        "RepairingProficiency"
      ],
      "mechanics": {
        "effect": "+20 %"
      },
      "itemsCategory": 7
    },
    {
      "id": "cutting_wire",
      "name": "Cutting Wire",
      "rarity": 2,
      "patch": "8.0.0",
      "tags": [
        "ActionSpeed",
        "Sabotage",
        "SabotageProficiency"
      ],
      "mechanics": {
        "effect": "+20 %"
      },
      "itemsCategory": 7
    },
    {
      "id": "grip_wrench",
      "name": "Grip Wrench",
      "rarity": 3,
      "patch": "8.0.0",
      "tags": [
        "ActionTime",
        "Sabotage"
      ],
      "mechanics": {
        "effect": "+20 seconds"
      },
      "itemsCategory": 7
    },
    {
      "id": "hacksaw",
      "name": "Hacksaw",
      "rarity": 3,
      "patch": "8.0.0",
      "tags": [
        "ActionSpeed",
        "Sabotage",
        "SabotageProficiency"
      ],
      "mechanics": {
        "effect": "+30 %"
      },
      "itemsCategory": 7
    },
    {
      "id": "instructions",
      "name": "Instructions",
      "rarity": 1,
      "patch": "3.6.0",
      "tags": [
        "Repairing",
        "SkillChecks"
      ],
      "itemsCategory": 7
    },
    {
      "id": "protective_gloves",
      "name": "Protective Gloves",
      "rarity": 2,
      "patch": "3.6.0",
      "tags": [
        "LoudNoiseNotifications",
        "Sabotage"
      ],
      "itemsCategory": 7
    },
    {
      "id": "scraps",
      "name": "Scraps",
      "rarity": 1,
      "patch": "3.6.0",
      "tags": [
        "Charges"
      ],
      "mechanics": {
        "effect": "+8 Charges"
      },
      "itemsCategory": 7
    },
    {
      "id": "socket_swivels",
      "name": "Socket Swivels",
      "rarity": 2,
      "patch": "3.6.0",
      "tags": [
        "ActionSpeed",
        "RepairingProficiency"
      ],
      "mechanics": {
        "effect": "+30 %"
      },
      "itemsCategory": 7
    },
    {
      "id": "spring_clamp",
      "name": "Spring Clamp",
      "rarity": 2,
      "patch": "3.6.0",
      "tags": [
        "ActionNoise",
        "Generators",
        "Repairing"
      ],
      "mechanics": {
        "range": "-8 metres"
      },
      "itemsCategory": 7
    },
    {
      "id": "wire_spool",
      "name": "Wire Spool",
      "rarity": 2,
      "patch": "3.6.0",
      "tags": [
        "Charges"
      ],
      "mechanics": {
        "effect": "+12 Charges"
      },
      "itemsCategory": 7
    },
    {
      "id": "mushroom_formula",
      "name": "Mushroom Formula",
      "rarity": 4,
      "patch": "9.1.0",
      "tags": [
        "EffectRange"
      ],
      "mechanics": {
        "effect": "+2 metres"
      },
      "itemsCategory": 8
    },
    {
      "id": "oily_sap",
      "name": "Oily Sap",
      "rarity": 3,
      "patch": "9.1.0",
      "tags": [
        "EffectDuration"
      ],
      "mechanics": {
        "effect": "+2 seconds"
      },
      "itemsCategory": 8
    },
    {
      "id": "potent_extract",
      "name": "Potent Extract",
      "rarity": 5,
      "patch": "9.5.0",
      "tags": [
        "EffectDuration",
        "EffectStrength",
        "EffectRange"
      ],
      "mechanics": {
        "opacity": "+100 %",
        "duration": "-50 %",
        "size": "-25 %"
      },
      "itemsCategory": 8
    },
    {
      "id": "reactive_compound",
      "name": "Reactive Compound",
      "rarity": 2,
      "patch": "9.1.0",
      "tags": [
        "EffectExpansion"
      ],
      "mechanics": {
        "effect": "-1 second"
      },
      "itemsCategory": 8
    },
    {
      "id": "volcanic_stone",
      "name": "Volcanic Stone",
      "rarity": 1,
      "patch": "9.1.0",
      "tags": [
        "RechargeTime"
      ],
      "mechanics": {
        "effect": "-5 seconds"
      },
      "itemsCategory": 8
    }
  ],
  "killerAddons": [
    {
      "id": "4_coil_spring_kit",
      "name": "4-Coil Spring Kit",
      "rarity": 2,
      "tags": [
        "ActionTime"
      ],
      "character": 1
    },
    {
      "id": "bear_oil",
      "name": "Bear Oil",
      "rarity": 1,
      "tags": [
        "ActionNoise"
      ],
      "character": 1
    },
    {
      "id": "bloody_coil",
      "name": "Bloody Coil",
      "rarity": 5,
      "tags": [
        "AutoDamage"
      ],
      "character": 1
    },
    {
      "id": "coffee_grounds",
      "name": "Coffee Grounds",
      "rarity": 2,
      "tags": [
        "Haste"
      ],
      "character": 1
    },
    {
      "id": "fastening_tools",
      "name": "Fastening Tools",
      "rarity": 3,
      "tags": [
        "ActionSpeed",
        "ActionTime"
      ],
      "character": 1
    },
    {
      "id": "honing_stone",
      "name": "Honing Stone",
      "rarity": 4,
      "tags": [
        "AutoDamage"
      ],
      "character": 1
    },
    {
      "id": "iridescent_stone",
      "name": "Iridescent Stone",
      "rarity": 5,
      "tags": [
        "AutoSetting"
      ],
      "character": 1
    },
    {
      "id": "lengthened_jaws",
      "name": "Lengthened Jaws",
      "rarity": 2,
      "tags": [
        "DeepWound"
      ],
      "character": 1
    },
    {
      "id": "makeshift_wrap",
      "name": "Makeshift Wrap",
      "rarity": 1,
      "tags": [
        "ExtendedAbility"
      ],
      "character": 1
    },
    {
      "id": "oily_coil",
      "name": "Oily Coil",
      "rarity": 4,
      "tags": [
        "Auras"
      ],
      "character": 1
    },
    {
      "id": "padded_jaws",
      "name": "Padded Jaws",
      "rarity": 1,
      "patch": "2.1.0",
      "tags": [
        "Bloodpoints"
      ],
      "mechanics": {
        "bonus": "+100 %"
      },
      "character": 1
    },
    {
      "id": "rusted_jaws",
      "name": "Rusted Jaws",
      "rarity": 3,
      "patch": "7.6.0",
      "tags": [
        "Mangled"
      ],
      "character": 1
    },
    {
      "id": "secondary_coil",
      "name": "Secondary Coil",
      "rarity": 3,
      "tags": [
        "ActionTime"
      ],
      "character": 1
    },
    {
      "id": "serrated_jaws",
      "name": "Serrated Jaws",
      "rarity": 2,
      "tags": [
        "Haemorrhage"
      ],
      "character": 1
    },
    {
      "id": "tar_bottle",
      "name": "Tar Bottle",
      "rarity": 3,
      "tags": [
        "Colour"
      ],
      "character": 1
    },
    {
      "id": "tension_spring",
      "name": "Tension Spring",
      "rarity": 4,
      "tags": [
        "AutoResetting"
      ],
      "character": 1
    },
    {
      "id": "trapper_bag",
      "name": "Trapper Bag",
      "rarity": 3,
      "tags": [
        "PowerCapacity"
      ],
      "character": 1
    },
    {
      "id": "trapper_gloves",
      "name": "Trapper Gloves",
      "rarity": 1,
      "tags": [
        "ActionSpeed"
      ],
      "character": 1
    },
    {
      "id": "trapper_sack",
      "name": "Trapper Sack",
      "rarity": 4,
      "tags": [
        "PowerCapacity"
      ],
      "character": 1
    },
    {
      "id": "wax_brick",
      "name": "Wax Brick",
      "rarity": 2,
      "tags": [
        "ActionTime"
      ],
      "character": 1
    },
    {
      "id": "all_seeing_blood",
      "name": "\"All Seeing\" - Blood",
      "rarity": 4,
      "patch": "5.3.0",
      "tags": [
        "Auras"
      ],
      "mechanics": {
        "range": "8 metres"
      },
      "character": 2
    },
    {
      "id": "all_seeing_spirit",
      "name": "\"All Seeing\" - Spirit",
      "rarity": 5,
      "patch": "2.2.0",
      "tags": [
        "Auras",
        "ExtendedAbility",
        "Generators"
      ],
      "character": 2
    },
    {
      "id": "blind_warrior_mud",
      "name": "\"Blind Warrior\" - Mud",
      "rarity": 2,
      "patch": "2.2.0",
      "tags": [
        "Blindness"
      ],
      "mechanics": {
        "blindness": "60 seconds"
      },
      "character": 2
    },
    {
      "id": "blind_warrior_white",
      "name": "\"Blind Warrior\" - White",
      "rarity": 3,
      "patch": "7.6.0",
      "tags": [
        "Mangled",
        "Haemorrhage"
      ],
      "mechanics": {
        "haemorrhage": "70 seconds",
        "mangled": "70 seconds",
        "duration": "70 seconds"
      },
      "character": 2
    },
    {
      "id": "blink_mud",
      "name": "\"Blink\" - Mud",
      "rarity": 2,
      "tags": [
        "ActionSpeed"
      ],
      "character": 2
    },
    {
      "id": "blink_white",
      "name": "\"Blink\" - White",
      "rarity": 3,
      "tags": [
        "ActionSpeed"
      ],
      "character": 2
    },
    {
      "id": "bone_clapper",
      "name": "Bone Clapper",
      "rarity": 2,
      "tags": [
        "ActionNoise"
      ],
      "character": 2
    },
    {
      "id": "coxcombed_clapper",
      "name": "Coxcombed Clapper",
      "rarity": 5,
      "tags": [
        "ActionNoise"
      ],
      "character": 2
    },
    {
      "id": "shadow_dance_blood",
      "name": "\"Shadow Dance\" - Blood",
      "rarity": 4,
      "tags": [
        "ActionSpeed",
        "BreakableWalls",
        "Generators",
        "Pallets",
        "Windows"
      ],
      "character": 2
    },
    {
      "id": "shadow_dance_white",
      "name": "\"Shadow Dance\" - White",
      "rarity": 3,
      "tags": [
        "ActionSpeed",
        "BreakableWalls",
        "Generators",
        "Pallets",
        "Windows"
      ],
      "character": 2
    },
    {
      "id": "swift_hunt_blood",
      "name": "\"Swift Hunt\" - Blood",
      "rarity": 4,
      "tags": [
        "ActionSpeed"
      ],
      "character": 2
    },
    {
      "id": "swift_hunt_mud",
      "name": "\"Swift Hunt\" - Mud",
      "rarity": 2,
      "tags": [
        "ActionSpeed"
      ],
      "character": 2
    },
    {
      "id": "swift_hunt_white",
      "name": "\"Swift Hunt\" - White",
      "rarity": 3,
      "tags": [
        "ActionSpeed"
      ],
      "character": 2
    },
    {
      "id": "the_beast_soot",
      "name": "\"The Beast\" - Soot",
      "rarity": 1,
      "tags": [
        "Bloodpoints",
        "TerrorRadius"
      ],
      "character": 2
    },
    {
      "id": "the_ghost_soot",
      "name": "\"The Ghost\" - Soot",
      "rarity": 1,
      "tags": [
        "RedStain",
        "TerrorRadius"
      ],
      "character": 2
    },
    {
      "id": "the_hound_soot",
      "name": "\"The Hound\" - Soot",
      "rarity": 1,
      "tags": [
        "PoolsOfBlood"
      ],
      "character": 2
    },
    {
      "id": "the_serpent_soot",
      "name": "\"The Serpent\" - Soot",
      "rarity": 1,
      "tags": [
        "BreakableWalls",
        "Generators",
        "Pallets"
      ],
      "character": 2
    },
    {
      "id": "windstorm_blood",
      "name": "\"Windstorm\" - Blood",
      "rarity": 4,
      "patch": "4.6.0",
      "tags": [
        "MovementSpeed"
      ],
      "mechanics": {
        "effect": "+9 %"
      },
      "character": 2
    },
    {
      "id": "windstorm_mud",
      "name": "\"Windstorm\" - Mud",
      "rarity": 2,
      "patch": "4.6.0",
      "tags": [
        "MovementSpeed"
      ],
      "mechanics": {
        "effect": "+5 %"
      },
      "character": 2
    },
    {
      "id": "windstorm_white",
      "name": "\"Windstorm\" - White",
      "rarity": 3,
      "patch": "4.6.0",
      "tags": [
        "MovementSpeed"
      ],
      "mechanics": {
        "effect": "+7 %"
      },
      "character": 2
    },
    {
      "id": "apex_muffler",
      "name": "Apex Muffler",
      "rarity": 4,
      "patch": "7.5.0",
      "tags": [
        "ActionNoise",
        "TerrorRadius"
      ],
      "character": 3
    },
    {
      "id": "begrimed_chains_chainsaw",
      "name": "Begrimed Chains (Chainsaw)",
      "rarity": 3,
      "patch": "7.6.0",
      "tags": [
        "Haemorrhage",
        "Mangled"
      ],
      "mechanics": {
        "multiName": true
      },
      "character": 3
    },
    {
      "id": "the_thompsons_mix",
      "name": "The Thompsons' Mix",
      "rarity": 3,
      "patch": "7.5.2",
      "tags": [
        "PowerCooldown",
        "Overdrive"
      ],
      "character": 3
    },
    {
      "id": "dad_s_boots",
      "name": "Dad's Boots",
      "rarity": 3,
      "patch": "8.3.0",
      "tags": [
        "TurnRate"
      ],
      "mechanics": {
        "effect": "+20 %"
      },
      "character": 3
    },
    {
      "id": "clogged_intake",
      "name": "Clogged Intake",
      "rarity": 2,
      "patch": "7.5.0",
      "tags": [
        "Overdrive",
        "PowerDuration"
      ],
      "character": 3
    },
    {
      "id": "iridescent_engravings",
      "name": "Iridescent Engravings",
      "rarity": 5,
      "patch": "7.5.0",
      "tags": [
        "ActionTime",
        "MovementSpeed"
      ],
      "character": 3
    },
    {
      "id": "counterweight",
      "name": "Counterweight",
      "rarity": 1,
      "patch": "7.5.0",
      "tags": [
        "TurnRate"
      ],
      "character": 3
    },
    {
      "id": "filthy_slippers",
      "name": "Filthy Slippers",
      "rarity": 4,
      "patch": "7.5.0",
      "tags": [
        "Undetectable"
      ],
      "character": 3
    },
    {
      "id": "greased_throttle",
      "name": "Greased Throttle",
      "rarity": 2,
      "patch": "7.5.2",
      "tags": [
        "PowerCooldown",
        "Overdrive"
      ],
      "character": 3
    },
    {
      "id": "ragged_engine",
      "name": "Ragged Engine",
      "rarity": 3,
      "patch": "7.5.0",
      "tags": [
        "ActionSpeed",
        "Overdrive"
      ],
      "character": 3
    },
    {
      "id": "lopro_chains",
      "name": "LoPro Chains",
      "rarity": 4,
      "patch": "8.3.0",
      "tags": [
        "DamageReduction",
        "DeepWound",
        "ExtendedAbility"
      ],
      "mechanics": {
        "effect": "5 seconds"
      },
      "character": 3
    },
    {
      "id": "low_kickback_chains",
      "name": "Low Kickback Chains",
      "rarity": 3,
      "patch": "7.5.0",
      "tags": [
        "PowerCooldown"
      ],
      "character": 3
    },
    {
      "id": "discarded_air_filter",
      "name": "Discarded Air Filter",
      "rarity": 1,
      "patch": "8.3.0",
      "tags": [
        "DecayDelay",
        "Overdrive"
      ],
      "mechanics": {
        "effect": "+20 %"
      },
      "character": 3
    },
    {
      "id": "off_brand_motor_oil",
      "name": "Off-Brand Motor Oil",
      "rarity": 2,
      "patch": "7.5.0",
      "tags": [
        "Overdrive"
      ],
      "character": 3
    },
    {
      "id": "high_speed_idler_screw",
      "name": "High-Speed Idler Screw",
      "rarity": 2,
      "patch": "8.3.0",
      "tags": [
        "DecayDelay",
        "Overdrive"
      ],
      "mechanics": {
        "effect": "+30 %"
      },
      "character": 3
    },
    {
      "id": "thermal_casing",
      "name": "Thermal Casing",
      "rarity": 2,
      "patch": "7.5.0",
      "tags": [
        "ActionSpeed",
        "Overdrive"
      ],
      "character": 3
    },
    {
      "id": "spiked_boots",
      "name": "Spiked Boots",
      "rarity": 4,
      "patch": "8.3.0",
      "tags": [
        "TurnRate"
      ],
      "mechanics": {
        "effect": "+30 %"
      },
      "character": 3
    },
    {
      "id": "steel_toe_boots",
      "name": "Steel Toe Boots",
      "rarity": 1,
      "patch": "7.5.0",
      "tags": [
        "PowerCooldown"
      ],
      "character": 3
    },
    {
      "id": "tuned_carburettor",
      "name": "Tuned Carburettor",
      "rarity": 5,
      "patch": "7.5.0",
      "tags": [
        "ActionTime",
        "MovementSpeed"
      ],
      "mechanics": {
        "charge": "+20 %",
        "speed": "4.4 m/s"
      },
      "character": 3
    },
    {
      "id": "speed_limiter",
      "name": "Speed Limiter",
      "rarity": 1,
      "tags": [
        "Bloodpoints",
        "DamageReduction",
        "Deviousness"
      ],
      "character": 9
    },
    {
      "id": "cracked_primer_bulb",
      "name": "Cracked Primer Bulb",
      "rarity": 1,
      "patch": "7.5.0",
      "tags": [
        "DamageReduction",
        "Overdrive"
      ],
      "character": 3
    },
    {
      "id": "anxious_gasp",
      "name": "Anxious Gasp",
      "rarity": 3,
      "tags": [
        "Bloodpoints",
        "LoudNoiseNotifications",
        "Screams"
      ],
      "character": 4
    },
    {
      "id": "ataxic_respiration",
      "name": "Ataxic Respiration",
      "rarity": 3,
      "tags": [
        "PowerCooldown"
      ],
      "character": 4
    },
    {
      "id": "bad_man_keepsake",
      "name": "Bad Man Keepsake",
      "rarity": 2,
      "tags": [
        "Auras",
        "Healing"
      ],
      "character": 4
    },
    {
      "id": "campbell_s_last_breath",
      "name": "Campbell's Last Breath",
      "rarity": 4,
      "tags": [
        "AutoBlink"
      ],
      "character": 4
    },
    {
      "id": "catatonic_boy_s_treasure",
      "name": "Catatonic Boy's Treasure",
      "rarity": 2,
      "tags": [
        "PowerCooldown"
      ],
      "character": 4
    },
    {
      "id": "dark_cincture",
      "name": "Dark Cincture",
      "rarity": 2,
      "tags": [
        "MovementSpeed"
      ],
      "character": 4
    },
    {
      "id": "dull_bracelet",
      "name": "Dull Bracelet",
      "rarity": 2,
      "tags": [
        "Bloodpoints",
        "PowerRange"
      ],
      "character": 4
    },
    {
      "id": "fragile_wheeze",
      "name": "Fragile Wheeze",
      "rarity": 3,
      "patch": "7.6.0",
      "tags": [
        "Mangled"
      ],
      "character": 4
    },
    {
      "id": "heavy_panting",
      "name": "Heavy Panting",
      "rarity": 3,
      "patch": "9.6.0",
      "tags": [
        "AttackRange"
      ],
      "character": 4
    },
    {
      "id": "jenner_s_last_breath",
      "name": "Jenner's Last Breath",
      "rarity": 4,
      "tags": [
        "AutoBlink"
      ],
      "character": 4
    },
    {
      "id": "kavanagh_s_last_breath",
      "name": "Kavanagh's Last Breath",
      "rarity": 4,
      "tags": [
        "Blindness"
      ],
      "character": 4
    },
    {
      "id": "matchbox",
      "name": "Matchbox",
      "rarity": 5,
      "tags": [
        "MovementSpeed"
      ],
      "character": 4
    },
    {
      "id": "metal_spoon",
      "name": "Metal Spoon",
      "rarity": 1,
      "tags": [
        "GruntsOfPain"
      ],
      "character": 4
    },
    {
      "id": "plaid_flannel",
      "name": "Plaid Flannel",
      "rarity": 1,
      "tags": [
        "ExtendedAbility",
        "PowerIndicator"
      ],
      "character": 4
    },
    {
      "id": "pocket_watch_spencer_s_last_breath",
      "name": "Pocket Watch (Spencer's Last Breath)",
      "rarity": 2,
      "tags": [
        "PowerWindow"
      ],
      "mechanics": {
        "multiName": true
      },
      "character": 4
    },
    {
      "id": "spasmodic_breath",
      "name": "Spasmodic Breath",
      "rarity": 3,
      "tags": [
        "MovementSpeed",
        "PowerDeactivation"
      ],
      "character": 4
    },
    {
      "id": "torn_bookmark",
      "name": "Torn Bookmark",
      "rarity": 5,
      "tags": [
        "Tokens"
      ],
      "character": 4
    },
    {
      "id": "white_nit_comb",
      "name": "White Nit Comb",
      "rarity": 1,
      "tags": [
        "AttackRange",
        "Bloodpoints"
      ],
      "character": 4
    },
    {
      "id": "wooden_horse",
      "name": "Wooden Horse",
      "rarity": 1,
      "tags": [
        "PowerCooldown"
      ],
      "character": 4
    },
    {
      "id": "blond_hair",
      "name": "Blond Hair",
      "rarity": 1,
      "tags": [
        "PoolsOfBlood",
        "ScratchMarks"
      ],
      "mechanics": {
        "bonus": "+100 %"
      },
      "character": 5
    },
    {
      "id": "boyfriend_s_memo",
      "name": "Boyfriend's Memo",
      "rarity": 1,
      "tags": [
        "PowerRange"
      ],
      "mechanics": {
        "bonus": "+8 metres"
      },
      "character": 5
    },
    {
      "id": "dead_rabbit",
      "name": "Dead Rabbit",
      "rarity": 2,
      "tags": [
        "TerrorRadius"
      ],
      "mechanics": {
        "TR_minus": "-25 %",
        "TR_plus": "+25 %"
      },
      "character": 5
    },
    {
      "id": "fragrant_tuft_of_hair",
      "name": "Fragrant Tuft of Hair",
      "rarity": 2,
      "patch": "8.4.0",
      "tags": [
        "Exposed",
        "PowerAlternate"
      ],
      "mechanics": {
        "bonus": "+50 %"
      },
      "character": 5
    },
    {
      "id": "glass_fragment",
      "name": "Glass Fragment",
      "rarity": 2,
      "tags": [
        "MovementSpeed",
        "PowerPenalty"
      ],
      "mechanics": {
        "bonus": "+5 %",
        "penalty": "-10 %"
      },
      "character": 5
    },
    {
      "id": "hair_bow",
      "name": "Hair Bow",
      "rarity": 3,
      "tags": [
        "PowerDuration",
        "PowerEfficiency"
      ],
      "mechanics": {
        "bonus": "+20 seconds",
        "penaltyPercentage": "-20 %",
        "penaltyPoints": [
          "+2.5 SP",
          "7.5 SP"
        ]
      },
      "character": 5
    },
    {
      "id": "hair_brush",
      "name": "Hair Brush",
      "rarity": 2,
      "tags": [
        "ActionSpeed",
        "Pallets"
      ],
      "mechanics": {
        "bonus": "+50 %"
      },
      "character": 5
    },
    {
      "id": "j_myers_memorial",
      "name": "J. Myers Memorial",
      "rarity": 3,
      "tags": [
        "ActionSpeed",
        "Hooking",
        "PickingUp"
      ],
      "mechanics": {
        "effect": "+40 %"
      },
      "character": 5
    },
    {
      "id": "jewellery",
      "name": "Jewellery",
      "rarity": 2,
      "tags": [
        "PowerEfficiency"
      ],
      "mechanics": {
        "effect": "+10 %"
      },
      "character": 5
    },
    {
      "id": "jewellery_box",
      "name": "Jewellery Box",
      "rarity": 3,
      "tags": [
        "PowerEfficiency",
        "PowerPenalty"
      ],
      "mechanics": {
        "bonus": "+30 %",
        "penalty": "-16 metres"
      },
      "character": 5
    },
    {
      "id": "judith_s_journal",
      "name": "Judith's Journal",
      "rarity": 3,
      "tags": [
        "Obsession",
        "PowerEfficiency"
      ],
      "mechanics": {
        "effect": "+40 %"
      },
      "character": 5
    },
    {
      "id": "judith_s_tombstone",
      "name": "Judith's Tombstone",
      "rarity": 5,
      "patch": "8.4.0",
      "tags": [
        "PowerDuration"
      ],
      "mechanics": {
        "cap": "40 seconds"
      },
      "character": 5
    },
    {
      "id": "lock_of_hair",
      "name": "Lock of Hair",
      "rarity": 4,
      "patch": "8.4.0",
      "tags": [
        "ExtendedAbility"
      ],
      "mechanics": {
        "convertPercent": "50 %"
      },
      "character": 5
    },
    {
      "id": "memorial_flower",
      "name": "Memorial Flower",
      "rarity": 1,
      "patch": "9.2.0",
      "tags": [
        "MovementSpeed"
      ],
      "mechanics": {
        "effect": [
          "+0.2 m/s",
          "4.4 m/s"
        ]
      },
      "character": 5
    },
    {
      "id": "mirror_shard",
      "name": "Mirror Shard",
      "rarity": 3,
      "tags": [
        "PowerDuration",
        "PowerPenalty"
      ],
      "mechanics": {
        "bonus": "+0.25 seconds",
        "penalty": "-25 %"
      },
      "character": 5
    },
    {
      "id": "reflective_fragment",
      "name": "Reflective Fragment",
      "rarity": 4,
      "tags": [
        "DamageReduction",
        "PowerDuration"
      ],
      "mechanics": {
        "bonus": "+20 seconds"
      },
      "character": 5
    },
    {
      "id": "scratched_mirror",
      "name": "Scratched Mirror",
      "rarity": 5,
      "patch": "8.4.0",
      "tags": [
        "Auras",
        "Bloodpoints",
        "Brutality",
        "Deviousness",
        "MovementSpeed"
      ],
      "mechanics": {
        "range": "32 metres",
        "bonusBP": [
          "+100 %",
          "+200 %"
        ]
      },
      "character": 5
    },
    {
      "id": "tacky_earrings",
      "name": "Tacky Earrings",
      "rarity": 1,
      "patch": "9.2.0",
      "tags": [
        "MovementSpeed"
      ],
      "mechanics": {
        "effect": "+20 %"
      },
      "character": 5
    },
    {
      "id": "tombstone_piece",
      "name": "Tombstone Piece",
      "rarity": 4,
      "patch": "8.4.0",
      "tags": [
        "Undetectable"
      ],
      "mechanics": {
        "duration": "20 seconds"
      },
      "character": 5
    },
    {
      "id": "vanity_mirror",
      "name": "Vanity Mirror",
      "rarity": 4,
      "patch": "5.3.0",
      "tags": [
        "Auras"
      ],
      "mechanics": {
        "duration": "4 seconds",
        "bonusBP": [
          "+100 %",
          "+150 %"
        ]
      },
      "character": 5
    },
    {
      "id": "bloodied_mud",
      "name": "Bloodied Mud",
      "rarity": 3,
      "patch": "7.6.0",
      "tags": [
        "PowerRange",
        "Trigger"
      ],
      "character": 6
    },
    {
      "id": "bloodied_water",
      "name": "Bloodied Water",
      "rarity": 2,
      "patch": "7.6.0",
      "tags": [
        "PowerRange",
        "Trigger"
      ],
      "character": 6
    },
    {
      "id": "bog_water",
      "name": "Bog Water",
      "rarity": 1,
      "patch": "7.6.0",
      "tags": [
        "PowerRange",
        "Trigger"
      ],
      "character": 6
    },
    {
      "id": "cracked_turtle_egg",
      "name": "Cracked Turtle Egg",
      "rarity": 3,
      "patch": "7.6.1",
      "tags": [
        "PowerDuration",
        "Tripped"
      ],
      "character": 6
    },
    {
      "id": "cypress_necklet",
      "name": "Cypress Necklet",
      "rarity": 2,
      "patch": "7.6.0",
      "tags": [
        "ActionSpeed"
      ],
      "character": 6
    },
    {
      "id": "dead_fly_mud",
      "name": "Dead Fly Mud",
      "rarity": 1,
      "patch": "7.6.0",
      "tags": [
        "PowerRange",
        "Teleportation"
      ],
      "character": 6
    },
    {
      "id": "disfigured_ear",
      "name": "Disfigured Ear",
      "rarity": 4,
      "tags": [
        "Deafened"
      ],
      "mechanics": {
        "deafened": "6 seconds"
      },
      "character": 6
    },
    {
      "id": "dragonfly_wings",
      "name": "Dragonfly Wings",
      "rarity": 2,
      "patch": "7.6.0",
      "tags": [
        "PowerRange",
        "Teleportation"
      ],
      "character": 6
    },
    {
      "id": "dried_cicada",
      "name": "Dried Cicada",
      "rarity": 3,
      "patch": "7.6.0",
      "tags": [
        "PowerRange\"; \"Teleportation"
      ],
      "character": 6
    },
    {
      "id": "grandma_s_heart",
      "name": "Grandma's Heart",
      "rarity": 4,
      "tags": [
        "Illusions",
        "Stealth",
        "TerrorRadius"
      ],
      "character": 6
    },
    {
      "id": "half_eggshell",
      "name": "Half Eggshell",
      "rarity": 2,
      "patch": "7.6.1",
      "tags": [
        "PowerDuration",
        "Tripped"
      ],
      "character": 6
    },
    {
      "id": "mint_rag",
      "name": "Mint Rag",
      "rarity": 5,
      "tags": [
        "ExtendedAbility",
        "PowerCooldown"
      ],
      "character": 6
    },
    {
      "id": "powdered_eggshell",
      "name": "Powdered Eggshell",
      "rarity": 1,
      "patch": "7.6.1",
      "tags": [
        "PowerDuration",
        "Tripped"
      ],
      "character": 6
    },
    {
      "id": "pussy_willow_catkins",
      "name": "Pussy Willow Catkins",
      "rarity": 2,
      "tags": [
        "Auras"
      ],
      "character": 6
    },
    {
      "id": "rope_necklet",
      "name": "Rope Necklet",
      "rarity": 1,
      "patch": "7.6.0",
      "tags": [
        "ActionSpeed"
      ],
      "character": 6
    },
    {
      "id": "rusty_shackles",
      "name": "Rusty Shackles",
      "rarity": 4,
      "tags": [
        "Deception"
      ],
      "character": 6
    },
    {
      "id": "scarred_hand",
      "name": "Scarred Hand",
      "rarity": 4,
      "tags": [
        "Bloodpoints",
        "Collision",
        "Deviousness",
        "ExtendedAbility",
        "PowerDeactivation"
      ],
      "character": 6
    },
    {
      "id": "swamp_orchid_necklet",
      "name": "Swamp Orchid Necklet",
      "rarity": 3,
      "patch": "7.6.0",
      "tags": [
        "ActionSpeed"
      ],
      "character": 6
    },
    {
      "id": "waterlogged_shoe",
      "name": "Waterlogged Shoe",
      "rarity": 5,
      "tags": [
        "Hindered",
        "MovementSpeed",
        "PowerDeactivation"
      ],
      "character": 6
    },
    {
      "id": "willow_wreath",
      "name": "Willow Wreath",
      "rarity": 3,
      "tags": [
        "Auras"
      ],
      "character": 6
    },
    {
      "id": "calm_class_i",
      "name": "\"Calm\" - Class I",
      "rarity": 1,
      "tags": [
        "Illusions",
        "TerrorRadius"
      ],
      "character": 7
    },
    {
      "id": "calm_class_ii",
      "name": "\"Calm\" - Class II",
      "rarity": 2,
      "tags": [
        "Illusions",
        "TerrorRadius"
      ],
      "character": 7
    },
    {
      "id": "discipline_class_ii",
      "name": "\"Discipline\" - Class II",
      "rarity": 2,
      "tags": [
        "Illusions",
        "RedStain",
        "TerrorRadius"
      ],
      "character": 7
    },
    {
      "id": "discipline_class_iii",
      "name": "\"Discipline\" - Class III",
      "rarity": 3,
      "patch": "7.6.0",
      "tags": [
        "Illusions",
        "RedStain",
        "TerrorRadius"
      ],
      "character": 7
    },
    {
      "id": "high_stimulus_electrode",
      "name": "High Stimulus Electrode",
      "rarity": 3,
      "tags": [
        "PowerRange"
      ],
      "character": 7
    },
    {
      "id": "interview_tape",
      "name": "Interview Tape",
      "rarity": 3,
      "tags": [
        "PowerRange"
      ],
      "character": 7
    },
    {
      "id": "iridescent_king",
      "name": "Iridescent King",
      "rarity": 5,
      "tags": [
        "EffectDuration",
        "Illusions",
        "Pallets",
        "RedStain",
        "TerrorRadius"
      ],
      "character": 7
    },
    {
      "id": "iridescent_queen",
      "name": "Iridescent Queen",
      "rarity": 5,
      "tags": [
        "ExtendedAbility"
      ],
      "character": 7
    },
    {
      "id": "maple_knight",
      "name": "Maple Knight",
      "rarity": 1,
      "tags": [
        "ExtendedAbility",
        "PowerIndicator"
      ],
      "character": 7
    },
    {
      "id": "mouldy_electrode",
      "name": "Mouldy Electrode",
      "rarity": 1,
      "tags": [
        "PowerRange"
      ],
      "character": 7
    },
    {
      "id": "order_class_i",
      "name": "\"Order\" - Class I",
      "rarity": 1,
      "tags": [
        "Illusions",
        "Pallets"
      ],
      "character": 7
    },
    {
      "id": "order_class_ii",
      "name": "\"Order\" - Class II",
      "rarity": 2,
      "patch": "8.2.0",
      "tags": [
        "Illusions",
        "Pallets"
      ],
      "character": 7
    },
    {
      "id": "polished_electrode",
      "name": "Polished Electrode",
      "rarity": 2,
      "tags": [
        "PowerRange"
      ],
      "character": 7
    },
    {
      "id": "restraint_class_ii",
      "name": "\"Restraint\" - Class II",
      "rarity": 2,
      "tags": [
        "EffectDuration",
        "Illusions"
      ],
      "character": 7
    },
    {
      "id": "restraint_class_iii",
      "name": "\"Restraint\" - Class III",
      "rarity": 3,
      "tags": [
        "EffectDuration",
        "Illusions"
      ],
      "character": 7
    },
    {
      "id": "scrapped_tape",
      "name": "Scrapped Tape",
      "rarity": 3,
      "tags": [
        "PowerRange"
      ],
      "character": 7
    },
    {
      "id": "amanita_toxin",
      "name": "Amanita Toxin",
      "rarity": 1,
      "tags": [
        "Blindness"
      ],
      "character": 8
    },
    {
      "id": "bandaged_haft",
      "name": "Bandaged Haft",
      "rarity": 1,
      "tags": [
        "ThrowCooldown"
      ],
      "character": 8
    },
    {
      "id": "begrimed_head",
      "name": "Begrimed Head",
      "rarity": 4,
      "patch": "7.6.0",
      "tags": [
        "Haemorrhage",
        "Mangled"
      ],
      "character": 8
    },
    {
      "id": "coarse_stone",
      "name": "Coarse Stone",
      "rarity": 1,
      "tags": [
        "GruntsOfPain"
      ],
      "character": 8
    },
    {
      "id": "deerskin_gloves",
      "name": "Deerskin Gloves",
      "rarity": 3,
      "tags": [
        "ActionTime"
      ],
      "mechanics": {
        "effect": "80 %"
      },
      "character": 8
    },
    {
      "id": "flower_babushka",
      "name": "Flower Babushka",
      "rarity": 3,
      "patch": "7.6.0",
      "tags": [
        "ActionTime"
      ],
      "mechanics": {
        "effect": "-0.1 seconds"
      },
      "character": 8
    },
    {
      "id": "glowing_concoction",
      "name": "Glowing Concoction",
      "rarity": 4,
      "tags": [
        "Auras"
      ],
      "character": 8
    },
    {
      "id": "infantry_belt",
      "name": "Infantry Belt",
      "rarity": 4,
      "patch": "7.6.2",
      "tags": [
        "Haste"
      ],
      "character": 8
    },
    {
      "id": "iridescent_head",
      "name": "Iridescent Head",
      "rarity": 5,
      "tags": [
        "AutoDamage",
        "PowerCapacity"
      ],
      "character": 8
    },
    {
      "id": "leather_loop",
      "name": "Leather Loop",
      "rarity": 2,
      "patch": "7.6.2",
      "tags": [
        "Haste"
      ],
      "character": 8
    },
    {
      "id": "manna_grass_braid",
      "name": "Manna Grass Braid",
      "rarity": 2,
      "tags": [
        "ActionTime"
      ],
      "character": 8
    },
    {
      "id": "oak_haft",
      "name": "Oak Haft",
      "rarity": 2,
      "tags": [
        "ThrowCooldown"
      ],
      "character": 8
    },
    {
      "id": "rose_root",
      "name": "Rose Root",
      "rarity": 3,
      "tags": [
        "ProjectileSpeed"
      ],
      "character": 8
    },
    {
      "id": "rusty_head",
      "name": "Rusty Head",
      "rarity": 3,
      "patch": "7.6.0",
      "tags": [
        "Mangled"
      ],
      "character": 8
    },
    {
      "id": "shiny_pin",
      "name": "Shiny Pin",
      "rarity": 2,
      "tags": [
        "MovementSpeed"
      ],
      "character": 8
    },
    {
      "id": "soldier_s_puttee",
      "name": "Soldier's Puttee",
      "rarity": 5,
      "tags": [
        "MovementSpeed"
      ],
      "character": 8
    },
    {
      "id": "venomous_concoction",
      "name": "Venomous Concoction",
      "rarity": 3,
      "tags": [
        "Exhausted"
      ],
      "character": 8
    },
    {
      "id": "yellowed_cloth",
      "name": "Yellowed Cloth",
      "rarity": 1,
      "tags": [
        "ProjectileSpeed"
      ],
      "character": 8
    },
    {
      "id": "weighted_head",
      "name": "Weighted Head",
      "rarity": 2,
      "tags": [
        "Incapacitated"
      ],
      "character": 8
    },
    {
      "id": "wooden_fox",
      "name": "Wooden Fox",
      "rarity": 4,
      "tags": [
        "Lockers",
        "Undetectable"
      ],
      "character": 8
    },
    {
      "id": "award_winning_chilli",
      "name": "Award-winning Chilli",
      "rarity": 4,
      "patch": "8.0.0",
      "tags": [
        "PowerDuration",
        "PowerWindow"
      ],
      "character": 9
    },
    {
      "id": "begrimed_chains_bubba_s_chainsaw",
      "name": "Begrimed Chains (Bubba's Chainsaw)",
      "rarity": 3,
      "tags": [
        "ItemDrop"
      ],
      "mechanics": {
        "multiName": true
      },
      "character": 9
    },
    {
      "id": "carburettor_tuning_guide",
      "name": "Carburettor Tuning Guide",
      "rarity": 5,
      "patch": "5.5.0",
      "tags": [
        "ExtendedAbility",
        "MovementSpeed",
        "PowerDuration",
        "Tokens"
      ],
      "mechanics": {
        "dash": "+0.5 seconds",
        "speed": "-2 %"
      },
      "character": 9
    },
    {
      "id": "chainsaw_file",
      "name": "Chainsaw File",
      "rarity": 1,
      "patch": "8.0.0",
      "tags": [
        "PowerPenalty"
      ],
      "character": 9
    },
    {
      "id": "chilli",
      "name": "Chilli",
      "rarity": 2,
      "patch": "8.0.0",
      "tags": [
        "PowerDuration",
        "PowerWindow"
      ],
      "character": 9
    },
    {
      "id": "depth_gauge_rake",
      "name": "Depth Gauge Rake",
      "rarity": 4,
      "tags": [
        "ActionSpeed",
        "MovementSpeed",
        "Tokens"
      ],
      "character": 9
    },
    {
      "id": "grisly_chains",
      "name": "Grisly Chains",
      "rarity": 3,
      "patch": "7.6.0",
      "tags": [
        "Mangled"
      ],
      "character": 9
    },
    {
      "id": "homemade_muffler",
      "name": "Homemade Muffler",
      "rarity": 2,
      "patch": "8.0.0",
      "tags": [
        "PowerPenalty"
      ],
      "character": 9
    },
    {
      "id": "iridescent_flesh",
      "name": "Iridescent Flesh",
      "rarity": 5,
      "tags": [
        "PowerPenalty",
        "PowerRecovery",
        "Tokens"
      ],
      "character": 9
    },
    {
      "id": "knife_scratches",
      "name": "Knife Scratches",
      "rarity": 2,
      "patch": "8.0.0",
      "tags": [
        "ActionTime",
        "MovementSpeed"
      ],
      "character": 9
    },
    {
      "id": "light_chassis",
      "name": "Light Chassis",
      "rarity": 4,
      "tags": [
        "Auras"
      ],
      "character": 9
    },
    {
      "id": "long_guide_bar",
      "name": "Long Guide Bar",
      "rarity": 2,
      "tags": [
        "PowerPenalty"
      ],
      "character": 9
    },
    {
      "id": "primer_bulb",
      "name": "Primer Bulb",
      "rarity": 2,
      "tags": [
        "PowerRecovery",
        "Tokens"
      ],
      "character": 9
    },
    {
      "id": "rusted_chains",
      "name": "Rusted Chains",
      "rarity": 4,
      "tags": [
        "Broken"
      ],
      "character": 9
    },
    {
      "id": "shop_lubricant",
      "name": "Shop Lubricant",
      "rarity": 3,
      "tags": [
        "Auras",
        "TerrorRadius"
      ],
      "character": 9
    },
    {
      "id": "spark_plug",
      "name": "Spark Plug",
      "rarity": 1,
      "tags": [
        "PowerRecovery",
        "Tokens"
      ],
      "character": 9
    },
    {
      "id": "the_beast_s_marks",
      "name": "The Beast's Marks",
      "rarity": 3,
      "patch": "8.0.0",
      "tags": [
        "ActionTime",
        "MovementSpeed"
      ],
      "character": 9
    },
    {
      "id": "the_grease",
      "name": "The Grease",
      "rarity": 3,
      "tags": [
        "PowerPenalty"
      ],
      "character": 9
    },
    {
      "id": "vegetable_oil",
      "name": "Vegetable Oil",
      "rarity": 1,
      "tags": [
        "PowerCooldown"
      ],
      "character": 9
    },
    {
      "id": "black_box",
      "name": "Black Box",
      "rarity": 5,
      "patch": "8.5.1",
      "tags": [
        "GateBlocker"
      ],
      "mechanics": {
        "duration": "15 seconds",
        "linger": "3 seconds"
      },
      "character": 10
    },
    {
      "id": "blue_dress",
      "name": "Blue Dress",
      "rarity": 3,
      "patch": "8.5.0",
      "tags": [
        "DreamSnares",
        "ExtendedAbility",
        "PowerCapacity",
        "PowerPenalty"
      ],
      "mechanics": {
        "duration": "8 seconds"
      },
      "character": 10
    },
    {
      "id": "cat_block",
      "name": "Cat Block",
      "rarity": 2,
      "patch": "8.5.0",
      "tags": [
        "DreamProjection",
        "PowerCooldown",
        "Teleportation"
      ],
      "mechanics": {
        "effect": "-10 %"
      },
      "character": 10
    },
    {
      "id": "class_photo",
      "name": "Class Photo",
      "rarity": 4,
      "patch": "8.5.0",
      "tags": [
        "DreamProjection",
        "ExitGates",
        "ExtendedAbility",
        "KillerInstinct",
        "Teleportation"
      ],
      "character": 10
    },
    {
      "id": "garden_rake",
      "name": "Garden Rake",
      "rarity": 1,
      "patch": "8.5.0",
      "tags": [
        "AOE",
        "DreamSnares"
      ],
      "mechanics": {
        "effect": "+10 %"
      },
      "character": 10
    },
    {
      "id": "green_dress",
      "name": "Green Dress",
      "rarity": 2,
      "patch": "8.5.0",
      "tags": [
        "ActionTime",
        "WakeUp"
      ],
      "mechanics": {
        "effect": "+2 seconds"
      },
      "character": 10
    },
    {
      "id": "jump_rope_dream_demon",
      "name": "Jump Rope (Dream Demon)",
      "rarity": 3,
      "patch": "8.5.0",
      "tags": [
        "DreamSnares",
        "Hindered"
      ],
      "mechanics": {
        "hindered": "-12 %",
        "durationHindered": "5 seconds",
        "effect": "+0.5 seconds",
        "multiName": true
      },
      "character": 10
    },
    {
      "id": "kid_s_drawing",
      "name": "Kid's Drawing",
      "rarity": 1,
      "patch": "8.5.0",
      "tags": [
        "Sleep"
      ],
      "mechanics": {
        "effect": "+10 %"
      },
      "character": 10
    },
    {
      "id": "nancy_s_masterpiece",
      "name": "Nancy's Masterpiece",
      "rarity": 3,
      "patch": "8.5.0",
      "tags": [
        "DreamProjection",
        "PowerCooldown"
      ],
      "mechanics": {
        "effect": "-10 %"
      },
      "character": 10
    },
    {
      "id": "nancy_s_sketch",
      "name": "Nancy's Sketch",
      "rarity": 2,
      "patch": "8.5.0",
      "tags": [
        "AlarmClocks",
        "EffectDuration"
      ],
      "mechanics": {
        "effect": "-20 %"
      },
      "character": 10
    },
    {
      "id": "outdoor_rope",
      "name": "Outdoor Rope",
      "rarity": 2,
      "patch": "8.5.0",
      "tags": [
        "DreamSnares"
      ],
      "mechanics": {
        "effect": "+15 %"
      },
      "character": 10
    },
    {
      "id": "paint_thinner",
      "name": "Paint Thinner",
      "rarity": 3,
      "patch": "8.5.0",
      "tags": [
        "ActionSpeed",
        "DreamPallets",
        "DreamProjection",
        "ExtendedAbility",
        "KillerInstinct"
      ],
      "mechanics": {
        "duration": "6 seconds",
        "effect": "+100 %"
      },
      "character": 10
    },
    {
      "id": "pill_bottle",
      "name": "Pill Bottle",
      "rarity": 4,
      "patch": "8.5.0",
      "tags": [
        "PowerPenalty",
        "Sleep"
      ],
      "mechanics": {
        "stack": "-10 %",
        "effect": "-50 %"
      },
      "character": 10
    },
    {
      "id": "prototype_claws",
      "name": "Prototype Claws",
      "rarity": 2,
      "patch": "8.5.0",
      "tags": [
        "ActionTime",
        "DreamSnares"
      ],
      "mechanics": {
        "effect": "-10 %"
      },
      "character": 10
    },
    {
      "id": "red_paint_brush",
      "name": "Red Paint Brush",
      "rarity": 5,
      "patch": "8.5.0",
      "tags": [
        "Auras",
        "PowerPenalty",
        "Sleep"
      ],
      "mechanics": {
        "distance": "32 metres",
        "effect": "+50 %"
      },
      "character": 10
    },
    {
      "id": "sheep_block",
      "name": "Sheep Block",
      "rarity": 1,
      "patch": "8.5.0",
      "tags": [
        "AlarmClocks"
      ],
      "mechanics": {
        "effect": "+10 %"
      },
      "character": 10
    },
    {
      "id": "swing_chains",
      "name": "Swing Chains",
      "rarity": 4,
      "patch": "8.5.0",
      "tags": [
        "DreamProjection",
        "ExtendedAbility",
        "WindowBlocker"
      ],
      "mechanics": {
        "range": "16 metres",
        "duration": "6 seconds"
      },
      "character": 10
    },
    {
      "id": "unicorn_block",
      "name": "Unicorn Block",
      "rarity": 3,
      "patch": "8.5.0",
      "tags": [
        "DetonationRadius",
        "DreamPallets",
        "EffectRange"
      ],
      "mechanics": {
        "effect": "+0.5 metres"
      },
      "character": 10
    },
    {
      "id": "wool_shirt",
      "name": "Wool Shirt",
      "rarity": 1,
      "patch": "8.5.0",
      "tags": [
        "DetonationDelay",
        "DreamPallets"
      ],
      "mechanics": {
        "effect": "-10 %"
      },
      "character": 10
    },
    {
      "id": "z_block",
      "name": "\"Z\" Block",
      "rarity": 4,
      "patch": "8.5.0",
      "tags": [
        "Auras",
        "DreamSnares",
        "DreamPallets"
      ],
      "mechanics": {
        "duration": "3 seconds"
      },
      "character": 10
    },
    {
      "id": "amanda_s_letter",
      "name": "Amanda's Letter",
      "rarity": 5,
      "tags": [
        "Auras",
        "PowerCapacity"
      ],
      "character": 11
    },
    {
      "id": "amanda_s_secret",
      "name": "Amanda's Secret",
      "rarity": 4,
      "patch": "7.6.0",
      "tags": [
        "Auras",
        "JigsawBox",
        "LoudNoiseNotifications",
        "PowerObject"
      ],
      "character": 11
    },
    {
      "id": "bag_of_gears",
      "name": "Bag of Gears",
      "rarity": 3,
      "patch": "5.3.0",
      "tags": [
        "ActionSpeed",
        "JigsawBox"
      ],
      "mechanics": {
        "effects": [
          "+50 %",
          "-14 %"
        ]
      },
      "character": 11
    },
    {
      "id": "combat_straps",
      "name": "Combat Straps",
      "rarity": 1,
      "patch": "7.6.0",
      "tags": [
        "TransitionSpeed"
      ],
      "mechanics": {
        "effect": "+10 %"
      },
      "character": 11
    },
    {
      "id": "crate_of_gears",
      "name": "Crate of Gears",
      "rarity": 4,
      "patch": "5.3.0",
      "tags": [
        "ActionSpeed",
        "JigsawBox"
      ],
      "mechanics": {
        "effects": [
          "+50 %",
          "-25 %"
        ]
      },
      "character": 11
    },
    {
      "id": "face_mask",
      "name": "Face Mask",
      "rarity": 2,
      "tags": [
        "Blindness"
      ],
      "character": 11
    },
    {
      "id": "interlocking_razor",
      "name": "Interlocking Razor",
      "rarity": 1,
      "tags": [
        "DeepWound",
        "JigsawBox",
        "SkillChecks"
      ],
      "character": 11
    },
    {
      "id": "jigsaw_s_annotated_plan",
      "name": "Jigsaw's Annotated Plan",
      "rarity": 3,
      "tags": [
        "Generators",
        "PowerCapacity",
        "PowerDuration"
      ],
      "character": 11
    },
    {
      "id": "jigsaw_s_sketch",
      "name": "Jigsaw's Sketch",
      "rarity": 4,
      "tags": [
        "Auras",
        "Generators",
        "PowerCapacity"
      ],
      "character": 11
    },
    {
      "id": "john_s_medical_file",
      "name": "John's Medical File",
      "rarity": 1,
      "patch": "9.1.0",
      "tags": [
        "MovementSpeed"
      ],
      "mechanics": {
        "effect": "+5 %"
      },
      "character": 11
    },
    {
      "id": "last_will",
      "name": "Last Will",
      "rarity": 2,
      "patch": "9.1.0",
      "tags": [
        "ActionTime",
        "Dash",
        "MovementSpeed"
      ],
      "mechanics": {
        "effects": [
          "+5 %",
          "+10 %"
        ]
      },
      "character": 11
    },
    {
      "id": "razor_wires",
      "name": "Razor Wires",
      "rarity": 2,
      "tags": [
        "AutoDamage",
        "JigsawBox",
        "SkillCheckDifficulty",
        "SkillChecks"
      ],
      "character": 11
    },
    {
      "id": "rules_set_no_2",
      "name": "Rules Set No.2",
      "rarity": 3,
      "tags": [
        "Auras",
        "JigsawBox"
      ],
      "character": 11
    },
    {
      "id": "rusty_attachments",
      "name": "Rusty Attachments",
      "rarity": 3,
      "patch": "7.6.0",
      "tags": [
        "Mangled"
      ],
      "mechanics": {
        "mangled": "70 seconds"
      },
      "character": 11
    },
    {
      "id": "shattered_syringe",
      "name": "Shattered Syringe",
      "rarity": 1,
      "patch": "7.6.0",
      "tags": [
        "Dash",
        "PowerCooldown"
      ],
      "character": 11
    },
    {
      "id": "slow_release_toxin",
      "name": "Slow-Release Toxin",
      "rarity": 3,
      "tags": [
        "Exhausted"
      ],
      "character": 11
    },
    {
      "id": "tampered_timer",
      "name": "Tampered Timer",
      "rarity": 4,
      "tags": [
        "PowerDuration"
      ],
      "character": 11
    },
    {
      "id": "utility_blades",
      "name": "Utility Blades",
      "rarity": 2,
      "patch": "7.6.0",
      "tags": [
        "Haemorrhage"
      ],
      "character": 11
    },
    {
      "id": "video_tape",
      "name": "Video Tape",
      "rarity": 5,
      "character": 11
    },
    {
      "id": "workshop_grease",
      "name": "Workshop Grease",
      "rarity": 2,
      "patch": "9.1.0",
      "tags": [
        "ActionSpeed",
        "Dash",
        "PowerCooldown"
      ],
      "mechanics": {
        "effect": "+50 %"
      },
      "character": 11
    },
    {
      "id": "bottle_of_chloroform",
      "name": "Bottle of Chloroform",
      "rarity": 3,
      "tags": [
        "Intoxication",
        "PowerRange"
      ],
      "mechanics": {
        "effect": "+20 %"
      },
      "character": 12
    },
    {
      "id": "cheap_gin_bottle",
      "name": "Cheap Gin Bottle",
      "rarity": 4,
      "patch": "7.6.2",
      "tags": [
        "Haste"
      ],
      "mechanics": {
        "effect": "+3 %",
        "haste": "+17 %"
      },
      "character": 12
    },
    {
      "id": "cigar_box",
      "name": "Cigar Box",
      "rarity": 4,
      "patch": "9.1.0",
      "tags": [
        "Auras",
        "Invigoration"
      ],
      "mechanics": {
        "range": "6 metres",
        "duration": "6 seconds"
      },
      "character": 12
    },
    {
      "id": "ether_15_vol",
      "name": "Ether 15 Vol%",
      "rarity": 4,
      "patch": "9.1.0",
      "tags": [
        "Intoxication",
        "PowerDuration"
      ],
      "mechanics": {
        "effect": "+0.5 seconds"
      },
      "character": 12
    },
    {
      "id": "fingerless_parade_gloves",
      "name": "Fingerless Parade Gloves",
      "rarity": 1,
      "tags": [
        "ProjectileAngle",
        "ProjectileSpeed"
      ],
      "mechanics": {
        "effet": [
          "+25 %",
          "-15 °"
        ]
      },
      "character": 12
    },
    {
      "id": "flask_of_bleach",
      "name": "Flask of Bleach",
      "rarity": 3,
      "patch": "9.1.0",
      "tags": [
        "Hindered",
        "Intoxication",
        "PowerEfficiency"
      ],
      "mechanics": {
        "effect": "-2 %",
        "hindered": "-16 %"
      },
      "character": 12
    },
    {
      "id": "garish_make_up_kit",
      "name": "Garish Make-Up Kit",
      "rarity": 4,
      "tags": [
        "Invigoration",
        "PowerDuration"
      ],
      "mechanics": {
        "effect": "+2 seconds"
      },
      "character": 12
    },
    {
      "id": "kerosene_can",
      "name": "Kerosene Can",
      "rarity": 2,
      "tags": [
        "Blindness",
        "Intoxication"
      ],
      "mechanics": {
        "blindness": "30 seconds"
      },
      "character": 12
    },
    {
      "id": "party_bottle",
      "name": "Party Bottle",
      "rarity": 1,
      "tags": [
        "Bloodpoints",
        "Confetti",
        "Deviousness"
      ],
      "mechanics": {
        "bonus": 100
      },
      "character": 12
    },
    {
      "id": "redhead_s_pinkie_finger",
      "name": "Redhead's Pinkie Finger",
      "rarity": 5,
      "patch": "7.6.0",
      "tags": [
        "Exposed",
        "Intoxication",
        "PowerCapacity"
      ],
      "mechanics": {
        "bottles": 1
      },
      "character": 12
    },
    {
      "id": "robin_feather",
      "name": "Robin Feather",
      "rarity": 1,
      "tags": [
        "ThrowCooldown"
      ],
      "mechanics": {
        "effect": "-40 %"
      },
      "character": 12
    },
    {
      "id": "smelly_inner_soles",
      "name": "Smelly Inner Soles",
      "rarity": 3,
      "patch": "9.1.0",
      "tags": [
        "MovementSpeed"
      ],
      "mechanics": {
        "effect": "+15 %"
      },
      "character": 12
    },
    {
      "id": "solvent_jug",
      "name": "Solvent Jug",
      "rarity": 2,
      "tags": [
        "Invigoration",
        "PowerDuration"
      ],
      "mechanics": {
        "effect": "+1 second"
      },
      "character": 12
    },
    {
      "id": "spirit_of_hartshorn",
      "name": "Spirit of Hartshorn",
      "rarity": 3,
      "tags": [
        "Invigoration",
        "PowerRange"
      ],
      "mechanics": {
        "effect": "+20 %"
      },
      "character": 12
    },
    {
      "id": "starling_feather",
      "name": "Starling Feather",
      "rarity": 2,
      "tags": [
        "ThrowCooldown"
      ],
      "mechanics": {
        "effect": "-50 %"
      },
      "character": 12
    },
    {
      "id": "sticky_soda_bottle",
      "name": "Sticky Soda Bottle",
      "rarity": 2,
      "patch": "7.6.2",
      "tags": [
        "Haste"
      ],
      "mechanics": {
        "effect": "+2 %",
        "haste": "+16 %"
      },
      "character": 12
    },
    {
      "id": "sulphuric_acid_vial",
      "name": "Sulphuric Acid Vial",
      "rarity": 3,
      "patch": "7.6.0",
      "tags": [
        "Intoxication",
        "Mangled"
      ],
      "mechanics": {
        "mangled": "70 seconds"
      },
      "character": 12
    },
    {
      "id": "tattoo_s_middle_finger",
      "name": "Tattoo's Middle Finger",
      "rarity": 5,
      "tags": [
        "Auras",
        "Intoxication",
        "Invigoration"
      ],
      "mechanics": {
        "duration": "6 seconds"
      },
      "character": 12
    },
    {
      "id": "thick_cork_stopper",
      "name": "Thick Cork Stopper",
      "rarity": 2,
      "tags": [
        "ActionTime"
      ],
      "mechanics": {
        "effect": "-0.5 seconds"
      },
      "character": 12
    },
    {
      "id": "vhs_porn",
      "name": "VHS Porn",
      "rarity": 1,
      "patch": "9.1.0",
      "tags": [
        "Intoxication",
        "PowerRange"
      ],
      "mechanics": {
        "effect": "+10 %"
      },
      "character": 12
    },
    {
      "id": "dried_cherry_blossom",
      "name": "Dried Cherry Blossom",
      "rarity": 4,
      "tags": [
        "KillerInstinct",
        "Phase-Walk",
        "ScratchMarks"
      ],
      "character": 13
    },
    {
      "id": "furin",
      "name": "Furin",
      "rarity": 4,
      "tags": [
        "Deception"
      ],
      "character": 13
    },
    {
      "id": "gifted_bamboo_comb",
      "name": "Gifted Bamboo Comb",
      "rarity": 1,
      "tags": [
        "ActionSpeed"
      ],
      "character": 13
    },
    {
      "id": "juniper_bonsai",
      "name": "Juniper Bonsai",
      "rarity": 2,
      "tags": [
        "Deception",
        "PowerInvisibility"
      ],
      "character": 13
    },
    {
      "id": "kaiun_talisman",
      "name": "Kaiun Talisman",
      "rarity": 2,
      "tags": [
        "Phase-Walk",
        "PowerDuration"
      ],
      "character": 13
    },
    {
      "id": "katana_tsuba",
      "name": "Katana Tsuba",
      "rarity": 3,
      "tags": [
        "MovementSpeed",
        "Phase-Walk",
        "PowerInvisibility"
      ],
      "character": 13
    },
    {
      "id": "kintsugi_teacup",
      "name": "Kintsugi Teacup",
      "rarity": 5,
      "tags": [
        "BreakableWalls",
        "Pallets",
        "PowerRecovery"
      ],
      "character": 13
    },
    {
      "id": "mother_s_glasses",
      "name": "Mother's Glasses",
      "rarity": 3,
      "tags": [
        "Husk",
        "KillerInstinct"
      ],
      "character": 13
    },
    {
      "id": "mother_daughter_ring",
      "name": "Mother-Daughter Ring",
      "rarity": 5,
      "tags": [
        "MovementSpeed",
        "Phase-Walk",
        "ScratchMarks"
      ],
      "character": 13
    },
    {
      "id": "muddy_sports_day_cap",
      "name": "Muddy Sports Day Cap",
      "rarity": 2,
      "tags": [
        "MovementSpeed",
        "Phase-Walk"
      ],
      "character": 13
    },
    {
      "id": "origami_crane",
      "name": "Origami Crane",
      "rarity": 1,
      "tags": [
        "PowerRecovery"
      ],
      "character": 13
    },
    {
      "id": "rin_s_broken_watch",
      "name": "Rin's Broken Watch",
      "rarity": 2,
      "tags": [
        "PowerRecovery"
      ],
      "character": 13
    },
    {
      "id": "rusty_flute",
      "name": "Rusty Flute",
      "rarity": 3,
      "tags": [
        "PowerRecovery"
      ],
      "character": 13
    },
    {
      "id": "senko_hanabi",
      "name": "Senko Hanabi",
      "rarity": 3,
      "tags": [
        "Husk",
        "Phase-Walk",
        "WindowBlocker"
      ],
      "character": 13
    },
    {
      "id": "shiawase_amulet",
      "name": "Shiawase Amulet",
      "rarity": 1,
      "tags": [
        "Phase-Walk",
        "PowerDuration"
      ],
      "character": 13
    },
    {
      "id": "uchiwa",
      "name": "Uchiwa",
      "rarity": 3,
      "tags": [
        "KillerStun",
        "Pallets",
        "PowerRecovery"
      ],
      "character": 13
    },
    {
      "id": "wakizashi_saya",
      "name": "Wakizashi Saya",
      "rarity": 4,
      "tags": [
        "ExtendedAbility",
        "Husk",
        "Phase-Walk"
      ],
      "character": 13
    },
    {
      "id": "white_hair_ribbon",
      "name": "White Hair Ribbon",
      "rarity": 2,
      "tags": [
        "ActionSpeed"
      ],
      "character": 13
    },
    {
      "id": "yakuyoke_amulet",
      "name": "Yakuyoke Amulet",
      "rarity": 4,
      "tags": [
        "MovementSpeed",
        "Phase-Walk",
        "PowerDuration"
      ],
      "character": 13
    },
    {
      "id": "zori",
      "name": "Zōri",
      "rarity": 1,
      "tags": [
        "MovementSpeed",
        "Phase-Walk"
      ],
      "character": 13
    },
    {
      "id": "bffs",
      "name": "BFFs",
      "rarity": 4,
      "tags": [
        "ExitGates",
        "Haste"
      ],
      "character": 14
    },
    {
      "id": "defaced_smiley_pin",
      "name": "Defaced Smiley Pin",
      "rarity": 2,
      "patch": "7.6.0",
      "tags": [
        "DeepWound",
        "Mangled",
        "Mending"
      ],
      "character": 14
    },
    {
      "id": "etched_ruler",
      "name": "Etched Ruler",
      "rarity": 2,
      "tags": [
        "Oblivious"
      ],
      "character": 14
    },
    {
      "id": "filthy_blade",
      "name": "Filthy Blade",
      "rarity": 4,
      "tags": [
        "ActionTime",
        "DeepWound",
        "Mending"
      ],
      "character": 14
    },
    {
      "id": "frank_s_mix_tape",
      "name": "Frank's Mix Tape",
      "rarity": 4,
      "tags": [
        "ActionSpeed",
        "BreakableWalls",
        "Generators",
        "TerrorRadius"
      ],
      "character": 14
    },
    {
      "id": "friendship_bracelet",
      "name": "Friendship Bracelet",
      "rarity": 1,
      "tags": [
        "AttackRange"
      ],
      "character": 14
    },
    {
      "id": "fuming_mix_tape",
      "name": "Fuming Mix Tape",
      "rarity": 5,
      "tags": [
        "ExtendedAbility",
        "Generators",
        "TerrorRadius"
      ],
      "character": 14
    },
    {
      "id": "iridescent_button",
      "name": "Iridescent Button",
      "rarity": 5,
      "tags": [
        "AutoBreak",
        "Pallets"
      ],
      "character": 14
    },
    {
      "id": "joey_s_mix_tape",
      "name": "Joey's Mix Tape",
      "rarity": 3,
      "tags": [
        "DeepWound",
        "Haemorrhage",
        "Mending",
        "TerrorRadius"
      ],
      "character": 14
    },
    {
      "id": "julie_s_mix_tape",
      "name": "Julie's Mix Tape",
      "rarity": 2,
      "tags": [
        "KillerStun",
        "PowerRecovery"
      ],
      "character": 14
    },
    {
      "id": "mischief_list",
      "name": "Mischief List",
      "rarity": 1,
      "patch": "8.6.0",
      "tags": [
        "PowerDuration"
      ],
      "mechanics": {
        "effect": "+1 second"
      },
      "character": 14
    },
    {
      "id": "mural_sketch",
      "name": "Mural Sketch",
      "rarity": 2,
      "patch": "8.6.0",
      "tags": [
        "MovementSpeed"
      ],
      "mechanics": {
        "effect": "+0.08 m/s",
        "stack": "+0.32 m/s",
        "maxBonus": "+1.28 m/s"
      },
      "character": 14
    },
    {
      "id": "never_sleep_pills",
      "name": "Never-Sleep Pills",
      "rarity": 2,
      "tags": [
        "Bloodpoints",
        "MovementSpeed",
        "PowerDuration"
      ],
      "character": 14
    },
    {
      "id": "scratched_ruler",
      "name": "Scratched Ruler",
      "rarity": 1,
      "tags": [
        "PowerRecovery"
      ],
      "character": 14
    },
    {
      "id": "smiley_face_pin",
      "name": "Smiley Face Pin",
      "rarity": 1,
      "tags": [
        "Blindness",
        "DeepWound",
        "Mending"
      ],
      "character": 14
    },
    {
      "id": "stab_wounds_study",
      "name": "Stab Wounds Study",
      "rarity": 4,
      "tags": [
        "Auras",
        "DeepWound",
        "Mending"
      ],
      "character": 14
    },
    {
      "id": "stolen_sketch_book",
      "name": "Stolen Sketch Book",
      "rarity": 3,
      "tags": [
        "ItemDrop"
      ],
      "character": 14
    },
    {
      "id": "stylish_sunglasses",
      "name": "Stylish Sunglasses",
      "rarity": 3,
      "tags": [
        "Auras",
        "DeepWound",
        "Mending"
      ],
      "character": 14
    },
    {
      "id": "susie_s_mix_tape",
      "name": "Susie's Mix Tape",
      "rarity": 3,
      "tags": [
        "KillerInstinct",
        "TerrorRadius"
      ],
      "character": 14
    },
    {
      "id": "the_legion_pin",
      "name": "The Legion Pin",
      "rarity": 3,
      "tags": [
        "Broken",
        "DeepWound",
        "Mending"
      ],
      "character": 14
    },
    {
      "id": "ashen_apple",
      "name": "Ashen Apple",
      "rarity": 3,
      "tags": [
        "PoolsOfDevotion",
        "PowerCapacity",
        "PowerObject"
      ],
      "character": 15
    },
    {
      "id": "black_incense",
      "name": "Black Incense",
      "rarity": 5,
      "tags": [
        "Auras"
      ],
      "character": 15
    },
    {
      "id": "blessed_apple",
      "name": "Blessed Apple",
      "rarity": 2,
      "tags": [
        "PoolsOfDevotion",
        "PowerCapacity"
      ],
      "character": 15
    },
    {
      "id": "devotee_s_amulet",
      "name": "Devotee's Amulet",
      "rarity": 4,
      "tags": [
        "PowerDuration"
      ],
      "character": 15
    },
    {
      "id": "emetic_potion",
      "name": "Emetic Potion",
      "rarity": 2,
      "tags": [
        "PowerEfficiency"
      ],
      "character": 15
    },
    {
      "id": "exorcism_amulet",
      "name": "Exorcism Amulet",
      "rarity": 3,
      "tags": [
        "PowerDuration"
      ],
      "character": 15
    },
    {
      "id": "haematite_seal",
      "name": "Haematite Seal",
      "rarity": 2,
      "tags": [
        "PowerDuration"
      ],
      "character": 15
    },
    {
      "id": "healing_salve",
      "name": "Healing Salve",
      "rarity": 1,
      "tags": [
        "PowerCooldown"
      ],
      "character": 15
    },
    {
      "id": "incensed_ointment",
      "name": "Incensed Ointment",
      "rarity": 3,
      "tags": [
        "LoudNoiseNotifications",
        "Screams",
        "TerrorRadius"
      ],
      "character": 15
    },
    {
      "id": "infected_emetic",
      "name": "Infected Emetic",
      "rarity": 3,
      "tags": [
        "PowerEfficiency"
      ],
      "character": 15
    },
    {
      "id": "iridescent_seal",
      "name": "Iridescent Seal",
      "rarity": 5,
      "tags": [
        "Generator",
        "PowerDuration",
        "PowerRecovery"
      ],
      "character": 15
    },
    {
      "id": "limestone_seal",
      "name": "Limestone Seal",
      "rarity": 1,
      "tags": [
        "PowerDuration"
      ],
      "character": 15
    },
    {
      "id": "olibanum_incense",
      "name": "Olibanum Incense",
      "rarity": 1,
      "tags": [
        "Auras",
        "PoolsOfDevotion"
      ],
      "character": 15
    },
    {
      "id": "potent_tincture",
      "name": "Potent Tincture",
      "rarity": 2,
      "tags": [
        "PowerCooldown"
      ],
      "character": 15
    },
    {
      "id": "prayer_tablet_fragment",
      "name": "Prayer Tablet Fragment",
      "rarity": 1,
      "tags": [
        "Bloodpoints",
        "Deviousness",
        "PowerDuration",
        "PowerEfficiency",
        "PowerPenalty"
      ],
      "character": 15
    },
    {
      "id": "prophylactic_amulet",
      "name": "Prophylactic Amulet",
      "rarity": 2,
      "tags": [
        "PoolsOfDevotion",
        "PowerObject"
      ],
      "character": 15
    },
    {
      "id": "rubbing_oil",
      "name": "Rubbing Oil",
      "rarity": 3,
      "tags": [
        "ActionSpeed"
      ],
      "character": 15
    },
    {
      "id": "severed_toe",
      "name": "Severed Toe",
      "rarity": 4,
      "tags": [
        "PowerEfficiency"
      ],
      "character": 15
    },
    {
      "id": "vile_emetic",
      "name": "Vile Emetic",
      "rarity": 4,
      "tags": [
        "ProjectileSpeed"
      ],
      "character": 15
    },
    {
      "id": "worship_tablet",
      "name": "Worship Tablet",
      "rarity": 4,
      "tags": [
        "ActionSpeed",
        "MovementSpeed",
        "PoolsOfDevotion"
      ],
      "character": 15
    },
    {
      "id": "cheap_cologne",
      "name": "Cheap Cologne",
      "rarity": 1,
      "tags": [
        "PowerDuration"
      ],
      "character": 16
    },
    {
      "id": "chewed_pen",
      "name": "Chewed Pen",
      "rarity": 3,
      "tags": [
        "PowerCounter"
      ],
      "character": 16
    },
    {
      "id": "cinch_straps",
      "name": "Cinch Straps",
      "rarity": 2,
      "tags": [
        "PowerPenalty"
      ],
      "character": 16
    },
    {
      "id": "driver_s_license",
      "name": "Driver's License",
      "rarity": 4,
      "tags": [
        "ExtendedAbility",
        "GenBlocker",
        "Generators"
      ],
      "character": 16
    },
    {
      "id": "drop_leg_knife_sheath",
      "name": "Drop-Leg Knife Sheath",
      "rarity": 4,
      "tags": [
        "Haste"
      ],
      "character": 16
    },
    {
      "id": "ghost_face_caught_on_tape",
      "name": "\"Ghost Face Caught on Tape\"",
      "rarity": 5,
      "tags": [
        "DyingState",
        "PowerRecovery"
      ],
      "character": 16
    },
    {
      "id": "headline_cut_outs",
      "name": "Headline Cut-Outs",
      "rarity": 1,
      "tags": [
        "MovementSpeed"
      ],
      "character": 16
    },
    {
      "id": "knife_belt_clip",
      "name": "Knife Belt Clip",
      "rarity": 3,
      "tags": [
        "TerrorRadius"
      ],
      "character": 16
    },
    {
      "id": "lasting_perfume",
      "name": "Lasting Perfume",
      "rarity": 3,
      "tags": [
        "PowerCounter"
      ],
      "character": 16
    },
    {
      "id": "leather_knife_sheath",
      "name": "Leather Knife Sheath",
      "rarity": 3,
      "tags": [
        "MovementSpeed"
      ],
      "character": 16
    },
    {
      "id": "marked_map",
      "name": "Marked Map",
      "rarity": 2,
      "tags": [
        "KillerInstinct",
        "PowerCounter"
      ],
      "character": 16
    },
    {
      "id": "night_vision_monocular",
      "name": "Night Vision Monocular",
      "rarity": 4,
      "tags": [
        "Exhausted"
      ],
      "character": 16
    },
    {
      "id": "olsen_s_address_book",
      "name": "Olsen's Address Book",
      "rarity": 2,
      "tags": [
        "Auras",
        "RushedActions"
      ],
      "character": 16
    },
    {
      "id": "olsen_s_journal",
      "name": "Olsen's Journal",
      "rarity": 2,
      "tags": [
        "Oblivious"
      ],
      "character": 16
    },
    {
      "id": "olsen_s_wallet",
      "name": "Olsen's Wallet",
      "rarity": 3,
      "tags": [
        "BreakableWalls",
        "Pallets",
        "PowerRecovery"
      ],
      "character": 16
    },
    {
      "id": "outdoor_security_camera",
      "name": "Outdoor Security Camera",
      "rarity": 5,
      "tags": [
        "Auras",
        "DyingState"
      ],
      "character": 16
    },
    {
      "id": "philly",
      "name": "\"Philly\"",
      "rarity": 1,
      "patch": "8.4.0",
      "tags": [
        "PowerEfficiency"
      ],
      "mechanics": {
        "effect": "-10 %"
      },
      "character": 16
    },
    {
      "id": "telephoto_lens",
      "name": "Telephoto Lens",
      "rarity": 2,
      "tags": [
        "Oblivious"
      ],
      "character": 16
    },
    {
      "id": "victim_s_detailed_routine",
      "name": "Victim's Detailed Routine",
      "rarity": 4,
      "tags": [
        "Exhausted"
      ],
      "character": 16
    },
    {
      "id": "walleye_s_matchbook",
      "name": "Walleye's Matchbook",
      "rarity": 1,
      "patch": "9.6.0",
      "tags": [
        "PowerRecovery"
      ],
      "mechanics": {
        "effect": "-2 seconds"
      },
      "character": 16
    },
    {
      "id": "barb_s_glasses",
      "name": "Barb's Glasses",
      "rarity": 2,
      "patch": "7.6.0",
      "tags": [
        "AttackCooldown",
        "BreakableWalls",
        "Pallets"
      ],
      "character": 17
    },
    {
      "id": "black_heart",
      "name": "Black Heart",
      "rarity": 1,
      "patch": "7.6.0",
      "tags": [
        "AttackCooldown"
      ],
      "character": 17
    },
    {
      "id": "brass_case_lighter",
      "name": "Brass Case Lighter",
      "rarity": 3,
      "tags": [
        "Blindness",
        "Portals"
      ],
      "character": 17
    },
    {
      "id": "deer_lung",
      "name": "Deer Lung",
      "rarity": 3,
      "tags": [
        "MovementSpeed",
        "PowerObject"
      ],
      "character": 17
    },
    {
      "id": "eleven_s_soda",
      "name": "Eleven's Soda",
      "rarity": 3,
      "tags": [
        "Auras",
        "ExtendedAbility",
        "Generators"
      ],
      "character": 17
    },
    {
      "id": "leprose_lichen",
      "name": "Leprose Lichen",
      "rarity": 5,
      "tags": [
        "Auras",
        "ExtendedAbility",
        "Portals"
      ],
      "character": 17
    },
    {
      "id": "lifeguard_whistle",
      "name": "Lifeguard Whistle",
      "rarity": 4,
      "patch": "8.4.0",
      "tags": [
        "PowerCapacity",
        "Portals"
      ],
      "mechanics": {
        "effect": "+2"
      },
      "character": 17
    },
    {
      "id": "mews_guts",
      "name": "Mews' Guts",
      "rarity": 2,
      "tags": [
        "AttackCooldown",
        "PowerObject",
        "Portals"
      ],
      "character": 17
    },
    {
      "id": "rat_liver",
      "name": "Rat Liver",
      "rarity": 1,
      "patch": "4.7.0",
      "tags": [
        "MovementSpeed"
      ],
      "mechanics": {
        "effect": "+3.5 %"
      },
      "character": 17
    },
    {
      "id": "rat_tail",
      "name": "Rat Tail",
      "rarity": 1,
      "tags": [
        "ActionSpeed",
        "Portals"
      ],
      "character": 17
    },
    {
      "id": "red_moss",
      "name": "Red Moss",
      "rarity": 5,
      "patch": "4.7.0",
      "tags": [
        "ActionNoise",
        "ActionTime",
        "EffectDuration",
        "Undetectable",
        "Portals"
      ],
      "mechanics": {
        "penalty": "+15 %",
        "bonus": "+8 seconds",
        "undetectable": "13 seconds"
      },
      "character": 17
    },
    {
      "id": "rotten_green_tripe",
      "name": "Rotten Green Tripe",
      "rarity": 2,
      "tags": [
        "MovementSpeed",
        "Portals"
      ],
      "character": 17
    },
    {
      "id": "rotten_pumpkin",
      "name": "Rotten Pumpkin",
      "rarity": 1,
      "tags": [
        "Bloodpoints",
        "Portals",
        "PowerPenalty"
      ],
      "character": 17
    },
    {
      "id": "sticky_lining",
      "name": "Sticky Lining",
      "rarity": 2,
      "tags": [
        "EffectRange",
        "Portals"
      ],
      "character": 17
    },
    {
      "id": "thorny_vines",
      "name": "Thorny Vines",
      "rarity": 3,
      "patch": "8.4.0",
      "tags": [
        "ActionTime",
        "EffectRange",
        "Portals"
      ],
      "mechanics": {
        "range": "+1 metre",
        "effect": "+8 %"
      },
      "character": 17
    },
    {
      "id": "unknown_egg",
      "name": "Unknown Egg",
      "rarity": 4,
      "tags": [
        "PowerRecovery"
      ],
      "character": 17
    },
    {
      "id": "upside_down_resin",
      "name": "Upside Down Resin",
      "rarity": 4,
      "patch": "8.4.0",
      "tags": [
        "ActionTime",
        "Portals"
      ],
      "mechanics": {
        "effect": "+20 %"
      },
      "character": 17
    },
    {
      "id": "vermilion_webcap",
      "name": "Vermilion Webcap",
      "rarity": 4,
      "patch": "5.0.0",
      "tags": [
        "EffectDuration",
        "Undetectable",
        "Portals"
      ],
      "mechanics": {
        "bonus": "+3 seconds",
        "undetectable": "8 seconds"
      },
      "character": 17
    },
    {
      "id": "violet_waxcap",
      "name": "Violet Waxcap",
      "rarity": 3,
      "patch": "7.2.0",
      "tags": [
        "EffectDuration",
        "Undetectable",
        "Portals"
      ],
      "mechanics": {
        "bonus": "+1 second",
        "undetectable": "6 seconds"
      },
      "character": 17
    },
    {
      "id": "viscous_webbing",
      "name": "Viscous Webbing",
      "rarity": 2,
      "patch": "8.4.0",
      "tags": [
        "ActionTime",
        "Portals"
      ],
      "mechanics": {
        "effect": "+10 %"
      },
      "character": 17
    },
    {
      "id": "akito_s_crutch",
      "name": "Akito's Crutch",
      "rarity": 4,
      "tags": [
        "Dash",
        "MovementSpeed"
      ],
      "character": 18
    },
    {
      "id": "blackened_toenail",
      "name": "Blackened Toenail",
      "rarity": 1,
      "tags": [
        "Absorption",
        "BloodOrbs",
        "MovementSpeed"
      ],
      "character": 18
    },
    {
      "id": "bloody_sash",
      "name": "Bloody Sash",
      "rarity": 2,
      "tags": [
        "Absorption",
        "BloodOrbs",
        "MovementSpeed"
      ],
      "character": 18
    },
    {
      "id": "child_s_wooden_sword",
      "name": "Child's Wooden Sword",
      "rarity": 2,
      "tags": [
        "Auras",
        "BloodOrbs",
        "PowerRange"
      ],
      "character": 18
    },
    {
      "id": "chipped_saihai",
      "name": "Chipped Saihai",
      "rarity": 2,
      "tags": [
        "PowerDuration"
      ],
      "character": 18
    },
    {
      "id": "cracked_sakazuki",
      "name": "Cracked Sakazuki",
      "rarity": 1,
      "tags": [
        "TransitionTime"
      ],
      "character": 18
    },
    {
      "id": "ink_lion",
      "name": "Ink Lion",
      "rarity": 2,
      "tags": [
        "TransitionTime",
        "PowerPenalty"
      ],
      "character": 18
    },
    {
      "id": "iridescent_family_crest",
      "name": "Iridescent Family Crest",
      "rarity": 5,
      "tags": [
        "ExtendedAbility",
        "LoudNoiseNotifications",
        "Screams"
      ],
      "character": 18
    },
    {
      "id": "kanai_anzen_talisman",
      "name": "Kanai-Anzen Talisman",
      "rarity": 3,
      "tags": [
        "Dash",
        "MovementSpeed"
      ],
      "character": 18
    },
    {
      "id": "lion_fang",
      "name": "Lion Fang",
      "rarity": 4,
      "tags": [
        "PowerDuration"
      ],
      "character": 18
    },
    {
      "id": "paper_lantern",
      "name": "Paper Lantern",
      "rarity": 1,
      "tags": [
        "Absorption",
        "BloodOrbs",
        "MovementSpeed"
      ],
      "character": 18
    },
    {
      "id": "polished_maedate",
      "name": "Polished Maedate",
      "rarity": 2,
      "tags": [
        "PassiveCharge"
      ],
      "character": 18
    },
    {
      "id": "renjiro_s_bloody_glove",
      "name": "Renjiro's Bloody Glove",
      "rarity": 5,
      "patch": "3.4.2",
      "tags": [
        "Auras",
        "ExtendedAbility"
      ],
      "mechanics": {
        "aura": "2 seconds"
      },
      "character": 18
    },
    {
      "id": "rotting_rope",
      "name": "Rotting Rope",
      "rarity": 1,
      "tags": [
        "Auras",
        "BloodOrbs",
        "PowerRange"
      ],
      "character": 18
    },
    {
      "id": "scalped_topknot",
      "name": "Scalped Topknot",
      "rarity": 3,
      "tags": [
        "ActionTime",
        "Dash"
      ],
      "character": 18
    },
    {
      "id": "shattered_wakizashi",
      "name": "Shattered Wakizashi",
      "rarity": 3,
      "tags": [
        "PassiveCharge"
      ],
      "character": 18
    },
    {
      "id": "splintered_hull",
      "name": "Splintered Hull",
      "rarity": 4,
      "tags": [
        "BloodOrbs",
        "Crouching",
        "Lockers",
        "Pallets",
        "SkillChecks",
        "Windows"
      ],
      "character": 18
    },
    {
      "id": "tear_soaked_tenugui",
      "name": "Tear-Soaked Tenugui",
      "rarity": 4,
      "tags": [
        "PowerPenalty"
      ],
      "character": 18
    },
    {
      "id": "wooden_oni_mask",
      "name": "Wooden Oni Mask",
      "rarity": 3,
      "tags": [
        "BloodOrbs",
        "Crouching",
        "Lockers",
        "Pallets",
        "SkillChecks",
        "Windows"
      ],
      "character": 18
    },
    {
      "id": "yamaoka_sashimono",
      "name": "Yamaoka Sashimono",
      "rarity": 3,
      "tags": [
        "PowerDuration"
      ],
      "character": 18
    },
    {
      "id": "barbed_wire",
      "name": "Barbed Wire",
      "rarity": 4,
      "tags": [
        "ActionTime",
        "DeepWound",
        "Mending"
      ],
      "character": 19
    },
    {
      "id": "bayshore_s_cigar",
      "name": "Bayshore's Cigar",
      "rarity": 4,
      "patch": "8.0.0",
      "tags": [
        "KillerStun",
        "StunDuration"
      ],
      "character": 19
    },
    {
      "id": "bayshore_s_gold_tooth",
      "name": "Bayshore's Gold Tooth",
      "rarity": 3,
      "patch": "8.0.0",
      "tags": [
        "MovementSpeed",
        "Reeling"
      ],
      "character": 19
    },
    {
      "id": "chewing_tobacco",
      "name": "Chewing Tobacco",
      "rarity": 2,
      "patch": "8.0.0",
      "tags": [
        "KillerStun",
        "StunDuration"
      ],
      "character": 19
    },
    {
      "id": "gold_creek_whiskey",
      "name": "Gold Creek Whiskey",
      "rarity": 4,
      "tags": [
        "ADS",
        "TerrorRadius"
      ],
      "character": 19
    },
    {
      "id": "hellshire_iron",
      "name": "Hellshire Iron",
      "rarity": 5,
      "tags": [
        "Undetectable"
      ],
      "character": 19
    },
    {
      "id": "honey_locust_thorn",
      "name": "Honey Locust Thorn",
      "rarity": 3,
      "patch": "7.6.0",
      "tags": [
        "Mangled"
      ],
      "character": 19
    },
    {
      "id": "iridescent_coin",
      "name": "Iridescent Coin",
      "rarity": 5,
      "tags": [
        "Exposed"
      ],
      "character": 19
    },
    {
      "id": "jaw_smasher",
      "name": "Jaw Smasher",
      "rarity": 2,
      "tags": [
        "ADS",
        "MovementSpeed"
      ],
      "character": 19
    },
    {
      "id": "marshal_s_badge",
      "name": "Marshal's Badge",
      "rarity": 2,
      "tags": [
        "ADS",
        "TerrorRadius"
      ],
      "character": 19
    },
    {
      "id": "modified_ammo_belt",
      "name": "Modified Ammo Belt",
      "rarity": 1,
      "tags": [
        "ActionTime"
      ],
      "character": 19
    },
    {
      "id": "poison_oak_leaves",
      "name": "Poison Oak Leaves",
      "rarity": 2,
      "tags": [
        "ActionTime",
        "DeepWound",
        "Mending"
      ],
      "character": 19
    },
    {
      "id": "prison_chain",
      "name": "Prison Chain",
      "rarity": 4,
      "tags": [
        "ActionTime"
      ],
      "character": 19
    },
    {
      "id": "rickety_chain",
      "name": "Rickety Chain",
      "rarity": 1,
      "tags": [
        "ActionTime",
        "Bloodpoints"
      ],
      "character": 19
    },
    {
      "id": "rusted_spike",
      "name": "Rusted Spike",
      "rarity": 2,
      "patch": "7.6.0",
      "tags": [
        "Mangled"
      ],
      "character": 19
    },
    {
      "id": "snake_oil",
      "name": "Snake Oil",
      "rarity": 1,
      "patch": "8.0.0",
      "tags": [
        "MovementSpeed",
        "Reeling"
      ],
      "character": 19
    },
    {
      "id": "spit_polish_rag",
      "name": "Spit Polish Rag",
      "rarity": 1,
      "tags": [
        "PowerCooldown"
      ],
      "character": 19
    },
    {
      "id": "tin_oil_can",
      "name": "Tin Oil Can",
      "rarity": 3,
      "tags": [
        "PowerCooldown"
      ],
      "character": 19
    },
    {
      "id": "wanted_poster",
      "name": "Wanted Poster",
      "rarity": 3,
      "tags": [
        "ADS",
        "MovementSpeed"
      ],
      "character": 19
    },
    {
      "id": "warden_s_keys",
      "name": "Warden's Keys",
      "rarity": 3,
      "tags": [
        "ActionTime"
      ],
      "character": 19
    },
    {
      "id": "black_strap",
      "name": "Black Strap",
      "rarity": 1,
      "patch": "9.1.0",
      "tags": [
        "PowerRange"
      ],
      "mechanics": {
        "range": "-25 %",
        "width": "+25 %"
      },
      "character": 20
    },
    {
      "id": "burning_man_painting",
      "name": "Burning Man Painting",
      "rarity": 3,
      "patch": "9.1.0",
      "tags": [
        "Auras"
      ],
      "mechanics": {
        "auraRange": "3 metres",
        "auraDuration": "6 seconds"
      },
      "character": 20
    },
    {
      "id": "cinderella_music_box",
      "name": "Cinderella Music Box",
      "rarity": 2,
      "patch": "9.1.0",
      "tags": [
        "PowerCooldown"
      ],
      "mechanics": {
        "effect": "-10 %"
      },
      "character": 20
    },
    {
      "id": "copper_ring",
      "name": "Copper Ring",
      "rarity": 1,
      "patch": "9.1.0",
      "tags": [
        "PowerDuration"
      ],
      "mechanics": {
        "duration": "+5 seconds"
      },
      "character": 20
    },
    {
      "id": "crimson_ceremony_book",
      "name": "Crimson Ceremony Book",
      "rarity": 4,
      "patch": "7.6.0",
      "tags": [
        "Haemorrhage",
        "Mangled"
      ],
      "mechanics": {
        "haemorrhage": "80 seconds",
        "mangled": "80 seconds",
        "duration": "80 seconds"
      },
      "character": 20
    },
    {
      "id": "dead_butterfly",
      "name": "Dead Butterfly",
      "rarity": 1,
      "patch": "9.1.0",
      "tags": [
        "PowerRecovery"
      ],
      "mechanics": {
        "effect": "+10 %"
      },
      "character": 20
    },
    {
      "id": "forgotten_videotape",
      "name": "Forgotten Videotape",
      "rarity": 2,
      "patch": "9.1.0",
      "tags": [
        "PowerDuration"
      ],
      "mechanics": {
        "effect": "+10 %"
      },
      "character": 20
    },
    {
      "id": "iridescent_seal_of_metatron",
      "name": "Iridescent Seal of Metatron",
      "rarity": 5,
      "patch": "9.1.0",
      "tags": [
        "PowerRange"
      ],
      "mechanics": {
        "minLength": "-50 %",
        "maxLength": "+200 %"
      },
      "character": 20
    },
    {
      "id": "lead_ring",
      "name": "Lead Ring",
      "rarity": 1,
      "patch": "9.1.0",
      "tags": [
        "PowerRange"
      ],
      "mechanics": {
        "range": "+25 %",
        "width": "-25 %"
      },
      "character": 20
    },
    {
      "id": "leopard_print_fabric",
      "name": "Leopard-Print Fabric",
      "rarity": 2,
      "patch": "9.1.0",
      "tags": [
        "StunDuration"
      ],
      "mechanics": {
        "effect": "-15 %"
      },
      "character": 20
    },
    {
      "id": "lost_memories_book",
      "name": "Lost Memories Book",
      "rarity": 4,
      "patch": "9.1.0",
      "tags": [
        "Oblivious"
      ],
      "mechanics": {
        "oblivious": "80 seconds"
      },
      "character": 20
    },
    {
      "id": "mannequin_foot",
      "name": "Mannequin Foot",
      "rarity": 3,
      "patch": "9.1.0",
      "tags": [
        "Exhausted"
      ],
      "mechanics": {
        "exhausted": "10 seconds"
      },
      "character": 20
    },
    {
      "id": "misty_day_remains_of_judgement",
      "name": "Misty Day, Remains of Judgement",
      "rarity": 3,
      "patch": "9.1.0",
      "tags": [
        "Auras"
      ],
      "mechanics": {
        "auraDuration": "8 seconds"
      },
      "character": 20
    },
    {
      "id": "obsidian_goblet",
      "name": "Obsidian Goblet",
      "rarity": 5,
      "patch": "9.1.0",
      "tags": [
        "BreakableWalls",
        "Pallets",
        "PowerCooldown"
      ],
      "mechanics": {
        "effect": "+20 %"
      },
      "character": 20
    },
    {
      "id": "rust_coloured_egg",
      "name": "Rust-Coloured Egg",
      "rarity": 4,
      "patch": "9.1.0",
      "tags": [
        "PowerRecovery"
      ],
      "mechanics": {
        "effect": "+30 %"
      },
      "character": 20
    },
    {
      "id": "scarlet_egg",
      "name": "Scarlet Egg",
      "rarity": 4,
      "patch": "9.1.0",
      "tags": [
        "Auras",
        "Torment"
      ],
      "mechanics": {
        "duration": "5 seconds"
      },
      "character": 20
    },
    {
      "id": "spearhead",
      "name": "Spearhead",
      "rarity": 2,
      "patch": "9.1.0",
      "tags": [
        "Auras",
        "CagesOfAtonement"
      ],
      "mechanics": {
        "duration": "8 seconds"
      },
      "character": 20
    },
    {
      "id": "tablet_of_the_oppressor",
      "name": "Tablet of the Oppressor",
      "rarity": 3,
      "patch": "9.1.0",
      "tags": [
        "Undetectable"
      ],
      "character": 20
    },
    {
      "id": "valtiel_sect_photograph",
      "name": "Valtiel Sect Photograph",
      "rarity": 3,
      "patch": "9.1.0",
      "tags": [
        "TerrorRadius",
        "Torment"
      ],
      "mechanics": {
        "radius": [
          "-2 metres",
          "-8 metres"
        ]
      },
      "character": 20
    },
    {
      "id": "wax_doll",
      "name": "Wax Doll",
      "rarity": 2,
      "patch": "9.1.0",
      "tags": [
        "AttackRange"
      ],
      "mechanics": {
        "range": "+5 %"
      },
      "character": 20
    },
    {
      "id": "adrenaline_vial",
      "name": "Adrenaline Vial",
      "rarity": 3,
      "patch": "7.5.0",
      "tags": [
        "CameraAngle",
        "Dash",
        "MovementSpeed",
        "PowerTokens",
        "TurnRate"
      ],
      "character": 21
    },
    {
      "id": "alchemist_s_ring",
      "name": "Alchemist's Ring",
      "rarity": 4,
      "patch": "7.5.0",
      "tags": [
        "Dash",
        "PowerDuration"
      ],
      "character": 21
    },
    {
      "id": "blighted_crow",
      "name": "Blighted Crow",
      "rarity": 3,
      "patch": "7.5.0",
      "tags": [
        "Dash",
        "MovementSpeed"
      ],
      "character": 21
    },
    {
      "id": "blighted_rat",
      "name": "Blighted Rat",
      "rarity": 2,
      "patch": "7.5.0",
      "tags": [
        "Dash",
        "MovementSpeed"
      ],
      "character": 21
    },
    {
      "id": "canker_thorn",
      "name": "Canker Thorn",
      "rarity": 2,
      "tags": [
        "Dash",
        "PowerCooldown"
      ],
      "character": 21
    },
    {
      "id": "chipped_monocle",
      "name": "Chipped Monocle",
      "rarity": 1,
      "tags": [
        "ExtendedAbility",
        "PowerIndicator",
        "Slam"
      ],
      "character": 21
    },
    {
      "id": "compound_seven",
      "name": "Compound Seven",
      "rarity": 1,
      "tags": [
        "ExtendedAbility",
        "Slam"
      ],
      "character": 21
    },
    {
      "id": "compound_thirty_three",
      "name": "Compound Thirty-Three",
      "rarity": 5,
      "patch": "8.0.0",
      "tags": [
        "Dash",
        "PowerDuration",
        "PowerTokens",
        "TurnRate"
      ],
      "character": 21
    },
    {
      "id": "compound_twenty_one",
      "name": "Compound Twenty-One",
      "rarity": 3,
      "tags": [
        "Auras",
        "Slam"
      ],
      "character": 21
    },
    {
      "id": "foxglove",
      "name": "Foxglove",
      "rarity": 1,
      "tags": [
        "Dash",
        "PowerCooldown"
      ],
      "character": 21
    },
    {
      "id": "iridescent_blight_tag",
      "name": "Iridescent Blight Tag",
      "rarity": 5,
      "patch": "8.0.0",
      "tags": [
        "CameraAngle",
        "Dash",
        "MovementSpeed",
        "PowerTokens"
      ],
      "character": 21
    },
    {
      "id": "placebo_tablet",
      "name": "Placebo Tablet",
      "rarity": 1,
      "tags": [
        "Bloodpoints",
        "Dash",
        "MovementSpeed"
      ],
      "character": 21
    },
    {
      "id": "plague_bile",
      "name": "Plague Bile",
      "rarity": 2,
      "tags": [
        "Dash",
        "TurnRate"
      ],
      "character": 21
    },
    {
      "id": "pustula_dust",
      "name": "Pustula Dust",
      "rarity": 2,
      "tags": [
        "PowerWindow"
      ],
      "character": 21
    },
    {
      "id": "rose_tonic",
      "name": "Rose Tonic",
      "rarity": 3,
      "tags": [
        "PowerWindow"
      ],
      "character": 21
    },
    {
      "id": "shredded_notes",
      "name": "Shredded Notes",
      "rarity": 2,
      "patch": "7.7.0",
      "tags": [
        "Dash",
        "PowerRecovery"
      ],
      "character": 21
    },
    {
      "id": "soul_chemical",
      "name": "Soul Chemical",
      "rarity": 4,
      "patch": "7.7.0",
      "tags": [
        "Dash",
        "MovementSpeed"
      ],
      "character": 21
    },
    {
      "id": "summoning_stone",
      "name": "Summoning Stone",
      "rarity": 4,
      "patch": "7.7.0",
      "tags": [
        "Dash",
        "PowerDuration"
      ],
      "character": 21
    },
    {
      "id": "umbra_salts",
      "name": "Umbra Salts",
      "rarity": 3,
      "tags": [
        "Dash",
        "TurnRate"
      ],
      "character": 21
    },
    {
      "id": "vigo_s_journal",
      "name": "Vigo's Journal",
      "rarity": 4,
      "tags": [
        "Dash",
        "Undetectable"
      ],
      "character": 21
    },
    {
      "id": "baby_teeth",
      "name": "Baby Teeth",
      "rarity": 2,
      "tags": [
        "Blindness",
        "Victor"
      ],
      "character": 22
    },
    {
      "id": "bloody_black_hood",
      "name": "Bloody Black Hood",
      "rarity": 2,
      "tags": [
        "Charlotte",
        "DormantState",
        "TransitionTime"
      ],
      "character": 22
    },
    {
      "id": "cat_s_eye",
      "name": "Cat's Eye",
      "rarity": 2,
      "tags": [
        "ActionNoise",
        "Lullaby",
        "Pounce",
        "Shriek",
        "Victor"
      ],
      "character": 22
    },
    {
      "id": "cat_figurine",
      "name": "Cat Figurine",
      "rarity": 1,
      "tags": [
        "ExtendedAbility",
        "PowerIndicator",
        "Victor"
      ],
      "character": 22
    },
    {
      "id": "ceremonial_candelabrum",
      "name": "Ceremonial Candelabrum",
      "rarity": 2,
      "tags": [
        "ActionTime",
        "Charlotte",
        "Victor"
      ],
      "character": 22
    },
    {
      "id": "drop_of_perfume",
      "name": "Drop of Perfume",
      "rarity": 4,
      "tags": [
        "Charlotte",
        "Lullaby",
        "Oblivious",
        "Shriek",
        "Victor"
      ],
      "character": 22
    },
    {
      "id": "forest_stew",
      "name": "Forest Stew",
      "rarity": 4,
      "tags": [
        "MovementSpeed",
        "Victor"
      ],
      "character": 22
    },
    {
      "id": "iridescent_pendant",
      "name": "Iridescent Pendant",
      "rarity": 5,
      "patch": "7.7.0",
      "tags": [
        "Charlotte",
        "Exposed",
        "Victor"
      ],
      "character": 22
    },
    {
      "id": "madeleine_s_glove",
      "name": "Madeleine's Glove",
      "rarity": 2,
      "tags": [
        "EffectRange",
        "Lullaby",
        "Shriek"
      ],
      "character": 22
    },
    {
      "id": "madeleine_s_scarf",
      "name": "Madeleine's Scarf",
      "rarity": 3,
      "tags": [
        "MovementSpeed",
        "Victor"
      ],
      "character": 22
    },
    {
      "id": "rusted_needle",
      "name": "Rusted Needle",
      "rarity": 3,
      "patch": "7.7.0",
      "tags": [
        "Haemorrhage",
        "Victor"
      ],
      "character": 22
    },
    {
      "id": "sewer_sludge",
      "name": "Sewer Sludge",
      "rarity": 3,
      "patch": "7.7.0",
      "tags": [
        "ActionTime",
        "Victor"
      ],
      "character": 22
    },
    {
      "id": "silencing_cloth",
      "name": "Silencing Cloth",
      "rarity": 5,
      "patch": "7.7.0",
      "tags": [
        "Charlotte",
        "DormantState",
        "Undetectable"
      ],
      "character": 22
    },
    {
      "id": "soured_milk",
      "name": "Soured Milk",
      "rarity": 1,
      "tags": [
        "EffectRange",
        "Lullaby",
        "Shriek"
      ],
      "character": 22
    },
    {
      "id": "spinning_top",
      "name": "Spinning Top",
      "rarity": 4,
      "tags": [
        "ItemDrop",
        "Pounce",
        "Victor"
      ],
      "character": 22
    },
    {
      "id": "stale_biscuit",
      "name": "Stale Biscuit",
      "rarity": 3,
      "tags": [
        "Pounce",
        "PowerCooldown",
        "Victor"
      ],
      "character": 22
    },
    {
      "id": "tiny_fingernail",
      "name": "Tiny Fingernail",
      "rarity": 1,
      "patch": "7.7.0",
      "tags": [
        "ActionTime",
        "Victor"
      ],
      "character": 22
    },
    {
      "id": "toy_sword",
      "name": "Toy Sword",
      "rarity": 1,
      "patch": "7.7.0",
      "tags": [
        "ActionTime",
        "Pounce",
        "Victor"
      ],
      "character": 22
    },
    {
      "id": "victor_s_soldier",
      "name": "Victor's Soldier",
      "rarity": 4,
      "tags": [
        "Auras",
        "Charlotte",
        "Victor"
      ],
      "character": 22
    },
    {
      "id": "weighty_rattle",
      "name": "Weighty Rattle",
      "rarity": 3,
      "patch": "7.7.0",
      "tags": [
        "Broken",
        "Victor"
      ],
      "character": 22
    },
    {
      "id": "bloody_boa",
      "name": "Bloody Boa",
      "rarity": 2,
      "patch": "9.5.2",
      "tags": [
        "DecayDelay"
      ],
      "character": 23
    },
    {
      "id": "caged_heart_shoes",
      "name": "Caged Heart Shoes",
      "rarity": 2,
      "patch": "9.5.0",
      "tags": [
        "MovementSpeed"
      ],
      "character": 23
    },
    {
      "id": "cut_thru_u_single",
      "name": "Cut Thru U Single",
      "rarity": 4,
      "patch": "9.5.0",
      "tags": [
        "ExtendedAbility",
        "Haste"
      ],
      "character": 23
    },
    {
      "id": "death_throes_compilation",
      "name": "Death Throes Compilation",
      "rarity": 5,
      "patch": "9.5.2",
      "tags": [
        "MainEvent",
        "PowerCapacity"
      ],
      "character": 23
    },
    {
      "id": "diamond_cufflinks",
      "name": "Diamond Cufflinks",
      "rarity": 4,
      "patch": "4.6.0",
      "tags": [
        "Auras"
      ],
      "character": 23
    },
    {
      "id": "edge_of_revival_album",
      "name": "Edge of Revival Album",
      "rarity": 4,
      "patch": "9.5.0",
      "tags": [
        "PowerEfficiency"
      ],
      "character": 23
    },
    {
      "id": "fizz_spin_soda",
      "name": "Fizz-Spin Soda",
      "rarity": 3,
      "patch": "9.5.2",
      "tags": [
        "PowerEfficiency"
      ],
      "character": 23
    },
    {
      "id": "inferno_wires",
      "name": "Inferno Wires",
      "rarity": 1,
      "patch": "9.5.2",
      "tags": [
        "PowerDuration"
      ],
      "character": 23
    },
    {
      "id": "iridescent_photocard",
      "name": "Iridescent Photocard",
      "rarity": 5,
      "patch": "9.5.0",
      "tags": [
        "MainEvent",
        "Auras"
      ],
      "character": 23
    },
    {
      "id": "ji_woon_s_autograph",
      "name": "Ji-Woon's Autograph",
      "rarity": 2,
      "patch": "9.5.0",
      "tags": [
        "MainEvent",
        "PowerDuration"
      ],
      "character": 23
    },
    {
      "id": "killing_part_chords",
      "name": "Killing Part Chords",
      "rarity": 1,
      "patch": "9.5.2",
      "tags": [
        "PowerDuration"
      ],
      "character": 23
    },
    {
      "id": "lucky_blade",
      "name": "Lucky Blade",
      "rarity": 2,
      "patch": "9.5.2",
      "tags": [
        "PowerEfficiency",
        "Haste"
      ],
      "character": 23
    },
    {
      "id": "melodious_murder",
      "name": "Melodious Murder",
      "rarity": 3,
      "patch": "9.5.0",
      "tags": [
        "ActionTime",
        "Lockers"
      ],
      "character": 23
    },
    {
      "id": "memento_blades",
      "name": "Memento Blades",
      "rarity": 1,
      "patch": "9.5.0",
      "tags": [
        "PowerIndicator"
      ],
      "character": 23
    },
    {
      "id": "on_target_single",
      "name": "On Target Single",
      "rarity": 3,
      "patch": "9.5.2",
      "tags": [
        "MainEvent"
      ],
      "character": 23
    },
    {
      "id": "ripper_brace",
      "name": "Ripper Brace",
      "rarity": 3,
      "patch": "9.5.2",
      "tags": [
        "BreakableWalls",
        "Pallets",
        "Windows"
      ],
      "character": 23
    },
    {
      "id": "tequila_moonrock",
      "name": "Tequila Moonrock",
      "rarity": 2,
      "patch": "9.5.2",
      "tags": [
        "PowerEfficiency"
      ],
      "character": 23
    },
    {
      "id": "trick_blades",
      "name": "Trick Blades",
      "rarity": 4,
      "patch": "9.5.0",
      "tags": [
        "ExtendedAbility"
      ],
      "character": 23
    },
    {
      "id": "trick_pouch",
      "name": "Trick Pouch",
      "rarity": 1,
      "patch": "9.5.2",
      "tags": [
        "PowerCapacity"
      ],
      "character": 23
    },
    {
      "id": "waiting_for_you_watch",
      "name": "Waiting For You Watch",
      "rarity": 3,
      "patch": "9.5.2",
      "tags": [
        "Auras"
      ],
      "character": 23
    },
    {
      "id": "admin_wristband",
      "name": "Admin Wristband",
      "rarity": 2,
      "tags": [
        "DetectionRange",
        "FOV",
        "Zombies"
      ],
      "character": 24
    },
    {
      "id": "adrenaline_injector",
      "name": "Adrenaline Injector",
      "rarity": 2,
      "tags": [
        "KillerInstinct",
        "Vaccine"
      ],
      "character": 24
    },
    {
      "id": "brian_s_intestine",
      "name": "Brian's Intestine",
      "rarity": 1,
      "tags": [
        "MovementSpeed",
        "Zombies"
      ],
      "character": 24
    },
    {
      "id": "broken_recovery_coin",
      "name": "Broken Recovery Coin",
      "rarity": 4,
      "tags": [
        "PowerCounter",
        "SupplyCases"
      ],
      "character": 24
    },
    {
      "id": "damaged_syringe",
      "name": "Damaged Syringe",
      "rarity": 1,
      "tags": [
        "ActionTime",
        "PowerCounter",
        "Vaccine"
      ],
      "character": 24
    },
    {
      "id": "depleted_ink_ribbon",
      "name": "Depleted Ink Ribbon",
      "rarity": 4,
      "tags": [
        "ExitGates",
        "ExtendedAbility",
        "MovementSpeed",
        "PowerCooldown",
        "Zombies"
      ],
      "character": 24
    },
    {
      "id": "iridescent_umbrella_badge",
      "name": "Iridescent Umbrella Badge",
      "rarity": 5,
      "tags": [
        "Exposed",
        "Vaccine"
      ],
      "character": 24
    },
    {
      "id": "jill_s_sandwich",
      "name": "Jill's Sandwich",
      "rarity": 4,
      "tags": [
        "Auras",
        "PowerCounter",
        "SupplyCases"
      ],
      "character": 24
    },
    {
      "id": "licker_tongue",
      "name": "Licker Tongue",
      "rarity": 3,
      "patch": "8.2.2",
      "tags": [
        "Hindered"
      ],
      "mechanics": {
        "effect": "+1 second",
        "durationHindered": "3 seconds"
      },
      "character": 24
    },
    {
      "id": "marvin_s_blood",
      "name": "Marvin's Blood",
      "rarity": 2,
      "patch": "8.2.0",
      "tags": [
        "PowerEfficiency"
      ],
      "character": 24
    },
    {
      "id": "mikhail_s_eye",
      "name": "Mikhail's Eye",
      "rarity": 2,
      "tags": [
        "MovementSpeed",
        "Zombies"
      ],
      "character": 24
    },
    {
      "id": "ne_a_parasite",
      "name": "NE-a Parasite",
      "rarity": 4,
      "tags": [
        "Oblivious",
        "Vaccine"
      ],
      "character": 24
    },
    {
      "id": "plant_43_vines",
      "name": "Plant 43 Vines",
      "rarity": 3,
      "tags": [
        "PowerCounter",
        "SupplyCases"
      ],
      "character": 24
    },
    {
      "id": "serotonin_injector",
      "name": "Serotonin Injector",
      "rarity": 3,
      "tags": [
        "Undetectable",
        "Zombies"
      ],
      "character": 24
    },
    {
      "id": "shattered_s_t_a_r_s_badge",
      "name": "Shattered S.T.A.R.S. Badge",
      "rarity": 5,
      "tags": [
        "MovementSpeed",
        "Zombies"
      ],
      "character": 24
    },
    {
      "id": "s_t_a_r_s_field_combat_manual",
      "name": "S.T.A.R.S. Field Combat Manual",
      "rarity": 1,
      "tags": [
        "Auras",
        "Zombies"
      ],
      "character": 24
    },
    {
      "id": "t_virus_sample",
      "name": "T-Virus Sample",
      "rarity": 3,
      "tags": [
        "PowerEfficiency",
        "Zombies"
      ],
      "character": 24
    },
    {
      "id": "tyrant_gore",
      "name": "Tyrant Gore",
      "rarity": 3,
      "tags": [
        "PowerCooldown",
        "PowerEfficiency",
        "Zombies"
      ],
      "character": 24
    },
    {
      "id": "visitor_wristband",
      "name": "Visitor Wristband",
      "rarity": 1,
      "tags": [
        "DetectionRange",
        "FOV",
        "Zombies"
      ],
      "character": 24
    },
    {
      "id": "zombie_heart",
      "name": "Zombie Heart",
      "rarity": 2,
      "tags": [
        "PowerEfficiency",
        "Zombies"
      ],
      "character": 24
    },
    {
      "id": "bent_nail",
      "name": "Bent Nail",
      "rarity": 1,
      "tags": [
        "Bloodpoints",
        "PowerObject",
        "PowerPenalty"
      ],
      "character": 25
    },
    {
      "id": "burning_candle",
      "name": "Burning Candle",
      "rarity": 1,
      "tags": [
        "ChainHunt",
        "PassiveCharge"
      ],
      "character": 25
    },
    {
      "id": "chatterer_s_tooth",
      "name": "Chatterer's Tooth",
      "rarity": 4,
      "tags": [
        "Auras",
        "ChainHunt",
        "ExtendedAbility",
        "LamentConfiguration",
        "PowerDeactivation",
        "Undetectable"
      ],
      "character": 25
    },
    {
      "id": "engineer_s_fang",
      "name": "Engineer's Fang",
      "rarity": 5,
      "tags": [
        "AutoDamage",
        "ActionTime",
        "Gateway",
        "PowerObject",
        "PowerPenalty"
      ],
      "character": 25
    },
    {
      "id": "flickering_television",
      "name": "Flickering Television",
      "rarity": 2,
      "tags": [
        "Gateway",
        "PowerRange"
      ],
      "character": 25
    },
    {
      "id": "frank_s_heart",
      "name": "Frank's Heart",
      "rarity": 3,
      "tags": [
        "Gateway\"; \"PowerRange"
      ],
      "character": 25
    },
    {
      "id": "greasy_black_lens",
      "name": "Greasy Black Lens",
      "rarity": 4,
      "tags": [
        "Auras"
      ],
      "character": 25
    },
    {
      "id": "impaling_wire",
      "name": "Impaling Wire",
      "rarity": 4,
      "tags": [
        "PowerObject"
      ],
      "character": 25
    },
    {
      "id": "iridescent_lament_configuration",
      "name": "Iridescent Lament Configuration",
      "rarity": 5,
      "tags": [
        "Auras",
        "ChainHunt",
        "KillerInstinct",
        "LamentConfiguration",
        "Oblivious",
        "Teleportation"
      ],
      "character": 25
    },
    {
      "id": "larry_s_blood",
      "name": "Larry's Blood",
      "rarity": 3,
      "tags": [
        "PowerRange"
      ],
      "character": 25
    },
    {
      "id": "larry_s_remains",
      "name": "Larry's Remains",
      "rarity": 3,
      "tags": [
        "ActionTime",
        "LamentConfiguration",
        "PowerCounter"
      ],
      "character": 25
    },
    {
      "id": "leather_strip",
      "name": "Leather Strip",
      "rarity": 1,
      "tags": [
        "PowerCooldown"
      ],
      "character": 25
    },
    {
      "id": "liquified_gore",
      "name": "Liquified Gore",
      "rarity": 2,
      "tags": [
        "ActionTime",
        "LamentConfiguration",
        "PowerCounter"
      ],
      "character": 25
    },
    {
      "id": "lively_crickets",
      "name": "Lively Crickets",
      "rarity": 1,
      "tags": [
        "TurnRate"
      ],
      "character": 25
    },
    {
      "id": "original_pain",
      "name": "Original Pain",
      "rarity": 4,
      "patch": "9.3.0",
      "tags": [
        "Auras"
      ],
      "mechanics": {
        "effect": "8 seconds"
      },
      "character": 25
    },
    {
      "id": "skewered_rat",
      "name": "Skewered Rat",
      "rarity": 2,
      "tags": [
        "PowerCooldown"
      ],
      "character": 25
    },
    {
      "id": "slice_of_frank",
      "name": "Slice of Frank",
      "rarity": 3,
      "tags": [
        "Exhausted",
        "LamentConfiguration"
      ],
      "character": 25
    },
    {
      "id": "spoiled_meal",
      "name": "Spoiled Meal",
      "rarity": 2,
      "tags": [
        "PowerRange"
      ],
      "character": 25
    },
    {
      "id": "torture_pillar",
      "name": "Torture Pillar",
      "rarity": 3,
      "tags": [
        "ChainHunt",
        "PassiveCharge"
      ],
      "character": 25
    },
    {
      "id": "wriggling_maggots",
      "name": "Wriggling Maggots",
      "rarity": 2,
      "tags": [
        "TurnRate"
      ],
      "character": 25
    },
    {
      "id": "automatic_drawing",
      "name": "Automatic Drawing",
      "rarity": 2,
      "tags": [
        "DireCrows",
        "PowerCooldown"
      ],
      "character": 26
    },
    {
      "id": "charcoal_stick",
      "name": "Charcoal Stick",
      "rarity": 3,
      "tags": [
        "Auras",
        "DireCrows",
        "PowerPenalty"
      ],
      "character": 26
    },
    {
      "id": "choclo_corn",
      "name": "Choclo Corn",
      "rarity": 1,
      "tags": [
        "DireCrows",
        "PowerDuration"
      ],
      "character": 26
    },
    {
      "id": "darkest_ink",
      "name": "Darkest Ink",
      "rarity": 3,
      "tags": [
        "Blindness",
        "DireCrows",
        "PowerCounter"
      ],
      "character": 26
    },
    {
      "id": "festering_carrion",
      "name": "Festering Carrion",
      "rarity": 2,
      "tags": [
        "DireCrows",
        "PowerCooldown"
      ],
      "character": 26
    },
    {
      "id": "garden_of_rot",
      "name": "Garden of Rot",
      "rarity": 5,
      "tags": [
        "DireCrows",
        "Exposed"
      ],
      "character": 26
    },
    {
      "id": "ink_egg",
      "name": "Ink Egg",
      "rarity": 4,
      "tags": [
        "DireCrows",
        "PowerCapacity",
        "PowerDuration"
      ],
      "character": 26
    },
    {
      "id": "iridescent_feather",
      "name": "Iridescent Feather",
      "rarity": 5,
      "tags": [
        "DireCrows",
        "Undetectable",
        "PowerCapacity"
      ],
      "character": 26
    },
    {
      "id": "matias_baby_shoes",
      "name": "Matias' Baby Shoes",
      "rarity": 4,
      "tags": [
        "Auras",
        "DireCrows"
      ],
      "character": 26
    },
    {
      "id": "o_grief_o_lover",
      "name": "O Grief, O Lover",
      "rarity": 3,
      "tags": [
        "DireCrows",
        "Exhausted"
      ],
      "character": 26
    },
    {
      "id": "oil_paints",
      "name": "Oil Paints",
      "rarity": 1,
      "tags": [
        "DireCrows",
        "EffectRange",
        "KillerInstinct"
      ],
      "character": 26
    },
    {
      "id": "severed_hands",
      "name": "Severed Hands",
      "rarity": 4,
      "tags": [
        "DireCrows",
        "ExtendedAbility"
      ],
      "character": 26
    },
    {
      "id": "severed_tongue",
      "name": "Severed Tongue",
      "rarity": 4,
      "tags": [
        "DireCrows",
        "MovementSpeed",
        "PowerPenalty"
      ],
      "character": 26
    },
    {
      "id": "silver_bell",
      "name": "Silver Bell",
      "rarity": 3,
      "tags": [
        "DireCrows",
        "Oblivious"
      ],
      "character": 26
    },
    {
      "id": "still_life_crow",
      "name": "Still Life Crow",
      "rarity": 2,
      "tags": [
        "DireCrows",
        "PowerDuration"
      ],
      "character": 26
    },
    {
      "id": "thick_tar",
      "name": "Thick Tar",
      "rarity": 1,
      "tags": [
        "ActionTime",
        "DireCrows"
      ],
      "character": 26
    },
    {
      "id": "thorny_nest",
      "name": "Thorny Nest",
      "rarity": 3,
      "patch": "7.6.0",
      "tags": [
        "DireCrows",
        "Haemorrhage",
        "Mangled"
      ],
      "character": 26
    },
    {
      "id": "untitled_agony",
      "name": "Untitled Agony",
      "rarity": 2,
      "tags": [
        "DireCrows",
        "Hindered"
      ],
      "character": 26
    },
    {
      "id": "velvet_fabric",
      "name": "Velvet Fabric",
      "rarity": 2,
      "tags": [
        "Auras",
        "DireCrows",
        "EffectDuration"
      ],
      "character": 26
    },
    {
      "id": "vibrant_obituary",
      "name": "Vibrant Obituary",
      "rarity": 1,
      "tags": [
        "EffectDuration",
        "KillerInstinct"
      ],
      "character": 26
    },
    {
      "id": "bloody_fingernails",
      "name": "Bloody Fingernails",
      "rarity": 3,
      "tags": [
        "MovementSpeed",
        "Projection"
      ],
      "character": 27
    },
    {
      "id": "cabin_sign",
      "name": "Cabin Sign",
      "rarity": 1,
      "tags": [
        "PowerCooldown",
        "Projection",
        "TVs"
      ],
      "character": 27
    },
    {
      "id": "clump_of_hair",
      "name": "Clump of Hair",
      "rarity": 2,
      "patch": "7.5.0",
      "tags": [
        "EffectRange",
        "PowerInvisibility"
      ],
      "mechanics": {
        "effect": "-6 metres"
      },
      "character": 27
    },
    {
      "id": "distorted_photo",
      "name": "Distorted Photo",
      "rarity": 4,
      "tags": [
        "Auras",
        "LoudNoiseNotifications",
        "Screams"
      ],
      "character": 27
    },
    {
      "id": "iridescent_videotape",
      "name": "Iridescent Videotape",
      "rarity": 5,
      "patch": "7.5.0",
      "tags": [
        "ExtendedAbility",
        "PowerCooldown",
        "PowerPenalty",
        "Projection",
        "TVs"
      ],
      "character": 27
    },
    {
      "id": "mother_s_comb",
      "name": "Mother's Comb",
      "rarity": 3,
      "tags": [
        "Auras",
        "ExtendedAbility",
        "LoudNoiseNotifications",
        "TVs"
      ],
      "character": 27
    },
    {
      "id": "mother_s_mirror",
      "name": "Mother's Mirror",
      "rarity": 1,
      "tags": [
        "EffectDuration",
        "PowerInvisibility"
      ],
      "character": 27
    },
    {
      "id": "old_newspaper",
      "name": "Old Newspaper",
      "rarity": 1,
      "tags": [
        "EffectDuration",
        "PowerInvisibility"
      ],
      "character": 27
    },
    {
      "id": "reiko_s_watch",
      "name": "Reiko's Watch",
      "rarity": 2,
      "patch": "7.5.0",
      "tags": [
        "EffectDuration",
        "PowerInvisibility"
      ],
      "character": 27
    },
    {
      "id": "remote_control",
      "name": "Remote Control",
      "rarity": 5,
      "tags": [
        "Auras",
        "Projection",
        "TVs"
      ],
      "character": 27
    },
    {
      "id": "rickety_pinwheel",
      "name": "Rickety Pinwheel",
      "rarity": 3,
      "tags": [
        "Oblivious",
        "TVs"
      ],
      "character": 27
    },
    {
      "id": "ring_drawing",
      "name": "Ring Drawing",
      "rarity": 3,
      "patch": "7.5.0",
      "tags": [
        "Condemned",
        "ExtendedAbility",
        "Hooks",
        "VHS"
      ],
      "character": 27
    },
    {
      "id": "sea_soaked_cloth",
      "name": "Sea-Soaked Cloth",
      "rarity": 2,
      "tags": [
        "Blindness",
        "TVs"
      ],
      "character": 27
    },
    {
      "id": "tape_editing_deck",
      "name": "Tape Editing Deck",
      "rarity": 4,
      "patch": "7.5.0",
      "tags": [
        "Auras",
        "ExtendedAbility",
        "VHS",
        "TV"
      ],
      "character": 27
    },
    {
      "id": "telephone",
      "name": "Telephone",
      "rarity": 4,
      "tags": [
        "Hindered"
      ],
      "character": 27
    },
    {
      "id": "vcr",
      "name": "VCR",
      "rarity": 4,
      "tags": [
        "ExtendedAbility",
        "Projection",
        "TVs"
      ],
      "character": 27
    },
    {
      "id": "videotape_copy",
      "name": "Videotape Copy",
      "rarity": 1,
      "patch": "7.5.0",
      "tags": [
        "Condemned",
        "EffectRange",
        "Projection",
        "TVs"
      ],
      "character": 27
    },
    {
      "id": "well_stone",
      "name": "Well Stone",
      "rarity": 2,
      "tags": [
        "PowerCooldown",
        "Projection",
        "TVs"
      ],
      "character": 27
    },
    {
      "id": "well_water",
      "name": "Well Water",
      "rarity": 3,
      "tags": [
        "EffectDuration",
        "Undetectable"
      ],
      "character": 27
    },
    {
      "id": "yoichi_s_fishing_net",
      "name": "Yoichi's Fishing Net",
      "rarity": 2,
      "tags": [
        "Blindness",
        "Condemned"
      ],
      "character": 27
    },
    {
      "id": "air_freshener",
      "name": "Air Freshener",
      "rarity": 2,
      "tags": [
        "PowerTokens"
      ],
      "character": 28
    },
    {
      "id": "boat_key",
      "name": "Boat Key",
      "rarity": 4,
      "patch": "8.2.0",
      "tags": [
        "Daytime",
        "ExitGates",
        "Lockers",
        "Locks",
        "MovementSpeed",
        "Teleportation"
      ],
      "character": 28
    },
    {
      "id": "broken_doll",
      "name": "Broken Doll",
      "rarity": 3,
      "tags": [
        "Nightfall",
        "PowerDuration"
      ],
      "character": 28
    },
    {
      "id": "burnt_letters",
      "name": "Burnt Letters",
      "rarity": 2,
      "tags": [
        "PowerEfficiency"
      ],
      "character": 28
    },
    {
      "id": "caffeine_tablets",
      "name": "Caffeine Tablets",
      "rarity": 1,
      "tags": [
        "Auras",
        "Lockers",
        "Locks",
        "Teleportation"
      ],
      "character": 28
    },
    {
      "id": "destroyed_pillow",
      "name": "Destroyed Pillow",
      "rarity": 3,
      "tags": [
        "PowerCooldown",
        "Nightfall"
      ],
      "character": 28
    },
    {
      "id": "fallen_shingle",
      "name": "Fallen Shingle",
      "rarity": 2,
      "tags": [
        "PowerEfficiency"
      ],
      "character": 28
    },
    {
      "id": "field_recorder",
      "name": "Field Recorder",
      "rarity": 4,
      "tags": [
        "Exhausted",
        "Generators",
        "Nightfall",
        "Remnant"
      ],
      "character": 28
    },
    {
      "id": "follower_s_cowl",
      "name": "Follower's Cowl",
      "rarity": 1,
      "tags": [
        "Daytime",
        "KillerInstinct",
        "Remnant"
      ],
      "character": 28
    },
    {
      "id": "haddie_s_calendar",
      "name": "Haddie's Calendar",
      "rarity": 2,
      "patch": "8.2.0",
      "tags": [
        "ActionTime",
        "Lockers",
        "Locks"
      ],
      "character": 28
    },
    {
      "id": "iridescent_wooden_plank",
      "name": "Iridescent Wooden Plank",
      "rarity": 5,
      "tags": [
        "ExtendedAbility",
        "Exposed",
        "Nightfall"
      ],
      "character": 28
    },
    {
      "id": "lavalier_microphone",
      "name": "Lavalier Microphone",
      "rarity": 4,
      "tags": [
        "Auras",
        "Deception",
        "Lockers",
        "PowerTokens"
      ],
      "character": 28
    },
    {
      "id": "malthinker_s_skull",
      "name": "Malthinker's Skull",
      "rarity": 2,
      "patch": "8.2.0",
      "tags": [
        "PowerEfficiency"
      ],
      "character": 28
    },
    {
      "id": "mortar_and_pestle",
      "name": "Mortar and Pestle",
      "rarity": 1,
      "tags": [
        "Remnant"
      ],
      "character": 28
    },
    {
      "id": "ottomarian_writing",
      "name": "Ottomarian Writing",
      "rarity": 3,
      "patch": "8.2.0",
      "tags": [
        "Daytime",
        "PowerCooldown"
      ],
      "character": 28
    },
    {
      "id": "sacrificial_knife",
      "name": "Sacrificial Knife",
      "rarity": 5,
      "tags": [
        "Lockers",
        "Nightfall",
        "WindowBlocker",
        "Windows"
      ],
      "character": 28
    },
    {
      "id": "tilling_blade",
      "name": "Tilling Blade",
      "rarity": 4,
      "patch": "7.6.0",
      "tags": [
        "Blindness",
        "Haemorrhage",
        "Mangled",
        "Nightfall"
      ],
      "character": 28
    },
    {
      "id": "war_helmet",
      "name": "War Helmet",
      "rarity": 3,
      "tags": [
        "EffectDuration",
        "KillerInstinct",
        "Nightfall"
      ],
      "character": 28
    },
    {
      "id": "wooden_plank",
      "name": "Wooden Plank",
      "rarity": 1,
      "tags": [
        "PowerEfficiency"
      ],
      "character": 28
    },
    {
      "id": "worry_stone",
      "name": "Worry Stone",
      "rarity": 3,
      "tags": [
        "Auras",
        "Lockers",
        "Locks"
      ],
      "character": 28
    },
    {
      "id": "bullhorn",
      "name": "Bullhorn",
      "rarity": 2,
      "patch": "6.2.0",
      "tags": [
        "FirstAidSpray",
        "Oblivious"
      ],
      "character": 29
    },
    {
      "id": "chalice_gold",
      "name": "Chalice (Gold)",
      "rarity": 2,
      "patch": "6.2.0",
      "tags": [
        "Bound",
        "PowerDuration",
        "PowerRange"
      ],
      "character": 29
    },
    {
      "id": "dark_sunglasses",
      "name": "Dark Sunglasses",
      "rarity": 4,
      "patch": "6.2.0",
      "tags": [
        "Undetectable"
      ],
      "character": 29
    },
    {
      "id": "egg_gold",
      "name": "Egg (Gold)",
      "rarity": 3,
      "patch": "9.6.0",
      "tags": [
        "Bound",
        "PowerWindow"
      ],
      "character": 29
    },
    {
      "id": "green_herb",
      "name": "Green Herb",
      "rarity": 4,
      "patch": "6.2.0",
      "tags": [
        "Bound",
        "PowerEfficiency"
      ],
      "character": 29
    },
    {
      "id": "helicopter_stick",
      "name": "Helicopter Stick",
      "rarity": 4,
      "patch": "6.2.0",
      "tags": [
        "Auras",
        "FirstAidSpray"
      ],
      "character": 29
    },
    {
      "id": "iridescent_uroboros_vial",
      "name": "Iridescent Uroboros Vial",
      "rarity": 5,
      "patch": "6.2.0",
      "tags": [
        "Exposed"
      ],
      "character": 29
    },
    {
      "id": "jewel_beetle",
      "name": "Jewel Beetle",
      "rarity": 1,
      "patch": "6.2.0",
      "tags": [
        "Bound",
        "Bloodpoints",
        "PowerDuration",
        "PowerPenalty",
        "PowerRange"
      ],
      "character": 29
    },
    {
      "id": "lab_photo",
      "name": "Lab Photo",
      "rarity": 5,
      "patch": "6.2.0",
      "tags": [
        "Bound",
        "Breakable Walls",
        "Pallets",
        "PowerPenalty"
      ],
      "character": 29
    },
    {
      "id": "leather_gloves",
      "name": "Leather Gloves",
      "rarity": 2,
      "patch": "8.4.0",
      "tags": [
        "PowerRecovery"
      ],
      "mechanics": {
        "effect": "-8 %"
      },
      "character": 29
    },
    {
      "id": "lion_medallion",
      "name": "Lion Medallion",
      "rarity": 2,
      "patch": "6.2.0",
      "tags": [
        "Bound",
        "PowerRange"
      ],
      "character": 29
    },
    {
      "id": "loose_crank",
      "name": "Loose Crank",
      "rarity": 2,
      "patch": "9.6.0",
      "tags": [
        "Bound",
        "MovementSpeed",
        "PowerWindow"
      ],
      "character": 29
    },
    {
      "id": "maiden_medallion",
      "name": "Maiden Medallion",
      "rarity": 3,
      "patch": "6.2.0",
      "tags": [
        "Blindness"
      ],
      "character": 29
    },
    {
      "id": "portable_safe",
      "name": "Portable Safe",
      "rarity": 3,
      "patch": "6.2.0",
      "tags": [
        "Haemorrhage"
      ],
      "character": 29
    },
    {
      "id": "r_p_d_shoulder_walkie",
      "name": "R.P.D. Shoulder Walkie",
      "rarity": 1,
      "patch": "6.2.0",
      "tags": [
        "Bound",
        "PowerDuration",
        "PowerRange"
      ],
      "character": 29
    },
    {
      "id": "red_herb",
      "name": "Red Herb",
      "rarity": 3,
      "patch": "6.2.0",
      "tags": [
        "ActionTime",
        "FirstAidSpray",
        "PowerCounter"
      ],
      "character": 29
    },
    {
      "id": "unicorn_medallion",
      "name": "Unicorn Medallion",
      "rarity": 1,
      "patch": "6.2.0",
      "tags": [
        "Bound",
        "PowerDuration",
        "PowerRange"
      ],
      "character": 29
    },
    {
      "id": "uroboros_tendril",
      "name": "Uroboros Tendril",
      "rarity": 1,
      "patch": "6.2.0",
      "tags": [
        "Bound",
        "MovementSpeed"
      ],
      "character": 29
    },
    {
      "id": "uroboros_virus",
      "name": "Uroboros Virus",
      "rarity": 4,
      "patch": "6.2.0",
      "tags": [
        "Auras"
      ],
      "character": 29
    },
    {
      "id": "video_conference_device",
      "name": "Video Conference Device",
      "rarity": 3,
      "patch": "6.2.0",
      "tags": [
        "PowerEfficiency"
      ],
      "character": 29
    },
    {
      "id": "battle_axe_head",
      "name": "Battle Axe Head",
      "rarity": 2,
      "patch": "8.1.0",
      "tags": [
        "Carnifex",
        "PowerCooldown"
      ],
      "character": 30
    },
    {
      "id": "blacksmith_s_hammer",
      "name": "Blacksmith's Hammer",
      "rarity": 4,
      "patch": "8.1.0",
      "tags": [
        "Broken",
        "Hunt"
      ],
      "character": 30
    },
    {
      "id": "broken_hilt",
      "name": "Broken Hilt",
      "rarity": 3,
      "patch": "8.1.0",
      "tags": [
        "Haemorrhage",
        "Mangled"
      ],
      "character": 30
    },
    {
      "id": "call_to_arms",
      "name": "Call to Arms",
      "rarity": 2,
      "patch": "9.1.0",
      "tags": [
        "MovementSpeed",
        "PowerRange"
      ],
      "mechanics": {
        "effects": [
          "+4 metres",
          "+7 %"
        ]
      },
      "character": 30
    },
    {
      "id": "cold_steel_manacles",
      "name": "Cold Steel Manacles",
      "rarity": 2,
      "patch": "8.1.0",
      "tags": [
        "Jailer",
        "PowerCooldown"
      ],
      "character": 30
    },
    {
      "id": "dried_horsemeat",
      "name": "Dried Horsemeat",
      "rarity": 2,
      "patch": "6.4.0",
      "tags": [
        "Hunt",
        "PowerDuration"
      ],
      "character": 30
    },
    {
      "id": "flint_and_steel",
      "name": "Flint and Steel",
      "rarity": 4,
      "patch": "8.1.0",
      "tags": [
        "Auras",
        "Carnifex",
        "Pallets"
      ],
      "character": 30
    },
    {
      "id": "grim_iron_mask",
      "name": "Grim Iron Mask",
      "rarity": 3,
      "patch": "8.1.0",
      "tags": [
        "Blindness",
        "Patrol"
      ],
      "character": 30
    },
    {
      "id": "gritty_lump",
      "name": "Gritty Lump",
      "rarity": 1,
      "patch": "6.4.0",
      "tags": [
        "MovementSpeed",
        "Patrol"
      ],
      "character": 30
    },
    {
      "id": "healing_poultice",
      "name": "Healing Poultice",
      "rarity": 4,
      "patch": "8.1.0",
      "tags": [
        "Assassin",
        "Auras"
      ],
      "character": 30
    },
    {
      "id": "iridescent_company_banner",
      "name": "Iridescent Company Banner",
      "rarity": 5,
      "patch": "8.1.0",
      "tags": [
        "ExitBlocker",
        "Hunt",
        "Patrol",
        "WindowBlocker"
      ],
      "character": 30
    },
    {
      "id": "ironworker_s_tongs",
      "name": "Ironworker's Tongs",
      "rarity": 3,
      "patch": "8.1.0",
      "tags": [
        "Hunt",
        "Oblivious"
      ],
      "character": 30
    },
    {
      "id": "sharpened_mount",
      "name": "Sharpened Mount",
      "rarity": 3,
      "patch": "8.1.0",
      "tags": [
        "ActionTime",
        "Standard"
      ],
      "character": 30
    },
    {
      "id": "knight_s_contract",
      "name": "Knight's Contract",
      "rarity": 5,
      "patch": "8.1.0",
      "tags": [
        "PowerDuration"
      ],
      "character": 30
    },
    {
      "id": "map_of_the_realm",
      "name": "Map of the Realm",
      "rarity": 1,
      "patch": "8.1.0",
      "tags": [
        "DetectionRange",
        "Patrol"
      ],
      "character": 30
    },
    {
      "id": "pillaged_mead",
      "name": "Pillaged Mead",
      "rarity": 1,
      "patch": "8.1.0",
      "tags": [
        "ActionTime",
        "BreakableWalls",
        "Generators",
        "Pallets"
      ],
      "character": 30
    },
    {
      "id": "jailer_s_chimes",
      "name": "Jailer's Chimes",
      "rarity": 4,
      "patch": "8.1.0",
      "tags": [
        "Auras",
        "Jailer",
        "PatrolPath"
      ],
      "character": 30
    },
    {
      "id": "tattered_tabard",
      "name": "Tattered Tabard",
      "rarity": 1,
      "patch": "6.4.0",
      "tags": [
        "Patrol",
        "PowerDuration"
      ],
      "character": 30
    },
    {
      "id": "town_watch_s_torch",
      "name": "Town Watch's Torch",
      "rarity": 3,
      "patch": "8.1.0",
      "tags": [
        "Hunt",
        "Undetectable"
      ],
      "character": 30
    },
    {
      "id": "treated_blade",
      "name": "Treated Blade",
      "rarity": 2,
      "patch": "8.1.0",
      "tags": [
        "Assassin",
        "PowerCooldown"
      ],
      "character": 30
    },
    {
      "id": "adaptive_lighting",
      "name": "Adaptive Lighting",
      "rarity": 2,
      "patch": "6.6.0",
      "tags": [
        "Undetectable",
        "PowerDuration"
      ],
      "mechanics": {
        "effect": "+20 %",
        "undetectable": "9.6 seconds"
      },
      "character": 31
    },
    {
      "id": "adi_valente_issue_1",
      "name": "Adi Valente Issue 1",
      "rarity": 1,
      "patch": "6.6.0",
      "tags": [
        "ClawTraps",
        "SkillCheckDifficulty",
        "SkillChecks"
      ],
      "character": 31
    },
    {
      "id": "advanced_movement_prediction",
      "name": "Advanced Movement Prediction",
      "rarity": 4,
      "patch": "6.6.0",
      "tags": [
        "Auras",
        "ClawTraps"
      ],
      "character": 31
    },
    {
      "id": "brown_noise_generator",
      "name": "Brown Noise Generator",
      "rarity": 3,
      "patch": "6.6.0",
      "tags": [
        "ClawTraps",
        "Oblivious"
      ],
      "character": 31
    },
    {
      "id": "expired_batteries",
      "name": "Expired Batteries",
      "rarity": 5,
      "patch": "8.3.0",
      "tags": [
        "ClawTraps",
        "PowerPenalty"
      ],
      "mechanics": {
        "firstBattery": "50 %",
        "secondBattery": "100 %",
        "batteryBonus": "+10 %",
        "batteryLimit": "150 %"
      },
      "character": 31
    },
    {
      "id": "geographical_readout",
      "name": "Geographical Readout",
      "rarity": 4,
      "patch": "6.6.0",
      "tags": [
        "ActionSpeed",
        "BreakableWalls",
        "Drones",
        "Generators",
        "Pallets",
        "Windows"
      ],
      "character": 31
    },
    {
      "id": "high_current_upgrade",
      "name": "High-Current Upgrade",
      "rarity": 1,
      "patch": "6.6.0",
      "tags": [
        "EffectDuration",
        "Radar"
      ],
      "character": 31
    },
    {
      "id": "high_power_floodlight",
      "name": "High-Power Floodlight",
      "rarity": 1,
      "patch": "6.6.0",
      "tags": [
        "Blindness",
        "ClawTraps"
      ],
      "character": 31
    },
    {
      "id": "infrared_upgrade",
      "name": "Infrared Upgrade",
      "rarity": 3,
      "patch": "6.6.0",
      "tags": [
        "Auras",
        "ClawTraps"
      ],
      "character": 31
    },
    {
      "id": "iridescent_unpublished_manuscript",
      "name": "Iridescent Unpublished Manuscript",
      "rarity": 5,
      "patch": "7.3.0",
      "tags": [
        "Deception",
        "Drones",
        "PowerCooldown",
        "TerrorRadius",
        "Undetectable"
      ],
      "mechanics": {
        "radius": "32 metres",
        "duration": "15 seconds",
        "undetectable": "15 seconds"
      },
      "character": 31
    },
    {
      "id": "loose_screw",
      "name": "Loose Screw",
      "rarity": 3,
      "patch": "6.6.0",
      "tags": [
        "ClawTraps",
        "Exhausted"
      ],
      "character": 31
    },
    {
      "id": "low_power_mode",
      "name": "Low-Power Mode",
      "rarity": 2,
      "patch": "6.6.0",
      "tags": [
        "Drones",
        "ScanLines"
      ],
      "character": 31
    },
    {
      "id": "powdered_glass",
      "name": "Powdered Glass",
      "rarity": 3,
      "patch": "7.6.0",
      "tags": [
        "ClawTraps",
        "Haemorrhage",
        "Mangled"
      ],
      "character": 31
    },
    {
      "id": "prototype_rotor",
      "name": "Prototype Rotor",
      "rarity": 4,
      "patch": "6.6.0",
      "tags": [
        "Drones",
        "ScanLines"
      ],
      "character": 31
    },
    {
      "id": "randomised_strobes",
      "name": "Randomised Strobes",
      "rarity": 4,
      "patch": "6.6.0",
      "tags": [
        "ClawTraps",
        "Drones",
        "Hindered"
      ],
      "character": 31
    },
    {
      "id": "shotgun_speakers",
      "name": "Shotgun Speakers",
      "rarity": 2,
      "patch": "6.6.0",
      "tags": [
        "ActionNoise",
        "ClawTraps",
        "SkillChecks"
      ],
      "character": 31
    },
    {
      "id": "stereo_remote_mic",
      "name": "Stereo Remote Mic",
      "rarity": 2,
      "patch": "6.6.0",
      "tags": [
        "Drones",
        "PowerCooldown"
      ],
      "character": 31
    },
    {
      "id": "supercharge",
      "name": "Supercharge",
      "rarity": 2,
      "patch": "6.6.0",
      "tags": [
        "ClawTraps",
        "EffectDuration"
      ],
      "character": 31
    },
    {
      "id": "ultrasonic_speaker",
      "name": "Ultrasonic Speaker",
      "rarity": 1,
      "patch": "8.3.0",
      "tags": [
        "Drones",
        "PowerPenalty"
      ],
      "mechanics": {
        "effect": "90 %"
      },
      "character": 31
    },
    {
      "id": "vital_targeting_processor",
      "name": "Vital Targeting Processor",
      "rarity": 3,
      "patch": "8.3.0",
      "tags": [
        "ClawTraps",
        "Drones",
        "Hindered"
      ],
      "mechanics": {
        "hindered": "-2 %"
      },
      "character": 31
    },
    {
      "id": "android_arm",
      "name": "Android Arm",
      "rarity": 2,
      "patch": "8.1.0",
      "tags": [
        "PowerEfficiency",
        "PowerRange"
      ],
      "character": 32
    },
    {
      "id": "broken_security_key",
      "name": "Broken Security Key",
      "rarity": 1,
      "patch": "7.0.0",
      "tags": [
        "Biopods",
        "PowerCooldown"
      ],
      "character": 32
    },
    {
      "id": "cremated_remains",
      "name": "Cremated Remains",
      "rarity": 2,
      "patch": "7.0.0",
      "tags": [
        "Blindness"
      ],
      "character": 32
    },
    {
      "id": "crew_manifest",
      "name": "Crew Manifest",
      "rarity": 4,
      "patch": "7.0.0",
      "tags": [
        "Auras",
        "Biopods",
        "PowerRange"
      ],
      "mechanics": {
        "duration": "8 seconds",
        "range": "+2 metres"
      },
      "character": 32
    },
    {
      "id": "cryo_gel",
      "name": "Cryo Gel",
      "rarity": 2,
      "patch": "8.1.0",
      "tags": [
        "Haemorrhage"
      ],
      "mechanics": {
        "haemorrhage": "60 seconds"
      },
      "character": 32
    },
    {
      "id": "denied_requisition_form",
      "name": "Denied Requisition Form",
      "rarity": 5,
      "patch": "7.0.0",
      "tags": [
        "EMPs",
        "PowerCounter",
        "PowerEfficiency"
      ],
      "character": 32
    },
    {
      "id": "diagnostic_tool_construction",
      "name": "Diagnostic Tool (Construction)",
      "rarity": 4,
      "patch": "8.1.0",
      "tags": [
        "Auras"
      ],
      "character": 32
    },
    {
      "id": "diagnostic_tool_repair",
      "name": "Diagnostic Tool (Repair)",
      "rarity": 1,
      "patch": "8.1.0",
      "tags": [
        "Biopods",
        "PowerRange"
      ],
      "character": 32
    },
    {
      "id": "foreign_plant_fibres",
      "name": "Foreign Plant Fibres",
      "rarity": 4,
      "patch": "7.0.0",
      "tags": [
        "MovementSpeed",
        "Pallets"
      ],
      "character": 32
    },
    {
      "id": "heavy_water",
      "name": "Heavy Water",
      "rarity": 1,
      "patch": "7.0.0",
      "tags": [
        "Auras",
        "SupplyCases"
      ],
      "character": 32
    },
    {
      "id": "hologram_generator",
      "name": "Hologram Generator",
      "rarity": 3,
      "patch": "7.0.0",
      "tags": [
        "Biopods",
        "Oblivious"
      ],
      "character": 32
    },
    {
      "id": "hyperawareness_spray",
      "name": "Hyperawareness Spray",
      "rarity": 3,
      "patch": "7.0.0",
      "tags": [
        "Illusions",
        "TerrorRadius"
      ],
      "character": 32
    },
    {
      "id": "iridescent_crystal_shard",
      "name": "Iridescent Crystal Shard",
      "rarity": 5,
      "patch": "8.1.0",
      "tags": [
        "Auras",
        "Biopods"
      ],
      "character": 32
    },
    {
      "id": "kid_s_ball_glove",
      "name": "Kid's Ball Glove",
      "rarity": 2,
      "patch": "8.1.0",
      "tags": [
        "PowerDuration"
      ],
      "character": 32
    },
    {
      "id": "live_wires",
      "name": "Live Wires",
      "rarity": 3,
      "patch": "7.0.0",
      "tags": [
        "Screams"
      ],
      "character": 32
    },
    {
      "id": "nanomachine_gel",
      "name": "Nanomachine Gel",
      "rarity": 3,
      "patch": "8.1.0",
      "tags": [
        "PowerCooldown"
      ],
      "mechanics": {
        "effect": "-15 %"
      },
      "character": 32
    },
    {
      "id": "nutritional_slurry",
      "name": "Nutritional Slurry",
      "rarity": 1,
      "patch": "7.0.0",
      "tags": [
        "Biopods",
        "PowerObject"
      ],
      "character": 32
    },
    {
      "id": "soma_family_photo",
      "name": "Soma Family Photo",
      "rarity": 4,
      "patch": "9.3.0",
      "tags": [
        "Biopods",
        "DeepWound",
        "Hindered"
      ],
      "mechanics": {
        "hindered": "-3 %",
        "durationHindered": "6 seconds"
      },
      "character": 32
    },
    {
      "id": "spent_oxygen_tank",
      "name": "Spent Oxygen Tank",
      "rarity": 3,
      "patch": "7.0.0",
      "tags": [
        "Exhausted"
      ],
      "mechanics": {
        "exhausted": "6 seconds"
      },
      "character": 32
    },
    {
      "id": "ultrasonic_sensor",
      "name": "Ultrasonic Sensor",
      "rarity": 2,
      "patch": "8.1.0",
      "tags": [
        "Biopods",
        "ExtendedAbility",
        "TerrorRadius"
      ],
      "character": 32
    },
    {
      "id": "acidic_blood",
      "name": "Acidic Blood",
      "rarity": 5,
      "patch": "7.2.0",
      "tags": [
        "AutoDamage",
        "CrawlerMode",
        "DeepWound",
        "KillerStun",
        "Tunnels"
      ],
      "mechanics": {
        "windowOfOpportunity": "20 seconds",
        "healthState": 1
      },
      "character": 33
    },
    {
      "id": "ash_s_innards",
      "name": "Ash's Innards",
      "rarity": 2,
      "patch": "8.6.0",
      "tags": [
        "PowerCounter",
        "Turrets"
      ],
      "mechanics": {
        "effect": "+15 seconds"
      },
      "character": 33
    },
    {
      "id": "brett_s_cap",
      "name": "Brett's Cap",
      "rarity": 2,
      "patch": "7.2.0",
      "tags": [
        "Blindness",
        "PowerCounter",
        "Turrets"
      ],
      "mechanics": {
        "range": "16 metres",
        "blindness": "25 seconds"
      },
      "character": 33
    },
    {
      "id": "cat_carrier",
      "name": "Cat Carrier",
      "rarity": 4,
      "patch": "7.2.0",
      "tags": [
        "CrawlerMode",
        "PowerCounter",
        "Turrets",
        "Undetectable"
      ],
      "mechanics": {
        "undetectable": "30 seconds"
      },
      "character": 33
    },
    {
      "id": "cereal_rations",
      "name": "Cereal Rations",
      "rarity": 1,
      "patch": "7.2.0",
      "tags": [
        "Auras",
        "Tunnels",
        "Turrets"
      ],
      "mechanics": {
        "linger": "3 seconds"
      },
      "character": 33
    },
    {
      "id": "crew_headset",
      "name": "Crew Headset",
      "rarity": 2,
      "patch": "7.2.0",
      "tags": [
        "DetectionRange",
        "Tunnels"
      ],
      "mechanics": {
        "effect": "+6 metres"
      },
      "character": 33
    },
    {
      "id": "drinking_bird",
      "name": "Drinking Bird",
      "rarity": 1,
      "patch": "8.6.0",
      "tags": [
        "KillerInstinct",
        "Tunnels"
      ],
      "mechanics": {
        "effect": "+3 seconds"
      },
      "character": 33
    },
    {
      "id": "emergency_helmet",
      "name": "Emergency Helmet",
      "rarity": 3,
      "patch": "7.2.0",
      "tags": [
        "StaggerResistance",
        "Turrets"
      ],
      "mechanics": {
        "effect": "+15 %"
      },
      "character": 33
    },
    {
      "id": "harpoon_gun",
      "name": "Harpoon Gun",
      "rarity": 4,
      "patch": "8.6.0",
      "tags": [
        "LoudNoiseNotifications",
        "Screams",
        "Tunnels"
      ],
      "mechanics": {
        "windowOfOpportunity": "30 seconds",
        "range": "16 metres"
      },
      "character": 33
    },
    {
      "id": "improvised_cattle_prod",
      "name": "Improvised Cattle Prod",
      "rarity": 5,
      "patch": "7.2.0",
      "tags": [
        "Auras",
        "ControlStations",
        "Generators"
      ],
      "mechanics": {
        "windowOfOpportunity": "15 seconds",
        "range": "10 metres",
        "duration": "15 seconds"
      },
      "character": 33
    },
    {
      "id": "kane_s_helmet",
      "name": "Kane's Helmet",
      "rarity": 3,
      "patch": "7.6.0",
      "tags": [
        "AlternateAttack",
        "Mangled"
      ],
      "mechanics": {
        "mangled": "70 seconds"
      },
      "character": 33
    },
    {
      "id": "lambert_s_star_map",
      "name": "Lambert's Star Map",
      "rarity": 2,
      "patch": "7.2.0",
      "tags": [
        "EffectRange",
        "PowerCounter",
        " Turrets"
      ],
      "mechanics": {
        "effect": "-2 metres"
      },
      "character": 33
    },
    {
      "id": "light_wand",
      "name": "Light Wand",
      "rarity": 2,
      "patch": "8.6.0",
      "tags": [
        "PowerCounter",
        "Tunnels"
      ],
      "mechanics": {
        "effect": "+3 seconds"
      },
      "character": 33
    },
    {
      "id": "moulted_skin",
      "name": "Moulted Skin",
      "rarity": 3,
      "patch": "8.6.0",
      "tags": [
        "Exhausted",
        "Turrets"
      ],
      "mechanics": {
        "exhausted": "30 seconds"
      },
      "character": 33
    },
    {
      "id": "multipurpose_hatchet",
      "name": "Multipurpose Hatchet",
      "rarity": 3,
      "patch": "7.2.0",
      "tags": [
        "AlternateAttack",
        "Haemorrhage"
      ],
      "character": 33
    },
    {
      "id": "ovomorph",
      "name": "Ovomorph",
      "rarity": 1,
      "patch": "7.2.0",
      "tags": [
        "CrawlerMode",
        "PowerRecovery",
        "Tunnels"
      ],
      "mechanics": {
        "effect": "+25 %"
      },
      "character": 33
    },
    {
      "id": "parker_s_headband",
      "name": "Parker's Headband",
      "rarity": 3,
      "patch": "7.2.0",
      "tags": [
        "Haste",
        "Tunnels"
      ],
      "mechanics": {
        "haste": "+5 %",
        "durationHaste": "3 seconds"
      },
      "character": 33
    },
    {
      "id": "ripley_s_watch",
      "name": "Ripley's Watch",
      "rarity": 1,
      "patch": "7.2.0",
      "tags": [
        "CrawlerMode",
        "PowerCounter",
        "Turrets"
      ],
      "character": 33
    },
    {
      "id": "self_destruct_bolt",
      "name": "Self-Destruct Bolt",
      "rarity": 4,
      "patch": "7.2.0",
      "tags": [
        "ActionSpeed",
        "CrawlerMode",
        "Vaulting"
      ],
      "mechanics": {
        "effect": "+30 %"
      },
      "character": 33
    },
    {
      "id": "semiotic_keyboard",
      "name": "Semiotic Keyboard",
      "rarity": 4,
      "patch": "7.2.0",
      "tags": [
        "Auras",
        "Generators",
        "Turrets"
      ],
      "mechanics": {
        "range": "16 metres"
      },
      "character": 33
    },
    {
      "id": "automatic_screwdriver",
      "name": "Automatic Screwdriver",
      "rarity": 2,
      "patch": "8.0.1",
      "tags": [
        "PowerCooldown"
      ],
      "character": 34
    },
    {
      "id": "doll_eyes",
      "name": "Doll Eyes",
      "rarity": 1,
      "patch": "7.4.0",
      "tags": [
        "Auras",
        "Pallets",
        "Windows"
      ],
      "character": 34
    },
    {
      "id": "electric_carving_knife",
      "name": "Electric Carving Knife",
      "rarity": 2,
      "patch": "7.4.0",
      "tags": [
        "PowerCooldown"
      ],
      "character": 34
    },
    {
      "id": "good_guy_box",
      "name": "Good Guy Box",
      "rarity": 1,
      "patch": "7.4.0",
      "tags": [
        "PowerCooldown"
      ],
      "character": 34
    },
    {
      "id": "hair_spray_candle",
      "name": "Hair Spray & Candle",
      "rarity": 2,
      "patch": "7.4.0",
      "tags": [
        "PowerPenalty"
      ],
      "character": 34
    },
    {
      "id": "hard_hat",
      "name": "Hard Hat",
      "rarity": 5,
      "patch": "8.0.0",
      "tags": [
        "Pallets"
      ],
      "character": 34
    },
    {
      "id": "iridescent_amulet",
      "name": "Iridescent Amulet",
      "rarity": 5,
      "patch": "7.4.0",
      "tags": [
        "PowerDuration"
      ],
      "character": 34
    },
    {
      "id": "jump_rope_playtime_s_over",
      "name": "Jump Rope (Playtime's Over)",
      "rarity": 2,
      "patch": "7.4.0",
      "tags": [
        "PowerDuration"
      ],
      "mechanics": {
        "multiName": true
      },
      "character": 34
    },
    {
      "id": "mirror_shards_playtime_s_over",
      "name": "Mirror Shards (Playtime's Over)",
      "rarity": 4,
      "patch": "7.4.0",
      "tags": [
        "ExtendedAbility"
      ],
      "mechanics": {
        "multiName": true
      },
      "character": 34
    },
    {
      "id": "pile_of_nails",
      "name": "Pile of Nails",
      "rarity": 4,
      "patch": "8.0.0",
      "tags": [
        "Undetectable"
      ],
      "character": 34
    },
    {
      "id": "plastic_bag",
      "name": "Plastic Bag",
      "rarity": 4,
      "patch": "7.4.0",
      "tags": [
        "Exhausted"
      ],
      "character": 34
    },
    {
      "id": "portable_tv",
      "name": "Portable TV",
      "rarity": 3,
      "patch": "7.4.0",
      "tags": [
        "ExitGates",
        "PowerDuration"
      ],
      "character": 34
    },
    {
      "id": "power_drill",
      "name": "Power Drill",
      "rarity": 2,
      "patch": "8.0.1",
      "tags": [
        "PowerCooldown"
      ],
      "character": 34
    },
    {
      "id": "rat_poison",
      "name": "Rat Poison",
      "rarity": 3,
      "patch": "8.4.0",
      "tags": [
        "Auras"
      ],
      "mechanics": {
        "range": "6 metres",
        "duration": "2.5 seconds"
      },
      "character": 34
    },
    {
      "id": "running_shoes",
      "name": "Running Shoes",
      "rarity": 3,
      "patch": "7.4.0",
      "tags": [
        "Haste"
      ],
      "character": 34
    },
    {
      "id": "silk_pillow",
      "name": "Silk Pillow",
      "rarity": 3,
      "patch": "7.4.0",
      "tags": [
        "ActionTime",
        "TerrorRadius"
      ],
      "character": 34
    },
    {
      "id": "straight_razor",
      "name": "Straight Razor",
      "rarity": 4,
      "patch": "7.6.0",
      "tags": [
        "Haemorrhage",
        "Mangled"
      ],
      "character": 34
    },
    {
      "id": "strobing_light",
      "name": "Strobing Light",
      "rarity": 1,
      "patch": "8.0.0",
      "tags": [
        "TerrorRadius"
      ],
      "character": 34
    },
    {
      "id": "tiny_scalpel",
      "name": "Tiny Scalpel",
      "rarity": 1,
      "patch": "7.4.0",
      "tags": [
        "PoolsOfBlood"
      ],
      "character": 34
    },
    {
      "id": "yardstick",
      "name": "Yardstick",
      "rarity": 3,
      "patch": "8.0.0",
      "tags": [
        "Auras"
      ],
      "character": 34
    },
    {
      "id": "blurry_photo",
      "name": "Blurry Photo",
      "rarity": 1,
      "patch": "8.3.0",
      "tags": [
        "MovementSpeed",
        "PowerCooldown"
      ],
      "mechanics": {
        "effect": "+7 %"
      },
      "character": 35
    },
    {
      "id": "b_movie_poster",
      "name": "B-Movie Poster",
      "rarity": 3,
      "patch": "7.6.0",
      "tags": [
        "Broken"
      ],
      "mechanics": {
        "broken": "30 seconds"
      },
      "character": 35
    },
    {
      "id": "captured_by_the_dark",
      "name": "Captured by the Dark",
      "rarity": 5,
      "patch": "7.6.0",
      "tags": [
        "Illusions",
        "PowerObject",
        "PowerCooldown"
      ],
      "mechanics": {
        "effect": 1
      },
      "character": 35
    },
    {
      "id": "device_of_undisclosed_origin",
      "name": "Device of Undisclosed Origin",
      "rarity": 2,
      "patch": "7.6.0",
      "tags": [
        "Illusions",
        "Oblivious"
      ],
      "character": 35
    },
    {
      "id": "discarded_milk_carton",
      "name": "Discarded Milk Carton",
      "rarity": 4,
      "patch": "7.6.0",
      "tags": [
        "ExtendedAbility"
      ],
      "mechanics": {
        "effect": [
          "+8 %",
          "-15 %"
        ]
      },
      "character": 35
    },
    {
      "id": "footprint_cast",
      "name": "Footprint Cast",
      "rarity": 3,
      "patch": "7.6.0",
      "tags": [
        "Illusions",
        "PowerCooldown"
      ],
      "mechanics": {
        "effect": "-15 seconds"
      },
      "character": 35
    },
    {
      "id": "front_page_article",
      "name": "Front-Page Article",
      "rarity": 3,
      "patch": "7.6.0",
      "tags": [
        "BreakableWalls",
        "Pallets",
        "PowerCooldown"
      ],
      "mechanics": {
        "effect": "-50 %"
      },
      "character": 35
    },
    {
      "id": "homemade_mask",
      "name": "Homemade Mask",
      "rarity": 4,
      "patch": "7.6.0",
      "tags": [
        "Blindness",
        "Illusions"
      ],
      "mechanics": {
        "blindness": "60 seconds"
      },
      "character": 35
    },
    {
      "id": "hypnotist_s_watch",
      "name": "Hypnotist's Watch",
      "rarity": 3,
      "patch": "7.6.0",
      "tags": [
        "Exhausted"
      ],
      "mechanics": {
        "exhausted": "15 seconds"
      },
      "character": 35
    },
    {
      "id": "iridescent_oss_report",
      "name": "Iridescent OSS Report",
      "rarity": 5,
      "patch": "7.6.0",
      "tags": [
        "PowerCooldown",
        "TerrorRadius"
      ],
      "mechanics": {
        "effect": [
          "-5 seconds",
          "+10 seconds"
        ]
      },
      "character": 35
    },
    {
      "id": "last_known_recording",
      "name": "Last Known Recording",
      "rarity": 2,
      "patch": "7.6.0",
      "tags": [
        "Auras",
        "Illusions"
      ],
      "mechanics": {
        "effect": "-35 %"
      },
      "character": 35
    },
    {
      "id": "notebook_of_theories",
      "name": "Notebook of Theories",
      "rarity": 2,
      "patch": "7.6.0",
      "tags": [
        "Hindered"
      ],
      "mechanics": {
        "effect": "+2 seconds",
        "hindered": "5 seconds"
      },
      "character": 35
    },
    {
      "id": "obscure_game_cartridge",
      "name": "Obscure Game Cartridge",
      "rarity": 4,
      "patch": "7.6.0",
      "tags": [
        "BreakableWalls",
        "Pallets"
      ],
      "mechanics": {
        "effect": [
          "20 seconds",
          "+30 %"
        ]
      },
      "character": 35
    },
    {
      "id": "punctured_eyeball",
      "name": "Punctured Eyeball",
      "rarity": 1,
      "patch": "7.6.0",
      "tags": [
        "DeepWound",
        "Illusions"
      ],
      "character": 35
    },
    {
      "id": "rabbit_s_foot",
      "name": "Rabbit's Foot",
      "rarity": 1,
      "patch": "7.6.0",
      "tags": [
        "ExtendedAbility",
        "Haemorrhage"
      ],
      "mechanics": {
        "haemorrhage": "45 seconds"
      },
      "character": 35
    },
    {
      "id": "serum_vial",
      "name": "Serum Vial",
      "rarity": 4,
      "patch": "7.6.0",
      "tags": [
        "Exhausted",
        "Illusions"
      ],
      "mechanics": {
        "exhausted": "15 seconds"
      },
      "character": 35
    },
    {
      "id": "sketch_attempt",
      "name": "Sketch Attempt",
      "rarity": 1,
      "patch": "7.6.0",
      "tags": [
        "Oblivious"
      ],
      "mechanics": {
        "oblivious": "20 seconds"
      },
      "character": 35
    },
    {
      "id": "slashed_backpack",
      "name": "Slashed Backpack",
      "rarity": 2,
      "patch": "7.6.0",
      "tags": [
        "Illusions",
        "PowerCooldown"
      ],
      "mechanics": {
        "effect": "-65 %"
      },
      "character": 35
    },
    {
      "id": "vanishing_box",
      "name": "Vanishing Box",
      "rarity": 3,
      "patch": "8.3.0",
      "tags": [
        "Generators",
        "Illusions",
        "PowerCooldown"
      ],
      "mechanics": {
        "effect": "+120 %"
      },
      "character": 35
    },
    {
      "id": "victim_s_map",
      "name": "Victim's Map",
      "rarity": 2,
      "patch": "7.6.0",
      "tags": [
        "KillerInstinct"
      ],
      "mechanics": {
        "killerInstinct": "3 seconds"
      },
      "character": 35
    },
    {
      "id": "bag_of_holding",
      "name": "Bag of Holding",
      "rarity": 4,
      "patch": "8.0.0",
      "tags": [
        "Oblivious"
      ],
      "mechanics": {
        "amount": 2,
        "diceRoll": 1,
        "oblivious": "15 seconds"
      },
      "character": 36
    },
    {
      "id": "boots_of_speed",
      "name": "Boots of Speed",
      "rarity": 3,
      "patch": "9.0.0",
      "tags": [
        "MovementSpeed"
      ],
      "mechanics": {
        "haste": "+3 %",
        "durationHaste": "2 seconds"
      },
      "character": 36
    },
    {
      "id": "cloak_of_elvenkind",
      "name": "Cloak of Elvenkind",
      "rarity": 3,
      "patch": "9.0.0",
      "tags": [
        "TerrorRadius"
      ],
      "mechanics": {
        "effect": "-22 metres",
        "linger": "6 seconds"
      },
      "character": 36
    },
    {
      "id": "cloak_of_invisibility",
      "name": "Cloak of Invisibility",
      "rarity": 4,
      "patch": "9.0.0",
      "tags": [
        "Stealthy"
      ],
      "mechanics": {
        "undetectable": "20 seconds"
      },
      "character": 36
    },
    {
      "id": "crystal_ball",
      "name": "Crystal Ball",
      "rarity": 1,
      "patch": "9.0.0",
      "tags": [
        "KillerInstinct"
      ],
      "mechanics": {
        "effect": "+1 second"
      },
      "character": 36
    },
    {
      "id": "dragontooth_dagger",
      "name": "Dragontooth Dagger",
      "rarity": 4,
      "patch": "9.0.0",
      "tags": [
        "Haemorrhage",
        "Mangled"
      ],
      "mechanics": {
        "haemorrhage": "60 seconds",
        "mangled": "60 seconds"
      },
      "character": 36
    },
    {
      "id": "glass_eye",
      "name": "Glass Eye",
      "rarity": 2,
      "patch": "8.0.0",
      "mechanics": {
        "radius": "+2 metres",
        "speed": "+10 %"
      },
      "character": 36
    },
    {
      "id": "iridescent_book_of_vile_darkness",
      "name": "Iridescent Book of Vile Darkness",
      "rarity": 5,
      "patch": "8.0.0",
      "tags": [
        "WindowBlocker"
      ],
      "mechanics": {
        "duration": "45 seconds",
        "height": "-0.7 metres",
        "penalty": 3
      },
      "character": 36
    },
    {
      "id": "lantern_of_revealing",
      "name": "Lantern of Revealing",
      "rarity": 2,
      "patch": "8.0.0",
      "tags": [
        "Auras"
      ],
      "mechanics": {
        "duration": "3 seconds"
      },
      "character": 36
    },
    {
      "id": "ornate_horn",
      "name": "Ornate Horn",
      "rarity": 3,
      "patch": "8.0.0",
      "tags": [
        "PowerCapacity"
      ],
      "mechanics": {
        "bonus": 1
      },
      "character": 36
    },
    {
      "id": "pearl_of_power",
      "name": "Pearl of Power",
      "rarity": 3,
      "patch": "9.0.0",
      "tags": [
        "PowerCooldown"
      ],
      "mechanics": {
        "effect": "-2 seconds"
      },
      "character": 36
    },
    {
      "id": "potion_of_speed",
      "name": "Potion of Speed",
      "rarity": 2,
      "patch": "9.0.0",
      "tags": [
        "PowerCooldown"
      ],
      "mechanics": {
        "effect": "-0.15 seconds"
      },
      "character": 36
    },
    {
      "id": "raven_s_feather",
      "name": "Raven's Feather",
      "rarity": 1,
      "patch": "8.0.0",
      "tags": [
        "PowerDuration"
      ],
      "mechanics": {
        "effect": "+0.5 seconds"
      },
      "character": 36
    },
    {
      "id": "ring_of_spell_storing",
      "name": "Ring of Spell Storing",
      "rarity": 2,
      "patch": "9.0.0",
      "tags": [
        "PowerCooldown"
      ],
      "mechanics": {
        "effect": "-1 second"
      },
      "character": 36
    },
    {
      "id": "ring_of_telekinesis",
      "name": "Ring of Telekinesis",
      "rarity": 2,
      "patch": "9.0.0",
      "tags": [
        "ActionSpeed",
        "Vaulting"
      ],
      "mechanics": {
        "effect": "+10 %",
        "duration": "10 seconds"
      },
      "character": 36
    },
    {
      "id": "robe_of_eyes",
      "name": "Robe of Eyes",
      "rarity": 4,
      "patch": "9.0.0",
      "tags": [
        "Auras",
        "PowerObject"
      ],
      "mechanics": {
        "range": "6 metres",
        "duration": "4 seconds"
      },
      "character": 36
    },
    {
      "id": "staff_of_withering",
      "name": "Staff of Withering",
      "rarity": 3,
      "patch": "9.0.0",
      "tags": [
        "Exhausted"
      ],
      "mechanics": {
        "exhausted": "30 seconds"
      },
      "character": 36
    },
    {
      "id": "tattered_headband",
      "name": "Tattered Headband",
      "rarity": 1,
      "patch": "8.0.0",
      "tags": [
        "PowerRange"
      ],
      "mechanics": {
        "effect": "+4 metres"
      },
      "character": 36
    },
    {
      "id": "trickster_s_glove",
      "name": "Trickster's Glove",
      "rarity": 1,
      "patch": "9.0.0",
      "tags": [
        "PowerDuration"
      ],
      "mechanics": {
        "effect": "+0.3 seconds"
      },
      "character": 36
    },
    {
      "id": "vorpal_sword",
      "name": "Vorpal Sword",
      "rarity": 5,
      "patch": "8.0.2",
      "tags": [
        "Broken",
        "ExtendedAbility"
      ],
      "mechanics": {
        "broken": "30 seconds",
        "palletBreaking": "4 seconds"
      },
      "character": 36
    },
    {
      "id": "alucard_s_shield",
      "name": "Alucard's Shield",
      "rarity": 5,
      "patch": "8.2.0",
      "tags": [
        "ExitGates"
      ],
      "character": 37
    },
    {
      "id": "blood_filled_goblet",
      "name": "Blood-Filled Goblet",
      "rarity": 2,
      "patch": "9.2.0",
      "tags": [
        "PowerDuration"
      ],
      "mechanics": {
        "effect": "+60 %"
      },
      "character": 37
    },
    {
      "id": "cerberus_talon",
      "name": "Cerberus Talon",
      "rarity": 1,
      "patch": "8.2.0",
      "tags": [
        "PowerRange"
      ],
      "mechanics": {
        "effect": "+100 %"
      },
      "character": 37
    },
    {
      "id": "clock_tower_gear",
      "name": "Clock Tower Gear",
      "rarity": 1,
      "patch": "9.2.0",
      "tags": [
        "PowerCooldown"
      ],
      "mechanics": {
        "effect": "-5 %"
      },
      "character": 37
    },
    {
      "id": "cube_of_zoe",
      "name": "Cube of Zoe",
      "rarity": 4,
      "patch": "8.2.0",
      "tags": [
        "Generators"
      ],
      "mechanics": {
        "effect": "10 seconds"
      },
      "character": 37
    },
    {
      "id": "force_of_echo",
      "name": "Force of Echo",
      "rarity": 3,
      "patch": "9.2.0",
      "tags": [
        "PowerEfficiency"
      ],
      "mechanics": {
        "effect": "+10 %"
      },
      "character": 37
    },
    {
      "id": "iridescent_ring_of_vlad",
      "name": "Iridescent Ring of Vlad",
      "rarity": 5,
      "patch": "9.2.0",
      "tags": [
        "PowerCapacity"
      ],
      "character": 37
    },
    {
      "id": "killer_doll",
      "name": "Killer Doll",
      "rarity": 3,
      "patch": "9.2.0",
      "tags": [
        "PowerCooldown"
      ],
      "mechanics": {
        "effect": "+30 %"
      },
      "character": 37
    },
    {
      "id": "lapis_lazuli",
      "name": "Lapis Lazuli",
      "rarity": 4,
      "patch": "9.2.0",
      "tags": [
        "WindowBlocker"
      ],
      "mechanics": {
        "effect": "8 seconds"
      },
      "character": 37
    },
    {
      "id": "magical_ticket",
      "name": "Magical Ticket",
      "rarity": 2,
      "patch": "8.2.2",
      "mechanics": {
        "effect": "+10 %"
      },
      "character": 37
    },
    {
      "id": "medusa_s_hair",
      "name": "Medusa's Hair",
      "rarity": 4,
      "patch": "9.2.0",
      "tags": [
        "Hindered"
      ],
      "mechanics": {
        "range": "8 metres",
        "hindered": "-8 %",
        "durationHindered": "4 seconds"
      },
      "character": 37
    },
    {
      "id": "moonstone_necklace",
      "name": "Moonstone Necklace",
      "rarity": 2,
      "patch": "9.2.0",
      "tags": [
        "TerrorRadius"
      ],
      "mechanics": {
        "effect": "-8 metres"
      },
      "character": 37
    },
    {
      "id": "pocket_watch_vampiric_shift",
      "name": "Pocket Watch (Vampiric Shift)",
      "rarity": 3,
      "patch": "8.2.0",
      "tags": [
        "PowerCooldown"
      ],
      "mechanics": {
        "multiName": true
      },
      "character": 37
    },
    {
      "id": "ruby_circlet",
      "name": "Ruby Circlet",
      "rarity": 1,
      "patch": "9.2.0",
      "tags": [
        "PowerCooldown"
      ],
      "mechanics": {
        "effect": "-5 %"
      },
      "character": 37
    },
    {
      "id": "sunglasses",
      "name": "Sunglasses",
      "rarity": 3,
      "patch": "8.2.0",
      "tags": [
        "PowerCapacity",
        "PowerCooldown"
      ],
      "mechanics": {
        "effect": [
          1,
          "+25 %"
        ]
      },
      "character": 37
    },
    {
      "id": "sylph_feather",
      "name": "Sylph Feather",
      "rarity": 3,
      "patch": "8.2.0",
      "mechanics": {
        "tokens": [
          "+1 Token",
          "5 Tokens"
        ],
        "cooldown": [
          "-5 %",
          "-25 %"
        ]
      },
      "character": 37
    },
    {
      "id": "traveller_s_hat",
      "name": "Traveller's Hat",
      "rarity": 1,
      "patch": "9.2.0",
      "tags": [
        "PowerPenalty"
      ],
      "mechanics": {
        "effect": "-5 %"
      },
      "character": 37
    },
    {
      "id": "warg_s_fang",
      "name": "Warg's Fang",
      "rarity": 4,
      "patch": "9.2.0",
      "tags": [
        "Auras"
      ],
      "mechanics": {
        "effect": "5 seconds"
      },
      "character": 37
    },
    {
      "id": "white_wolf_medallion",
      "name": "White Wolf Medallion",
      "rarity": 2,
      "patch": "9.2.0",
      "tags": [
        "KillerInstinct"
      ],
      "mechanics": {
        "effect": "+1 second"
      },
      "character": 37
    },
    {
      "id": "winged_boots",
      "name": "Winged Boots",
      "rarity": 2,
      "patch": "8.2.0",
      "tags": [
        "PowerRange"
      ],
      "mechanics": {
        "effect": "+20 %"
      },
      "character": 37
    },
    {
      "id": "barley_meal",
      "name": "Barley Meal",
      "rarity": 2,
      "patch": "8.4.0",
      "tags": [
        "ChasePath",
        "Dog",
        "PowerRange"
      ],
      "mechanics": {
        "effect": "+20 %"
      },
      "character": 38
    },
    {
      "id": "belaying_pins",
      "name": "Belaying Pins",
      "rarity": 2,
      "patch": "8.4.0",
      "tags": [
        "Houndsense",
        "Oblivious"
      ],
      "mechanics": {
        "oblivious": "20 seconds"
      },
      "character": 38
    },
    {
      "id": "creature_s_bone",
      "name": "Creature's Bone",
      "rarity": 1,
      "patch": "8.4.0",
      "tags": [
        "Dog",
        "DogStun"
      ],
      "mechanics": {
        "effect": "-50 %"
      },
      "character": 38
    },
    {
      "id": "fatty_meat",
      "name": "Fatty Meat",
      "rarity": 3,
      "patch": "8.4.0",
      "tags": [
        "Houndsense",
        "Screams"
      ],
      "mechanics": {
        "effect": "15 seconds"
      },
      "character": 38
    },
    {
      "id": "gunpowder_tin",
      "name": "Gunpowder Tin",
      "rarity": 4,
      "patch": "8.4.1",
      "tags": [
        "ActionSpeeds",
        "BreakableWalls",
        "Generators",
        "Houndsense",
        "Pallets"
      ],
      "mechanics": {
        "effect": "+30 %",
        "duration": "20 seconds"
      },
      "character": 38
    },
    {
      "id": "iridescent_wheel_handle",
      "name": "Iridescent Wheel Handle",
      "rarity": 5,
      "patch": "8.4.0",
      "tags": [
        "Dog",
        "SearchPath",
        "Undetectable"
      ],
      "mechanics": {
        "effect": "+20 %"
      },
      "character": 38
    },
    {
      "id": "knotted_rope",
      "name": "Knotted Rope",
      "rarity": 2,
      "patch": "8.4.2",
      "tags": [
        "AttackCooldown",
        "Dog"
      ],
      "mechanics": {
        "effect": "-2 %"
      },
      "character": 38
    },
    {
      "id": "leather_harness",
      "name": "Leather Harness",
      "rarity": 4,
      "patch": "8.4.0",
      "tags": [
        "Dog",
        "Generators",
        "MovementSpeed"
      ],
      "mechanics": {
        "effect": "+20 %",
        "duration": "30 seconds"
      },
      "character": 38
    },
    {
      "id": "marlinspike",
      "name": "Marlinspike",
      "rarity": 4,
      "patch": "8.4.1",
      "tags": [
        "Dog",
        "DogGrab",
        "Houndsense"
      ],
      "mechanics": {
        "range": "20 metres"
      },
      "character": 38
    },
    {
      "id": "ship_figurehead",
      "name": "Ship Figurehead",
      "rarity": 4,
      "patch": "8.4.0",
      "tags": [
        "Dog",
        "TerrorRadius"
      ],
      "mechanics": {
        "near": "+8 metres",
        "far": "-8 metres"
      },
      "character": 38
    },
    {
      "id": "smoked_snapper",
      "name": "Smoked Snapper",
      "rarity": 2,
      "patch": "8.4.0",
      "tags": [
        "PowerRecovery"
      ],
      "mechanics": {
        "effect": "-5 %"
      },
      "character": 38
    },
    {
      "id": "spiked_collar",
      "name": "Spiked Collar",
      "rarity": 3,
      "patch": "8.4.1",
      "tags": [
        "Dog",
        "DogGrab",
        "Haemorrhage"
      ],
      "mechanics": {
        "haemorrhage": "60 seconds",
        "mangled": "60 seconds",
        "duration": "60 seconds"
      },
      "character": 38
    },
    {
      "id": "spyglass",
      "name": "Spyglass",
      "rarity": 2,
      "patch": "8.4.0",
      "tags": [
        "Auras",
        "Houndsense"
      ],
      "mechanics": {
        "duration": "3 seconds"
      },
      "character": 38
    },
    {
      "id": "sticky_pitch",
      "name": "Sticky Pitch",
      "rarity": 1,
      "patch": "8.4.0",
      "tags": [
        "MovementSpeed",
        "SearchPath"
      ],
      "mechanics": {
        "effect": "+2 %"
      },
      "character": 38
    },
    {
      "id": "torn_novel",
      "name": "Torn Novel",
      "rarity": 5,
      "patch": "8.4.0",
      "tags": [
        "Auras",
        "Dog"
      ],
      "mechanics": {
        "range": "10 metres",
        "linger": "2 seconds"
      },
      "character": 38
    },
    {
      "id": "trainer_s_book",
      "name": "Trainer's Book",
      "rarity": 1,
      "patch": "8.4.0",
      "tags": [
        "EffectDuration",
        "Houndsense"
      ],
      "mechanics": {
        "effect": "+35 %"
      },
      "character": 38
    },
    {
      "id": "training_bell",
      "name": "Training Bell",
      "rarity": 3,
      "patch": "8.4.1",
      "tags": [
        "Auras",
        "Dog",
        "DogStun"
      ],
      "mechanics": {
        "duration": "8 seconds"
      },
      "character": 38
    },
    {
      "id": "unfinished_map",
      "name": "Unfinished Map",
      "rarity": 3,
      "patch": "8.4.0",
      "tags": [
        "Exhausted",
        "Houndsense"
      ],
      "mechanics": {
        "exhausted": "15 seconds"
      },
      "character": 38
    },
    {
      "id": "waterskin",
      "name": "Waterskin",
      "rarity": 3,
      "patch": "8.4.0",
      "tags": [
        "ChasePath",
        "Dog",
        "PowerRange"
      ],
      "mechanics": {
        "effect": "+20 %"
      },
      "character": 38
    },
    {
      "id": "young_coconut",
      "name": "Young Coconut",
      "rarity": 1,
      "patch": "8.4.0",
      "tags": [
        "Dog",
        "MovementSpeed"
      ],
      "mechanics": {
        "effect": "+5 %"
      },
      "character": 38
    },
    {
      "id": "amon_s_necktie",
      "name": "Amon's Necktie",
      "rarity": 3,
      "patch": "8.6.0",
      "tags": [
        "Auras"
      ],
      "mechanics": {
        "range": "32 metres"
      },
      "character": 39
    },
    {
      "id": "anteiku_apron",
      "name": "Anteiku Apron",
      "rarity": 1,
      "patch": "8.6.0",
      "mechanics": {
        "effect": "-50 %"
      },
      "character": 39
    },
    {
      "id": "aogiri_tree_robe",
      "name": "Aogiri Tree Robe",
      "rarity": 3,
      "patch": "8.6.0",
      "tags": [
        "Enraged",
        "Generators",
        "Undetectable"
      ],
      "mechanics": {
        "undetectable": "20 seconds"
      },
      "character": 39
    },
    {
      "id": "blood_stained_handkerchief",
      "name": "Blood-Stained Handkerchief",
      "rarity": 2,
      "patch": "8.6.2",
      "tags": [
        "PowerRange"
      ],
      "mechanics": {
        "effect": "+1 metre"
      },
      "character": 39
    },
    {
      "id": "broken_chain",
      "name": "Broken Chain",
      "rarity": 2,
      "patch": "8.6.0",
      "tags": [
        "Enraged",
        "PowerRecovery"
      ],
      "mechanics": {
        "effect": "-1.4 seconds per Token"
      },
      "character": 39
    },
    {
      "id": "ccg_id_card",
      "name": "CCG ID Card",
      "rarity": 4,
      "patch": "8.6.0",
      "tags": [
        "Auras",
        "Vaulting"
      ],
      "mechanics": {
        "range": "24 metres",
        "duration": "3 seconds"
      },
      "character": 39
    },
    {
      "id": "fresh_coffee",
      "name": "Fresh Coffee",
      "rarity": 4,
      "patch": "8.6.2",
      "tags": [
        "MovementSpeed"
      ],
      "mechanics": {
        "effect": "+2 m/s"
      },
      "character": 39
    },
    {
      "id": "hide_s_headphones",
      "name": "Hide's Headphones",
      "rarity": 2,
      "patch": "8.6.0",
      "tags": [
        "Oblivious"
      ],
      "character": 39
    },
    {
      "id": "hinami_s_umbrella",
      "name": "Hinami's Umbrella",
      "rarity": 2,
      "patch": "8.6.2",
      "tags": [
        "Enraged"
      ],
      "mechanics": {
        "effect": "+10 seconds"
      },
      "character": 39
    },
    {
      "id": "iridescent_eye_patch",
      "name": "Iridescent Eye Patch",
      "rarity": 5,
      "patch": "8.6.0",
      "tags": [
        "AutoBreak",
        "Enraged",
        "Pallets"
      ],
      "character": 39
    },
    {
      "id": "kaneki_s_satchel",
      "name": "Kaneki's Satchel",
      "rarity": 2,
      "patch": "8.6.0",
      "tags": [
        "MovementSpeed"
      ],
      "mechanics": {
        "effect": "+4.2 m/s"
      },
      "character": 39
    },
    {
      "id": "kaneki_s_wallet",
      "name": "Kaneki's Wallet",
      "rarity": 1,
      "patch": "8.6.0",
      "tags": [
        "PowerWindow"
      ],
      "mechanics": {
        "effect": "+3 seconds"
      },
      "character": 39
    },
    {
      "id": "mado_s_glove",
      "name": "Mado's Glove",
      "rarity": 3,
      "patch": "8.6.0",
      "tags": [
        "Exhausted"
      ],
      "mechanics": {
        "exhausted": "15 seconds"
      },
      "character": 39
    },
    {
      "id": "red_spider_lily",
      "name": "Red Spider Lily",
      "rarity": 3,
      "patch": "8.6.0",
      "tags": [
        "Haemorrhage"
      ],
      "mechanics": {
        "haemorrhage": "60 seconds"
      },
      "character": 39
    },
    {
      "id": "red_headed_centipede",
      "name": "Red-Headed Centipede",
      "rarity": 4,
      "patch": "8.6.0",
      "tags": [
        "Enraged",
        "WindowBlocker"
      ],
      "mechanics": {
        "effect": "10 seconds"
      },
      "character": 39
    },
    {
      "id": "rize_s_glasses",
      "name": "Rize's Glasses",
      "rarity": 3,
      "patch": "8.6.0",
      "tags": [
        "Auras",
        "Enraged",
        "Generators"
      ],
      "mechanics": {
        "effect": "8 seconds"
      },
      "character": 39
    },
    {
      "id": "taiyaki",
      "name": "Taiyaki",
      "rarity": 1,
      "patch": "8.6.2",
      "tags": [
        "EffectDuration"
      ],
      "mechanics": {
        "effect": "+5 seconds"
      },
      "character": 39
    },
    {
      "id": "the_black_goat_s_egg",
      "name": "The Black Goat's Egg",
      "rarity": 1,
      "patch": "8.6.0",
      "tags": [
        "Bloodpoints"
      ],
      "mechanics": {
        "effect": "+100 %"
      },
      "character": 39
    },
    {
      "id": "torture_apparatus",
      "name": "Torture Apparatus",
      "rarity": 4,
      "patch": "8.6.0",
      "tags": [
        "Enraged",
        "MovementSpeed"
      ],
      "mechanics": {
        "haste": "+5 %",
        "durationHaste": "6 seconds"
      },
      "character": 39
    },
    {
      "id": "yamori_s_mask",
      "name": "Yamori's Mask",
      "rarity": 5,
      "patch": "8.6.2",
      "tags": [
        "Enraged",
        "Hooks",
        "Screams"
      ],
      "mechanics": {
        "effect": "3 seconds"
      },
      "character": 39
    },
    {
      "id": "access_panel",
      "name": "Access Panel",
      "rarity": 4,
      "patch": "9.6.0",
      "tags": [
        "ExtendedAbility",
        "FireAxe",
        "KillerInstinct",
        "SecurityDoors"
      ],
      "mechanics": {
        "range": "6 metres"
      },
      "character": 40
    },
    {
      "id": "bonnie_s_guitar_strings",
      "name": "Bonnie's Guitar Strings",
      "rarity": 3,
      "patch": "9.0.2",
      "tags": [
        "Auras",
        "ExtendedAbility",
        "Generators",
        "SecurityDoors",
        "Undetectable"
      ],
      "mechanics": {
        "effect": "-100 %",
        "undetectable": "0 seconds"
      },
      "character": 40
    },
    {
      "id": "celebrate_poster",
      "name": "Celebrate! Poster",
      "rarity": 4,
      "patch": "9.0.0",
      "tags": [
        "ActionSpeed",
        "FireAxe",
        "Haste",
        "Vaulting"
      ],
      "mechanics": {
        "haste": "+12 %",
        "effect": "+20 %",
        "range": "32 metres"
      },
      "character": 40
    },
    {
      "id": "chica_s_bib",
      "name": "Chica's Bib",
      "rarity": 3,
      "patch": "9.0.0",
      "tags": [
        "Exhausted",
        "FireAxe"
      ],
      "mechanics": {
        "linger": "5 seconds"
      },
      "character": 40
    },
    {
      "id": "endo_cpu",
      "name": "Endo CPU",
      "rarity": 4,
      "patch": "9.0.2",
      "tags": [
        "ActionSpeed",
        "BreakableWalls",
        "FireAxe",
        "Generators",
        "Pallets"
      ],
      "mechanics": {
        "effect": "+40 %",
        "linger": "5 seconds"
      },
      "character": 40
    },
    {
      "id": "faz_coin",
      "name": "Faz-Coin",
      "rarity": 5,
      "patch": "9.0.0",
      "tags": [
        "Deception",
        "TerrorRadius",
        "TerrorRadiusTransfer",
        "Undetectable"
      ],
      "mechanics": {
        "radius": "24 metres",
        "undetectable": "10 seconds"
      },
      "character": 40
    },
    {
      "id": "foxy_s_hook",
      "name": "Foxy's Hook",
      "rarity": 3,
      "patch": "9.0.2",
      "tags": [
        "FireAxe",
        "Haste"
      ],
      "mechanics": {
        "haste": "+7 %",
        "linger": "6 seconds"
      },
      "character": 40
    },
    {
      "id": "freddy_s_hat",
      "name": "Freddy's Hat",
      "rarity": 3,
      "patch": "9.0.0",
      "tags": [
        "FireAxe",
        "Trajectory"
      ],
      "mechanics": {
        "effect": "+100 %"
      },
      "character": 40
    },
    {
      "id": "greasy_paper_plate",
      "name": "Greasy Paper Plate",
      "rarity": 1,
      "patch": "9.0.0",
      "tags": [
        "ActionTime",
        "FireAxe"
      ],
      "mechanics": {
        "effect": "+15 %"
      },
      "character": 40
    },
    {
      "id": "help_wanted_ad",
      "name": "Help Wanted Ad",
      "rarity": 1,
      "patch": "9.0.0",
      "tags": [
        "ExtendedAbility",
        "FireAxe",
        "PowerIndicator"
      ],
      "character": 40
    },
    {
      "id": "iridescent_remnant",
      "name": "Iridescent Remnant",
      "rarity": 5,
      "patch": "9.0.0",
      "tags": [
        "PalletBlocker",
        "Pallets",
        "SecurityDoors"
      ],
      "mechanics": {
        "blockDuration": "12 seconds",
        "blockRange": "32 metres"
      },
      "character": 40
    },
    {
      "id": "loot_bag",
      "name": "Loot Bag",
      "rarity": 4,
      "patch": "9.0.0",
      "tags": [
        "ExitGates",
        "FireAxe",
        "GateBlocker"
      ],
      "mechanics": {
        "range": "12 metres"
      },
      "character": 40
    },
    {
      "id": "office_phone",
      "name": "Office Phone",
      "rarity": 2,
      "patch": "9.0.0",
      "tags": [
        "Broken",
        "FireAxe",
        "Oblivious"
      ],
      "mechanics": {
        "range": "24 metres",
        "effect": "-50 %"
      },
      "character": 40
    },
    {
      "id": "party_hat",
      "name": "Party Hat",
      "rarity": 2,
      "patch": "9.0.2",
      "tags": [
        "AOE",
        "Fire Axe",
        "PowerPenalty"
      ],
      "mechanics": {
        "AOE_bonusSize": "+250 %",
        "AOE_bonusDuration": "+2.5 seconds",
        "AOE_duration": "-20 %"
      },
      "character": 40
    },
    {
      "id": "purple_guy_drawing",
      "name": "Purple Guy Drawing",
      "rarity": 3,
      "patch": "9.0.0",
      "tags": [
        "Auras",
        "ExtendedAbility",
        "FireAxe"
      ],
      "mechanics": {
        "aura": [
          "3 seconds",
          "6 seconds"
        ]
      },
      "character": 40
    },
    {
      "id": "restaurant_menu",
      "name": "Restaurant Menu",
      "rarity": 1,
      "patch": "9.6.0",
      "tags": [
        "ActionTime",
        "FireAxe"
      ],
      "mechanics": {
        "effect": "-10 %"
      },
      "character": 40
    },
    {
      "id": "ripped_curtain",
      "name": "Ripped Curtain",
      "rarity": 2,
      "patch": "9.0.0",
      "tags": [
        "FireAxe",
        "Haemorrhage",
        "Mangled"
      ],
      "mechanics": {
        "haemorrhage": "60 seconds",
        "mangled": "60 seconds",
        "duration": "60 seconds"
      },
      "character": 40
    },
    {
      "id": "rotten_pizza",
      "name": "Rotten Pizza",
      "rarity": 1,
      "patch": "9.0.0",
      "tags": [
        "FireAxe",
        "KillerInstinct"
      ],
      "mechanics": {
        "effect": "+100 %"
      },
      "character": 40
    },
    {
      "id": "security_guard_s_badge",
      "name": "Security Guard's Badge",
      "rarity": 2,
      "patch": "9.0.2",
      "tags": [
        "SecurityDoors",
        "Undetectable"
      ],
      "mechanics": {
        "effect": "+25 %",
        "undetectable": "25 seconds"
      },
      "character": 40
    },
    {
      "id": "streamers",
      "name": "Streamers",
      "rarity": 2,
      "patch": "9.0.2",
      "tags": [
        "MovementSpeed",
        "SecurityDoors"
      ],
      "mechanics": {
        "effect": "+15 %"
      },
      "character": 40
    },
    {
      "id": "broken_tiara",
      "name": "Broken Tiara",
      "rarity": 1,
      "patch": "9.2.0",
      "tags": [
        "GlowingFungus",
        "Oblivious"
      ],
      "mechanics": {
        "effect": "+2 Charges"
      },
      "character": 41
    },
    {
      "id": "chicken_head",
      "name": "Chicken Head",
      "rarity": 5,
      "patch": "9.2.0",
      "tags": [
        "Leeched"
      ],
      "mechanics": {
        "effect": "+2"
      },
      "character": 41
    },
    {
      "id": "chunk_of_malai",
      "name": "Chunk of Malai",
      "rarity": 2,
      "patch": "9.2.0",
      "tags": [
        "GlowingFungus",
        "Leeched"
      ],
      "mechanics": {
        "effect": [
          "-8 %",
          "-32 %"
        ]
      },
      "character": 41
    },
    {
      "id": "crumpled_sheet_music",
      "name": "Crumpled Sheet Music",
      "rarity": 2,
      "patch": "9.2.0",
      "tags": [
        "Leeched",
        "PowerDuration"
      ],
      "mechanics": {
        "effect": "+12 Charges"
      },
      "character": 41
    },
    {
      "id": "defective_metronome",
      "name": "Defective Metronome",
      "rarity": 2,
      "patch": "9.2.0",
      "tags": [
        "Exhausted",
        "GlowingFungus"
      ],
      "character": 41
    },
    {
      "id": "dulled_knife",
      "name": "Dulled Knife",
      "rarity": 3,
      "patch": "9.2.0",
      "tags": [
        "PowerDuration",
        "Elusive",
        "GlowingFungus",
        "Haste"
      ],
      "mechanics": {
        "effect": "-25 %",
        "duration": "5 seconds",
        "haste": "+5 %",
        "durationHaste": "5 seconds",
        "durationElusive": "5 seconds"
      },
      "character": 41
    },
    {
      "id": "first_libretto",
      "name": "First Libretto",
      "rarity": 1,
      "patch": "9.2.0",
      "tags": [
        "PowerDuration"
      ],
      "mechanics": {
        "effect": "-30 %",
        "duration": "15 seconds"
      },
      "character": 41
    },
    {
      "id": "framed_newspaper",
      "name": "Framed Newspaper",
      "rarity": 3,
      "patch": "9.2.0",
      "tags": [
        "PowerDuration",
        "PowerRecovery"
      ],
      "mechanics": {
        "capacity": "+6 Charges",
        "charge": "+15 %",
        "threshold": "50 %"
      },
      "character": 41
    },
    {
      "id": "janjira_s_hand",
      "name": "Janjira's Hand",
      "rarity": 3,
      "patch": "9.2.0",
      "tags": [
        "PowerDuration",
        "PowerRecovery"
      ],
      "mechanics": {
        "effect": "+25 %",
        "duration": "15 seconds",
        "bonus": "+2 Charges"
      },
      "character": 41
    },
    {
      "id": "lorenza_s_remains",
      "name": "Lorenza's Remains",
      "rarity": 4,
      "patch": "9.2.0",
      "tags": [
        "Blindness",
        "Hindered",
        "Leeched"
      ],
      "mechanics": {
        "hindered": "-4 %"
      },
      "character": 41
    },
    {
      "id": "luckless_mouse",
      "name": "Luckless Mouse",
      "rarity": 1,
      "patch": "9.2.0",
      "tags": [
        "PowerDuration"
      ],
      "mechanics": {
        "effect": "+2 Charges"
      },
      "character": 41
    },
    {
      "id": "mysterious_elixir",
      "name": "Mysterious Elixir",
      "rarity": 4,
      "patch": "9.2.0",
      "tags": [
        "ExtendedAbility",
        "Windows",
        "WindowBlocker"
      ],
      "mechanics": {
        "duration": "10 seconds"
      },
      "character": 41
    },
    {
      "id": "pig_s_eye",
      "name": "Pig's Eye",
      "rarity": 2,
      "patch": "9.2.0",
      "tags": [
        "Auras",
        "GlowingFungus"
      ],
      "mechanics": {
        "distance": "40 metres",
        "duration": "6 seconds"
      },
      "character": 41
    },
    {
      "id": "queen_s_sceptre",
      "name": "Queen's Sceptre",
      "rarity": 4,
      "patch": "9.2.0",
      "tags": [
        "ExtendedAbility"
      ],
      "character": 41
    },
    {
      "id": "rotten_swine",
      "name": "Rotten Swine",
      "rarity": 4,
      "patch": "9.2.0",
      "tags": [
        "ActionSpeed",
        "BreakableWalls",
        "Generators",
        "Pallets"
      ],
      "mechanics": {
        "effect": "+15 %"
      },
      "character": 41
    },
    {
      "id": "shredded_gown",
      "name": "Shredded Gown",
      "rarity": 5,
      "patch": "9.2.0",
      "tags": [
        "Auras",
        "GlowingFungus"
      ],
      "mechanics": {
        "aura": [
          "8 metres",
          "5 seconds"
        ]
      },
      "character": 41
    },
    {
      "id": "spattered_handkerchief",
      "name": "Spattered Handkerchief",
      "rarity": 3,
      "patch": "9.2.0",
      "tags": [
        "Exit Gates",
        "GlowingFungus",
        "Leeched"
      ],
      "character": 41
    },
    {
      "id": "sticky_lozenge",
      "name": "Sticky Lozenge",
      "rarity": 1,
      "patch": "9.2.0",
      "tags": [
        "PowerIndicator"
      ],
      "character": 41
    },
    {
      "id": "theatre_binoculars",
      "name": "Theatre Binoculars",
      "rarity": 3,
      "patch": "9.2.0",
      "tags": [
        "Auras"
      ],
      "mechanics": {
        "aura": [
          "24 metres",
          "6 seconds"
        ]
      },
      "character": 41
    },
    {
      "id": "wriggling_parasite",
      "name": "Wriggling Parasite",
      "rarity": 2,
      "patch": "9.2.0",
      "tags": [
        "GlowingFungus",
        "Leeched"
      ],
      "mechanics": {
        "effect": "+16 %"
      },
      "character": 41
    },
    {
      "id": "bead_maze",
      "name": "Bead Maze",
      "rarity": 1,
      "patch": "9.5.0",
      "mechanics": {
        "timer": "2.5 seconds"
      },
      "character": 42
    },
    {
      "id": "black_widow_spider",
      "name": "Black Widow Spider",
      "rarity": 4,
      "patch": "9.4.0",
      "tags": [
        "Auras"
      ],
      "mechanics": {
        "aura": [
          "36 meters",
          "3 seconds"
        ]
      },
      "character": 42
    },
    {
      "id": "bloody_roller_skate",
      "name": "Bloody Roller Skate",
      "rarity": 2,
      "patch": "9.5.0",
      "mechanics": {
        "effect": "20 %",
        "duration": "1.5 seconds"
      },
      "character": 42
    },
    {
      "id": "broken_skateboard",
      "name": "Broken Skateboard",
      "rarity": 4,
      "patch": "9.5.0",
      "mechanics": {
        "effect": "30 %",
        "duration": "65 seconds",
        "auraRange": "32 metres"
      },
      "character": 42
    },
    {
      "id": "chess_piece",
      "name": "Chess Piece",
      "rarity": 5,
      "patch": "9.5.0",
      "mechanics": {
        "radius": "40 %"
      },
      "character": 42
    },
    {
      "id": "clock_hands",
      "name": "Clock Hands",
      "rarity": 2,
      "patch": "9.4.0",
      "mechanics": {
        "duration": "12 seconds"
      },
      "character": 42
    },
    {
      "id": "electrode_cap",
      "name": "Electrode Cap",
      "rarity": 3,
      "patch": "9.4.0",
      "mechanics": {
        "aura": [
          "26 meters",
          "6 seconds"
        ]
      },
      "character": 42
    },
    {
      "id": "electroshock_collar",
      "name": "Electroshock Collar",
      "rarity": 4,
      "patch": "9.4.0",
      "mechanics": {
        "distance": "32 meters",
        "duration": "12 seconds"
      },
      "character": 42
    },
    {
      "id": "forged_death_certificate",
      "name": "Forged Death Certificate",
      "rarity": 3,
      "patch": "9.5.0",
      "character": 42
    },
    {
      "id": "gutted_supercom",
      "name": "Gutted Supercom",
      "rarity": 2,
      "patch": "9.4.0",
      "mechanics": {
        "duration": "1.5 seconds"
      },
      "character": 42
    },
    {
      "id": "iridescent_soteria_chip",
      "name": "Iridescent Soteria Chip",
      "rarity": 5,
      "patch": "9.4.0",
      "mechanics": {
        "distance": "12 meters"
      },
      "character": 42
    },
    {
      "id": "mid_century_radio",
      "name": "Mid-Century Radio",
      "rarity": 1,
      "patch": "9.5.0",
      "mechanics": {
        "distance": "32 meters"
      },
      "character": 42
    },
    {
      "id": "neck_tendril",
      "name": "Neck Tendril",
      "rarity": 3,
      "patch": "9.4.0",
      "mechanics": {
        "duration": "70 seconds"
      },
      "character": 42
    },
    {
      "id": "orderly_id",
      "name": "Orderly ID",
      "rarity": 1,
      "patch": "9.4.0",
      "mechanics": {
        "distance": "2 meters"
      },
      "character": 42
    },
    {
      "id": "pizza_goggles",
      "name": "Pizza Goggles",
      "rarity": 3,
      "patch": "9.5.0",
      "mechanics": {
        "effect": [
          "90 %",
          "25 seconds"
        ],
        "cooldownReduction": "80 %"
      },
      "character": 42
    },
    {
      "id": "rabbit_remains",
      "name": "Rabbit Remains",
      "rarity": 4,
      "patch": "9.5.0",
      "mechanics": {
        "duration": "10 seconds",
        "cooldownIncrease": "5 seconds"
      },
      "character": 42
    },
    {
      "id": "shattered_wrist_rocket",
      "name": "Shattered Wrist Rocket",
      "rarity": 2,
      "patch": "9.5.0",
      "character": 42
    },
    {
      "id": "smashed_cassette_deck",
      "name": "Smashed Cassette Deck",
      "rarity": 2,
      "patch": "9.4.0",
      "character": 42
    },
    {
      "id": "stained_glass_mural",
      "name": "Stained Glass Mural",
      "rarity": 1,
      "patch": "9.4.0",
      "mechanics": {
        "duration": "12 seconds"
      },
      "character": 42
    },
    {
      "id": "victor_s_razor_blade",
      "name": "Victor's Razor Blade",
      "rarity": 3,
      "patch": "9.4.0",
      "mechanics": {
        "duration": "20 seconds"
      },
      "character": 42
    },
    {
      "id": "orderly_s_shoe",
      "name": "Orderly's Shoe",
      "rarity": 1,
      "mechanics": {
        "effect": "+5 seconds"
      },
      "character": 43
    },
    {
      "id": "knitting_needle",
      "name": "Knitting Needle",
      "rarity": 1,
      "mechanics": {
        "effect": "+20 %"
      },
      "character": 43
    },
    {
      "id": "garden_claw",
      "name": "Garden Claw",
      "rarity": 1,
      "mechanics": {
        "effect": "+2 seconds"
      },
      "character": 43
    },
    {
      "id": "bent_wheel",
      "name": "Bent Wheel",
      "rarity": 1,
      "mechanics": {
        "effect": "+4 metres"
      },
      "character": 43
    },
    {
      "id": "toxic_waste",
      "name": "Toxic Waste",
      "rarity": 2,
      "patch": "10.0.0",
      "tags": [
        "Oblivious",
        "ScrapPiles"
      ],
      "mechanics": {
        "range": "10 metres",
        "duration": "13 seconds"
      },
      "character": 43
    },
    {
      "id": "sleeping_bag",
      "name": "Sleeping Bag",
      "rarity": 2,
      "mechanics": {
        "range": "10 metres"
      },
      "character": 43
    },
    {
      "id": "party_noisemaker",
      "name": "Party Noisemaker",
      "rarity": 2,
      "tags": [
        "Auras"
      ],
      "mechanics": {
        "range": "28 metres",
        "duration": "6 seconds"
      },
      "character": 43
    },
    {
      "id": "coroner_s_coffee",
      "name": "Coroner's Coffee",
      "rarity": 2,
      "patch": "10.0.1",
      "tags": [
        "Haste"
      ],
      "mechanics": {
        "effect": "+25 %",
        "hasteStrength": "+13 %",
        "hasteDuration": "3 seconds"
      },
      "character": 43
    },
    {
      "id": "bloody_smile",
      "name": "Bloody Smile",
      "rarity": 2,
      "mechanics": {
        "effect": "+4 metres"
      },
      "character": 43
    },
    {
      "id": "two_nails",
      "name": "Two Nails",
      "rarity": 3,
      "tags": [
        "Auras"
      ],
      "mechanics": {
        "range": "1 metre",
        "duration": "5 seconds"
      },
      "character": 43
    },
    {
      "id": "sauna_rock",
      "name": "Sauna Rock",
      "rarity": 3,
      "tags": [
        "Exhausted"
      ],
      "mechanics": {
        "duration": "3 seconds"
      },
      "character": 43
    },
    {
      "id": "mirror_shards_omnipresent_evil",
      "name": "Mirror Shards (Omnipresent Evil)",
      "rarity": 3,
      "tags": [
        "Broken"
      ],
      "mechanics": {
        "duration": "40 seconds",
        "multiName": true
      },
      "character": 43
    },
    {
      "id": "imprinted_aluminum",
      "name": "Imprinted Aluminum",
      "rarity": 3,
      "tags": [
        "Mangled",
        "Haemorrhage"
      ],
      "mechanics": {
        "duration": "70 seconds"
      },
      "character": 43
    },
    {
      "id": "eye_goop",
      "name": "Eye Goop",
      "rarity": 3,
      "patch": "10.0.0",
      "tags": [
        "Undetectable"
      ],
      "mechanics": {
        "duration": "13 seconds"
      },
      "character": 43
    },
    {
      "id": "missing_corkscrew",
      "name": "Missing Corkscrew",
      "rarity": 4,
      "tags": [
        "Undetectable",
        "TerrorRadius",
        "TerrorRadiusTransfer"
      ],
      "mechanics": {
        "range": "32 metres",
        "duration": "13 seconds"
      },
      "character": 43
    },
    {
      "id": "deputy_s_badge",
      "name": "Deputy's Badge",
      "rarity": 4,
      "patch": "10.0.2",
      "tags": [
        "Generators",
        "SkillChecks"
      ],
      "mechanics": {
        "effect": "-5 %",
        "range": "2 metres"
      },
      "character": 43
    },
    {
      "id": "burnt_fuse",
      "name": "Burnt Fuse",
      "rarity": 4,
      "tags": [
        "ExitBlocker"
      ],
      "mechanics": {
        "range": "13 metres",
        "duration": "5 seconds"
      },
      "character": 43
    },
    {
      "id": "bloody_magazine",
      "name": "Bloody Magazine",
      "rarity": 4,
      "patch": "10.0.0",
      "tags": [
        "Auras",
        "Screams"
      ],
      "mechanics": {
        "range": "8 metres",
        "duration": "3 seconds"
      },
      "character": 43
    },
    {
      "id": "iridescent_boat_motor",
      "name": "Iridescent Boat Motor",
      "rarity": 5,
      "patch": "10.0.0",
      "tags": [
        "Windows",
        "WindowBlocker"
      ],
      "mechanics": {
        "duration": "13 seconds",
        "markBlockDuration": "13 seconds"
      },
      "character": 43
    },
    {
      "id": "dirty_money",
      "name": "Dirty Money",
      "rarity": 5,
      "tags": [
        "Windows",
        "Pallets",
        "BreakableWalls"
      ],
      "mechanics": {
        "tokensAdded": "2"
      },
      "character": 43
    }
  ],
  "offerings": [
    {
      "id": "airlock_doors",
      "name": "Airlock Doors",
      "rarity": 3,
      "patch": "9.0.0",
      "tags": [
        "DvarkaDeepwood",
        "MapSelection",
        "RealmSelection"
      ],
      "mechanics": {
        "effect": "20 %",
        "realm": "Dvarka Deepwood",
        "map": "Nostromo Wreckage",
        "secret": true
      }
    },
    {
      "id": "alien_flora",
      "name": "Alien Flora",
      "rarity": 3,
      "patch": "9.0.0",
      "tags": [
        "DvarkaDeepwood",
        "MapSelection",
        "RealmSelection"
      ],
      "mechanics": {
        "effect": "20 %",
        "realm": "Dvarka Deepwood",
        "map": "Toba Landing",
        "secret": true
      }
    },
    {
      "id": "annotated_blueprint",
      "name": "Annotated Blueprint",
      "rarity": 1,
      "tags": [
        "Hatch",
        "MapModifier"
      ],
      "mechanics": {
        "secret": true
      }
    },
    {
      "id": "arcane_dousing_rod",
      "name": "Arcane Dousing Rod",
      "rarity": 8,
      "patch": "8.3.0",
      "tags": [
        "Bloodpoints",
        "Event",
        "halloweenEvent"
      ],
      "mechanics": {
        "bonus": "+100 %"
      }
    },
    {
      "id": "ardent_raven_wreath",
      "name": "Ardent Raven Wreath",
      "rarity": 3,
      "tags": [
        "Bloodpoints",
        "Deviousness"
      ],
      "charType": "K"
    },
    {
      "id": "ardent_shrike_wreath",
      "name": "Ardent Shrike Wreath",
      "rarity": 3,
      "tags": [
        "Bloodpoints",
        "Sacrifice"
      ],
      "charType": "K"
    },
    {
      "id": "ardent_spotted_owl_wreath",
      "name": "Ardent Spotted Owl Wreath",
      "rarity": 3,
      "tags": [
        "Bloodpoints",
        "Hunter"
      ],
      "charType": "K"
    },
    {
      "id": "ardent_tanager_wreath",
      "name": "Ardent Tanager Wreath",
      "rarity": 3,
      "tags": [
        "Bloodpoints",
        "Brutality"
      ],
      "charType": "K"
    },
    {
      "id": "azarov_s_key",
      "name": "Azarov's Key",
      "rarity": 3,
      "patch": "9.0.0",
      "tags": [
        "AutohavenWreckers",
        "RealmSelection"
      ],
      "mechanics": {
        "effect": "20 %",
        "realm": "Autohaven Wreckers",
        "secret": true
      }
    },
    {
      "id": "bbq_invitation",
      "name": "BBQ Invitation",
      "rarity": 8,
      "tags": [
        "Bloodpoints",
        "Event",
        "summerEvent"
      ]
    },
    {
      "id": "beef_tallow_mixture",
      "name": "Beef Tallow Mixture",
      "rarity": 3,
      "patch": "9.0.0",
      "tags": [
        "TheDecimatedBorgo",
        "RealmSelection"
      ],
      "mechanics": {
        "effect": "20 %",
        "realm": "The Decimated Borgo",
        "secret": true
      }
    },
    {
      "id": "black_salt_statuette",
      "name": "Black Salt Statuette",
      "rarity": 3,
      "patch": "9.0.0",
      "tags": [
        "AllSurvivors",
        "AllSurvivorsLuck",
        "Chance"
      ],
      "mechanics": {
        "effect": "+2 %"
      },
      "charType": "S"
    },
    {
      "id": "black_ward",
      "name": "Black Ward",
      "rarity": 4,
      "tags": [
        "Ward"
      ],
      "mechanics": {
        "secret": true
      },
      "charType": "K"
    },
    {
      "id": "bloodied_blueprint",
      "name": "Bloodied Blueprint",
      "rarity": 1,
      "tags": [
        "Auras",
        "Basement",
        "MapModifier"
      ],
      "mechanics": {
        "secret": true
      }
    },
    {
      "id": "bloodshot_eye",
      "name": "Bloodshot Eye",
      "rarity": 8,
      "patch": "8.6.0",
      "tags": [
        "Bloodpoints",
        "Event",
        "Personal",
        "springEvent"
      ]
    },
    {
      "id": "bloody_party_streamers",
      "name": "Bloody Party Streamers",
      "rarity": 3,
      "tags": [
        "AllCategories",
        "AllPlayers",
        "Bloodpoints"
      ]
    },
    {
      "id": "bound_envelope",
      "name": "Bound Envelope",
      "rarity": 3,
      "tags": [
        "AllCategories",
        "AllSurvivors",
        "Bloodpoints"
      ],
      "charType": "S"
    },
    {
      "id": "bog_laurel_sachet",
      "name": "Bog Laurel Sachet",
      "rarity": 1,
      "tags": [
        "Bloodpoints",
        "Objectives",
        "Personal"
      ],
      "charType": "S"
    },
    {
      "id": "chalk_pouch",
      "name": "Chalk Pouch",
      "rarity": 1,
      "patch": "9.0.0",
      "tags": [
        "Chance",
        "Personal",
        "PersonalLuck"
      ],
      "mechanics": {
        "effect": "+1 %",
        "secret": true
      },
      "charType": "S"
    },
    {
      "id": "charred_wedding_photograph",
      "name": "Charred Wedding Photograph",
      "rarity": 3,
      "patch": "9.0.0",
      "tags": [
        "CrotusPrennAsylum",
        "RealmSelection"
      ],
      "mechanics": {
        "effect": "20 %",
        "realm": "Crotus Prenn Asylum",
        "secret": true
      }
    },
    {
      "id": "clear_reagent",
      "name": "Clear Reagent",
      "rarity": 1,
      "tags": [
        "Fog",
        "MapModifier"
      ],
      "mechanics": {
        "secret": true
      }
    },
    {
      "id": "cream_chalk_pouch",
      "name": "Cream Chalk Pouch",
      "rarity": 2,
      "patch": "9.0.0",
      "tags": [
        "Chance",
        "Personal",
        "PersonalLuck"
      ],
      "mechanics": {
        "effect": "+2 %",
        "secret": true
      },
      "charType": "S"
    },
    {
      "id": "crispleaf_amaranth_sachet",
      "name": "Crispleaf Amaranth Sachet",
      "rarity": 1,
      "tags": [
        "Bloodpoints",
        "Personal",
        "Survival"
      ],
      "charType": "S"
    },
    {
      "id": "crow_s_eye",
      "name": "Crow's Eye",
      "rarity": 3,
      "patch": "9.0.0",
      "tags": [
        "ForsakenBoneyard",
        "RealmSelection"
      ],
      "mechanics": {
        "effect": "20 %",
        "realm": "Forsaken Boneyard",
        "secret": true
      }
    },
    {
      "id": "cursed_seed",
      "name": "Cursed Seed",
      "rarity": 8,
      "tags": [
        "Bloodpoints",
        "Event",
        "halloweenEvent"
      ],
      "mechanics": {
        "notAvailable": true
      }
    },
    {
      "id": "cut_coin",
      "name": "Cut Coin",
      "rarity": 4,
      "tags": [
        "Chest",
        "MapModifier"
      ],
      "mechanics": {
        "secret": true
      },
      "charType": "K"
    },
    {
      "id": "damaged_photo",
      "name": "Damaged Photo",
      "rarity": 3,
      "patch": "9.0.0",
      "tags": [
        "Ormond",
        "RealmSelection"
      ],
      "mechanics": {
        "effect": "20 %",
        "realm": "Ormond",
        "secret": true
      }
    },
    {
      "id": "devout_raven_wreath",
      "name": "Devout Raven Wreath",
      "rarity": 2,
      "tags": [
        "Bloodpoints",
        "Deviousness"
      ],
      "charType": "K"
    },
    {
      "id": "devout_shrike_wreath",
      "name": "Devout Shrike Wreath",
      "rarity": 2,
      "tags": [
        "Bloodpoints",
        "Sacrifice"
      ],
      "charType": "K"
    },
    {
      "id": "devout_spotted_owl_wreath",
      "name": "Devout Spotted Owl Wreath",
      "rarity": 2,
      "tags": [
        "Bloodpoints",
        "Hunter"
      ],
      "charType": "K"
    },
    {
      "id": "devout_tanager_wreath",
      "name": "Devout Tanager Wreath",
      "rarity": 2,
      "tags": [
        "Bloodpoints",
        "Brutality"
      ],
      "charType": "K"
    },
    {
      "id": "ebony_memento_mori",
      "name": "Ebony Memento Mori",
      "rarity": 5,
      "patch": "4.4.1",
      "tags": [
        "Mori"
      ],
      "mechanics": {
        "hookStageCount": 2,
        "secret": true
      },
      "charType": "K"
    },
    {
      "id": "escape_cake",
      "name": "Escape! Cake",
      "rarity": 2,
      "tags": [
        "AllCategories",
        "Bloodpoints",
        "Personal"
      ],
      "charType": "S"
    },
    {
      "id": "faint_reagent",
      "name": "Faint Reagent",
      "rarity": 1,
      "tags": [
        "Fog",
        "MapModifier"
      ],
      "mechanics": {
        "secret": true
      }
    },
    {
      "id": "fragrant_bog_laurel",
      "name": "Fragrant Bog Laurel",
      "rarity": 3,
      "tags": [
        "Bloodpoints",
        "Objectives",
        "Personal"
      ],
      "charType": "S"
    },
    {
      "id": "fragrant_crispleaf_amaranth",
      "name": "Fragrant Crispleaf Amaranth",
      "rarity": 3,
      "tags": [
        "Bloodpoints",
        "Personal",
        "Survival"
      ],
      "charType": "S"
    },
    {
      "id": "fragrant_primrose_blossom",
      "name": "Fragrant Primrose Blossom",
      "rarity": 3,
      "tags": [
        "Bloodpoints",
        "Personal",
        "Altruism"
      ],
      "charType": "S"
    },
    {
      "id": "fragrant_sweet_william",
      "name": "Fragrant Sweet William",
      "rarity": 3,
      "tags": [
        "Bloodpoints",
        "Personal",
        "Boldness"
      ],
      "charType": "S"
    },
    {
      "id": "fresh_bog_laurel",
      "name": "Fresh Bog Laurel",
      "rarity": 2,
      "tags": [
        "Bloodpoints",
        "Objectives",
        "Personal"
      ],
      "charType": "S"
    },
    {
      "id": "fresh_crispleaf_amaranth",
      "name": "Fresh Crispleaf Amaranth",
      "rarity": 2,
      "tags": [
        "Bloodpoints",
        "Personal",
        "Survival"
      ],
      "charType": "S"
    },
    {
      "id": "fresh_primrose_blossom",
      "name": "Fresh Primrose Blossom",
      "rarity": 2,
      "tags": [
        "Bloodpoints",
        "Personal",
        "Altruism"
      ],
      "charType": "S"
    },
    {
      "id": "fresh_sweet_william",
      "name": "Fresh Sweet William",
      "rarity": 2,
      "tags": [
        "Bloodpoints",
        "Personal",
        "Boldness"
      ],
      "charType": "S"
    },
    {
      "id": "grandma_s_cookbook",
      "name": "Grandma's Cookbook",
      "rarity": 3,
      "patch": "9.0.0",
      "tags": [
        "BackwaterSwamp",
        "RealmSelection"
      ],
      "mechanics": {
        "effect": "20 %",
        "realm": "Backwater Swamp",
        "secret": true
      }
    },
    {
      "id": "hawkins_national_laboratory_id",
      "name": "Hawkins National Laboratory ID",
      "rarity": 3,
      "patch": "9.0.0",
      "tags": [
        "HawkinsNationalLaboratory",
        "RealmSelection"
      ],
      "mechanics": {
        "effect": "20 %",
        "realm": "Hawkins National Laboratory",
        "secret": true
      }
    },
    {
      "id": "hazy_reagent",
      "name": "Hazy Reagent",
      "rarity": 2,
      "tags": [
        "Fog",
        "MapModifier"
      ],
      "mechanics": {
        "secret": true
      }
    },
    {
      "id": "heart_locket",
      "name": "Heart Locket",
      "rarity": 3,
      "patch": "9.0.0",
      "tags": [
        "ColdwindFarm",
        "RealmSelection"
      ],
      "mechanics": {
        "effect": "20 %",
        "realm": "Coldwind Farm",
        "secret": true
      }
    },
    {
      "id": "hollow_shell",
      "name": "Hollow Shell",
      "rarity": 2,
      "tags": [
        "AllCategories",
        "Bloodpoints"
      ],
      "charType": "K"
    },
    {
      "id": "ichorous_loam",
      "name": "Ichorous Loam",
      "rarity": 3,
      "patch": "9.0.0",
      "tags": [
        "WitheredIsle",
        "RealmSelection"
      ],
      "mechanics": {
        "effect": "20 %",
        "realm": "Withered Isle",
        "secret": true
      }
    },
    {
      "id": "ivory_chalk_pouch",
      "name": "Ivory Chalk Pouch",
      "rarity": 3,
      "patch": "9.0.0",
      "tags": [
        "Chance",
        "Personal",
        "PersonalLuck"
      ],
      "mechanics": {
        "effect": "+3 %",
        "secret": true
      },
      "charType": "S"
    },
    {
      "id": "ivory_memento_mori",
      "name": "Ivory Memento Mori",
      "rarity": 3,
      "patch": "4.4.1",
      "tags": [
        "Mori"
      ],
      "mechanics": {
        "hookStageCount": 2,
        "secret": true
      },
      "charType": "K"
    },
    {
      "id": "jigsaw_piece",
      "name": "Jigsaw Piece",
      "rarity": 3,
      "patch": "9.0.0",
      "tags": [
        "GideonMeatPlant",
        "RealmSelection"
      ],
      "mechanics": {
        "effect": "20 %",
        "realm": "Gideon Meat Plant",
        "secret": true
      }
    },
    {
      "id": "macmillan_s_phalanx_bone",
      "name": "MacMillan's Phalanx Bone",
      "rarity": 3,
      "patch": "9.0.0",
      "tags": [
        "TheMacMillanEstate",
        "RealmSelection"
      ],
      "mechanics": {
        "effect": "20 %",
        "realm": "The MacMillan Estate",
        "secret": true
      }
    },
    {
      "id": "mary_s_letter",
      "name": "Mary's Letter",
      "rarity": 3,
      "patch": "9.0.0",
      "tags": [
        "SilentHill",
        "RealmSelection"
      ],
      "mechanics": {
        "effect": "20 %",
        "realm": "Silent Hill",
        "secret": true
      }
    },
    {
      "id": "mistle_toes",
      "name": "Mistle Toes",
      "rarity": 8,
      "patch": "8.4.0",
      "tags": [
        "Bloodpoints",
        "Chests",
        "Event",
        "Personal",
        "Snowskulls",
        "winterEvent"
      ]
    },
    {
      "id": "mouldy_oak",
      "name": "Mouldy Oak",
      "rarity": 2,
      "tags": [
        "Hook",
        "MapModifier"
      ],
      "mechanics": {
        "secret": true
      },
      "charType": "K"
    },
    {
      "id": "murky_reagent",
      "name": "Murky Reagent",
      "rarity": 4,
      "tags": [
        "Fog",
        "MapModifier"
      ],
      "mechanics": {
        "secret": true
      }
    },
    {
      "id": "petrified_oak",
      "name": "Petrified Oak",
      "rarity": 4,
      "tags": [
        "Hook",
        "MapModifier"
      ],
      "mechanics": {
        "secret": true
      },
      "charType": "S"
    },
    {
      "id": "primrose_blossom_sachet",
      "name": "Primrose Blossom Sachet",
      "rarity": 1,
      "tags": [
        "Bloodpoints",
        "Personal",
        "Altruism"
      ],
      "charType": "S"
    },
    {
      "id": "pustula_petals",
      "name": "Pustula Petals",
      "rarity": 8,
      "tags": [
        "Bloodpoints",
        "Event",
        "halloweenEvent"
      ],
      "mechanics": {
        "notAvailable": true
      }
    },
    {
      "id": "putrid_oak",
      "name": "Putrid Oak",
      "rarity": 4,
      "tags": [
        "Hook",
        "MapModifier"
      ],
      "mechanics": {
        "secret": true
      },
      "charType": "K"
    },
    {
      "id": "raven_wreath",
      "name": "Raven Wreath",
      "rarity": 1,
      "tags": [
        "Bloodpoints",
        "Deviousness"
      ],
      "charType": "K"
    },
    {
      "id": "red_envelope",
      "name": "Red Envelope",
      "rarity": 8,
      "tags": [
        "Bloodpoints",
        "Event",
        "lunarEvent"
      ]
    },
    {
      "id": "rotten_oak",
      "name": "Rotten Oak",
      "rarity": 3,
      "tags": [
        "Hook",
        "MapModifier"
      ],
      "mechanics": {
        "secret": true
      },
      "charType": "K"
    },
    {
      "id": "rpd_badge",
      "name": "RPD Badge",
      "rarity": 3,
      "patch": "9.0.0",
      "tags": [
        "RaccoonCity",
        "RealmSelection"
      ],
      "mechanics": {
        "effect": "20 %",
        "realm": "Raccoon City",
        "secret": true
      }
    },
    {
      "id": "sacrificial_ward",
      "name": "Sacrificial Ward",
      "rarity": 1,
      "patch": "8.4.0",
      "tags": [
        "Ward"
      ]
    },
    {
      "id": "salt_pouch",
      "name": "Salt Pouch",
      "rarity": 2,
      "patch": "9.0.0",
      "tags": [
        "AllPlayers",
        "AllSurvivorsLuck",
        "Chance"
      ],
      "mechanics": {
        "effect": "+1 %"
      },
      "charType": "S"
    },
    {
      "id": "scratched_coin",
      "name": "Scratched Coin",
      "rarity": 2,
      "tags": [
        "Chest",
        "MapModifier"
      ],
      "mechanics": {
        "secret": true
      },
      "charType": "K"
    },
    {
      "id": "sealed_envelope",
      "name": "Sealed Envelope",
      "rarity": 2,
      "tags": [
        "Bloodpoints",
        "AllCategories",
        "Personal"
      ],
      "charType": "S"
    },
    {
      "id": "shattered_bottle",
      "name": "Shattered Bottle",
      "rarity": 3,
      "patch": "9.0.0",
      "tags": [
        "GraveOfGlenvale",
        "RealmSelection"
      ],
      "mechanics": {
        "effect": "20 %",
        "realm": "Grave of Glenvale",
        "secret": true
      }
    },
    {
      "id": "shattered_glasses",
      "name": "Shattered Glasses",
      "rarity": 3,
      "patch": "9.0.0",
      "tags": [
        "LérysMemorialInstitute",
        "RealmSelection"
      ],
      "mechanics": {
        "effect": "20 %",
        "realm": "Léry's Memorial Institute",
        "secret": true
      }
    },
    {
      "id": "shiny_coin",
      "name": "Shiny Coin",
      "rarity": 4,
      "tags": [
        "Chest",
        "MapModifier"
      ],
      "mechanics": {
        "secret": true
      },
      "charType": "S"
    },
    {
      "id": "shrike_wreath",
      "name": "Shrike Wreath",
      "rarity": 1,
      "tags": [
        "Bloodpoints",
        "Sacrifice"
      ],
      "charType": "K"
    },
    {
      "id": "shroud_of_separation",
      "name": "Shroud of Separation",
      "rarity": 4,
      "patch": "9.0.0",
      "tags": [
        "Shroud"
      ],
      "mechanics": {
        "secret": true
      },
      "charType": "S"
    },
    {
      "id": "shroud_of_vanishing",
      "name": "Shroud of Vanishing",
      "rarity": 2,
      "patch": "9.0.0",
      "tags": [
        "Shroud"
      ],
      "mechanics": {
        "secret": true
      },
      "charType": "K"
    },
    {
      "id": "shroud_of_union",
      "name": "Shroud of Union",
      "rarity": 2,
      "patch": "9.0.0",
      "tags": [
        "Shroud"
      ],
      "mechanics": {
        "secret": true
      },
      "charType": "S"
    },
    {
      "id": "spotted_owl_wreath",
      "name": "Spotted Owl Wreath",
      "rarity": 1,
      "tags": [
        "Bloodpoints",
        "Hunter"
      ],
      "charType": "K"
    },
    {
      "id": "strode_realty_key",
      "name": "Strode Realty Key",
      "rarity": 3,
      "patch": "9.0.0",
      "tags": [
        "Haddonfield",
        "RealmSelection"
      ],
      "mechanics": {
        "effect": "20 %",
        "realm": "Haddonfield",
        "secret": true
      }
    },
    {
      "id": "survivor_pudding",
      "name": "Survivor Pudding",
      "rarity": 2,
      "tags": [
        "AllCategories",
        "Bloodpoints"
      ],
      "charType": "K"
    },
    {
      "id": "sweet_william_sachet",
      "name": "Sweet William Sachet",
      "rarity": 1,
      "tags": [
        "Bloodpoints",
        "Personal",
        "Boldness"
      ],
      "charType": "S"
    },
    {
      "id": "tanager_wreath",
      "name": "Tanager Wreath",
      "rarity": 1,
      "tags": [
        "Bloodpoints",
        "Brutality"
      ],
      "charType": "K"
    },
    {
      "id": "tarnished_coin",
      "name": "Tarnished Coin",
      "rarity": 2,
      "tags": [
        "Chest",
        "MapModifier"
      ],
      "mechanics": {
        "secret": true
      },
      "charType": "S"
    },
    {
      "id": "the_last_mask",
      "name": "The Last Mask",
      "rarity": 3,
      "patch": "9.0.0",
      "tags": [
        "RedForest",
        "RealmSelection"
      ],
      "mechanics": {
        "effect": "20 %",
        "realm": "Red Forest",
        "secret": true
      }
    },
    {
      "id": "the_pied_piper",
      "name": "The Pied Piper",
      "rarity": 3,
      "patch": "9.0.0",
      "tags": [
        "Springwood",
        "RealmSelection"
      ],
      "mechanics": {
        "effect": "20 %",
        "realm": "Springwood",
        "secret": true
      }
    },
    {
      "id": "toothy_torte",
      "name": "Toothy Torte",
      "rarity": 8,
      "patch": "10.0.1",
      "tags": [
        "AllPlayers",
        "AllCategories",
        "anniversaryEvent",
        "Bloodpoints",
        "Event",
        "EventCake"
      ],
      "mechanics": {
        "percentage": "+110 %",
        "aura": "16 metres"
      }
    },
    {
      "id": "torn_blueprint",
      "name": "Torn Blueprint",
      "rarity": 1,
      "tags": [
        "Auras",
        "Basement",
        "MapModifier"
      ],
      "mechanics": {
        "secret": true
      }
    },
    {
      "id": "vigo_s_blueprint",
      "name": "Vigo's Blueprint",
      "rarity": 1,
      "tags": [
        "Hatch",
        "MapModifier",
        "MapModifier"
      ],
      "mechanics": {
        "secret": true
      }
    },
    {
      "id": "vigo_s_jar_of_salty_lips",
      "name": "Vigo's Jar of Salty Lips",
      "rarity": 4,
      "patch": "9.0.0",
      "tags": [
        "AllSurvivors",
        "AllSurvivorsLuck",
        "Chance"
      ],
      "mechanics": {
        "effect": "+3 %"
      },
      "charType": "S"
    },
    {
      "id": "vigo_s_shroud",
      "name": "Vigo's Shroud",
      "rarity": 2,
      "patch": "1.0.0",
      "tags": [
        "Shroud"
      ],
      "mechanics": {
        "secret": true
      },
      "charType": "S"
    },
    {
      "id": "vip_wristband",
      "name": "VIP Wristband",
      "rarity": 3,
      "patch": "9.5.0",
      "tags": [
        "SleeplessDistrict",
        "MapSelection",
        "RealmSelection"
      ],
      "mechanics": {
        "effect": "20 %",
        "realm": "Sleepless District",
        "map": "Trickster's Delusion",
        "secret": true
      }
    },
    {
      "id": "white_ward",
      "name": "White Ward",
      "rarity": 4,
      "tags": [
        "Ward"
      ],
      "mechanics": {
        "secret": true
      },
      "charType": "S"
    },
    {
      "id": "yamaoka_family_crest",
      "name": "Yamaoka Family Crest",
      "rarity": 3,
      "patch": "9.0.0",
      "tags": [
        "YamaokaEstate",
        "RealmSelection"
      ],
      "mechanics": {
        "effect": "20 %",
        "realm": "Yamaoka Estate",
        "secret": true
      }
    },
    {
      "id": "black_tea",
      "name": "Black Tea",
      "rarity": 1,
      "tags": [
        "Tea",
        "XP",
        "Personal"
      ],
      "mechanics": {
        "mobile": true
      },
      "charType": "S"
    },
    {
      "id": "blank_postcard",
      "name": "Blank Postcard",
      "rarity": 2,
      "tags": [
        "Postcard",
        "XP",
        "AllPlayers"
      ],
      "mechanics": {
        "mobile": true
      },
      "charType": "S"
    },
    {
      "id": "bloodstone_chalice",
      "name": "Bloodstone Chalice",
      "rarity": 4,
      "tags": [
        "Chalice",
        "XP",
        "Personal"
      ],
      "mechanics": {
        "mobile": true
      },
      "charType": "K"
    },
    {
      "id": "bone_doll",
      "name": "Bone Doll",
      "rarity": 4,
      "tags": [
        "Doll",
        "XP",
        "AllPlayers"
      ],
      "mechanics": {
        "mobile": true
      },
      "charType": "K"
    },
    {
      "id": "burdock_tea",
      "name": "Burdock Tea",
      "rarity": 3,
      "tags": [
        "Tea",
        "XP",
        "Personal"
      ],
      "mechanics": {
        "mobile": true
      },
      "charType": "S"
    },
    {
      "id": "ceramic_chalice",
      "name": "Ceramic Chalice",
      "rarity": 2,
      "tags": [
        "Chalice",
        "XP",
        "Personal"
      ],
      "mechanics": {
        "mobile": true
      },
      "charType": "K"
    },
    {
      "id": "clay_doll",
      "name": "Clay Doll",
      "rarity": 2,
      "tags": [
        "Doll",
        "XP",
        "AllPlayers"
      ],
      "mechanics": {
        "mobile": true
      },
      "charType": "K"
    },
    {
      "id": "copper_chalice",
      "name": "Copper Chalice",
      "rarity": 3,
      "tags": [
        "Chalice",
        "XP",
        "Personal"
      ],
      "mechanics": {
        "mobile": true
      },
      "charType": "K"
    },
    {
      "id": "crumpled_postcard",
      "name": "Crumpled Postcard",
      "rarity": 3,
      "tags": [
        "Postcard",
        "XP",
        "AllPlayers"
      ],
      "mechanics": {
        "mobile": true
      },
      "charType": "S"
    },
    {
      "id": "flesh_doll",
      "name": "Flesh Doll",
      "rarity": 5,
      "tags": [
        "Doll",
        "XP",
        "AllPlayers"
      ],
      "mechanics": {
        "mobile": true
      },
      "charType": "K"
    },
    {
      "id": "lotus_leaf_tea",
      "name": "Lotus Leaf Tea",
      "rarity": 4,
      "tags": [
        "Tea",
        "XP",
        "Personal"
      ],
      "mechanics": {
        "mobile": true
      },
      "charType": "S"
    },
    {
      "id": "lovers_postcard",
      "name": "Lovers' Postcard",
      "rarity": 5,
      "tags": [
        "Postcard",
        "XP",
        "AllPlayers"
      ],
      "mechanics": {
        "mobile": true
      },
      "charType": "S"
    },
    {
      "id": "milk_tea",
      "name": "Milk Tea",
      "rarity": 2,
      "tags": [
        "Tea",
        "XP",
        "Personal"
      ],
      "mechanics": {
        "mobile": true
      },
      "charType": "S"
    },
    {
      "id": "stamped_postcard",
      "name": "Stamped Postcard",
      "rarity": 4,
      "tags": [
        "Postcard",
        "XP",
        "AllPlayers"
      ],
      "mechanics": {
        "mobile": true
      },
      "charType": "S"
    },
    {
      "id": "thorn_doll",
      "name": "Thorn Doll",
      "rarity": 3,
      "tags": [
        "Doll",
        "XP",
        "AllPlayers"
      ],
      "mechanics": {
        "mobile": true
      },
      "charType": "K"
    },
    {
      "id": "wooden_chalice",
      "name": "Wooden Chalice",
      "rarity": 1,
      "tags": [
        "Chalice",
        "XP",
        "Personal"
      ],
      "mechanics": {
        "mobile": true
      },
      "charType": "K"
    }
  ],
  "killerPerks": [
    {
      "id": "a_nurse_s_calling",
      "name": "A Nurse's Calling",
      "genericVersion": false,
      "character": 4,
      "patch": "9.2.0",
      "units": [
        3
      ],
      "values": [
        28,
        30,
        32
      ],
      "tags": [
        "Auras",
        "Healing"
      ]
    },
    {
      "id": "agitation",
      "name": "Agitation",
      "genericVersion": false,
      "character": 1,
      "patch": "2.6.2",
      "units": [
        4
      ],
      "values": [
        6,
        12,
        18
      ],
      "tags": [
        "Carrying",
        "MovementSpeed",
        "TerrorRadius"
      ],
      "mechanics": {
        "radius": "+12 metres"
      }
    },
    {
      "id": "alien_instinct",
      "name": "Alien Instinct",
      "genericVersion": false,
      "character": 33,
      "patch": "8.6.0",
      "units": [
        1
      ],
      "values": [
        40,
        50,
        60
      ],
      "tags": [
        "Auras",
        "Hooks",
        "Oblivious"
      ],
      "mechanics": {
        "aura": "8 seconds"
      }
    },
    {
      "id": "all_shaking_thunder",
      "name": "All-Shaking Thunder",
      "genericVersion": false,
      "character": 38,
      "patch": "9.2.0",
      "units": [
        1
      ],
      "values": [
        15,
        20,
        25
      ],
      "tags": [
        "Falling",
        "Lunge"
      ],
      "mechanics": {
        "lunge": "+75 %",
        "cooldown": "5 seconds"
      }
    },
    {
      "id": "awakened_awareness",
      "name": "Awakened Awareness",
      "genericVersion": false,
      "character": 29,
      "patch": "6.2.0",
      "units": [
        3
      ],
      "values": [
        16,
        18,
        20
      ],
      "tags": [
        "Auras",
        "Carrying"
      ]
    },
    {
      "id": "bamboozle",
      "name": "Bamboozle",
      "genericVersion": false,
      "character": 12,
      "patch": "2.5.0",
      "units": [
        4,
        1
      ],
      "values": [
        5,
        10,
        15,
        8,
        12,
        16
      ],
      "tags": [
        "ActionSpeed",
        "Vaulting",
        "VaultLocations",
        "WindowBlocker"
      ]
    },
    {
      "id": "barbecue_chilli",
      "name": "Barbecue & Chilli",
      "genericVersion": false,
      "character": 9,
      "patch": "7.1.0",
      "units": [
        3
      ],
      "values": [
        60,
        50,
        40
      ],
      "tags": [
        "Auras",
        "Hooks"
      ]
    },
    {
      "id": "batteries_included",
      "name": "Batteries Included",
      "genericVersion": false,
      "character": 34,
      "patch": "9.0.0",
      "units": [
        2
      ],
      "values": [
        1,
        3,
        5
      ],
      "tags": [
        "Generators",
        "Haste"
      ],
      "mechanics": {
        "range": "16 metres",
        "haste": "+5 %"
      }
    },
    {
      "id": "beast_of_prey",
      "name": "Beast of Prey",
      "genericVersion": false,
      "character": 8,
      "units": [
        1
      ],
      "values": [
        30,
        35,
        40
      ],
      "tags": [
        "Bloodlust",
        "Deception",
        "Stealth",
        "Undetectable"
      ]
    },
    {
      "id": "bitter_murmur",
      "name": "Bitter Murmur",
      "genericVersion": false,
      "patch": "2.1.0",
      "units": [
        1
      ],
      "values": [
        5,
        7,
        10
      ],
      "tags": [
        "Auras",
        "Generators"
      ],
      "mechanics": {
        "range": "16 metres",
        "duration": "5 seconds"
      }
    },
    {
      "id": "blood_echo",
      "name": "Blood Echo",
      "genericVersion": false,
      "character": 18,
      "patch": "8.3.0",
      "units": [
        1
      ],
      "values": [
        20,
        25,
        30
      ],
      "tags": [
        "Exhausted",
        "Haemorrhage",
        "Hooks"
      ]
    },
    {
      "id": "blood_warden",
      "name": "Blood Warden",
      "genericVersion": false,
      "character": 10,
      "patch": "1.8.0",
      "units": [
        1
      ],
      "values": [
        40,
        50,
        60
      ],
      "tags": [
        "Auras",
        "ExitGates",
        "GateBlocker",
        "Hooks"
      ]
    },
    {
      "id": "bloodhound",
      "name": "Bloodhound",
      "genericVersion": false,
      "character": 2,
      "patch": "1.8.3",
      "units": [
        1
      ],
      "values": [
        2,
        3,
        4
      ],
      "tags": [
        "PoolsOfBlood"
      ]
    },
    {
      "id": "brutal_strength",
      "name": "Brutal Strength",
      "genericVersion": false,
      "character": 1,
      "units": [
        4
      ],
      "values": [
        10,
        15,
        20
      ],
      "tags": [
        "ActionSpeed",
        "BreakableWalls",
        "Generators",
        "Pallets"
      ]
    },
    {
      "id": "call_of_brine",
      "name": "Call of Brine",
      "genericVersion": false,
      "character": 27,
      "patch": "9.0.0",
      "units": [
        4
      ],
      "values": [
        130,
        140,
        150
      ],
      "tags": [
        "Generators",
        "Regression",
        "SkillChecks"
      ],
      "mechanics": {
        "duration": "70 seconds"
      }
    },
    {
      "id": "corrupt_intervention",
      "name": "Corrupt Intervention",
      "genericVersion": false,
      "character": 15,
      "patch": "6.1.0",
      "units": [
        1
      ],
      "values": [
        80,
        100,
        120
      ],
      "tags": [
        "GenBlocker",
        "Generators"
      ]
    },
    {
      "id": "coulrophobia",
      "name": "Coulrophobia",
      "genericVersion": false,
      "character": 12,
      "patch": "6.1.0",
      "units": [
        4
      ],
      "values": [
        30,
        40,
        50
      ],
      "tags": [
        "ActionSpeed",
        "Healing",
        "HealingProficiency",
        "RotationSpeed",
        "SkillChecks",
        "TerrorRadius"
      ],
      "mechanics": {
        "effect": "+50 %"
      }
    },
    {
      "id": "coup_de_grace",
      "name": "Coup de Grâce",
      "genericVersion": false,
      "character": 22,
      "patch": "7.1.0",
      "units": [
        4
      ],
      "values": [
        70,
        75,
        80
      ],
      "tags": [
        "Generators",
        "Lunge",
        "Tokens"
      ],
      "mechanics": {
        "diacritics": true
      }
    },
    {
      "id": "cruel_limits",
      "name": "Cruel Limits",
      "genericVersion": false,
      "character": 17,
      "patch": "7.3.3",
      "units": [
        1
      ],
      "values": [
        20,
        25,
        30
      ],
      "tags": [
        "Auras",
        "Generators",
        "VaultLocations",
        "WindowBlocker"
      ]
    },
    {
      "id": "cull_the_weak",
      "name": "Cull the Weak",
      "formerName": "Dying Light",
      "genericVersion": false,
      "units": [
        4,
        4
      ],
      "values": [
        2,
        2.5,
        3,
        22,
        27.5,
        33
      ],
      "tags": [
        "ActionSpeed",
        "HealingProficiency",
        "Obsession",
        "RepairingProficiency",
        "SabotageProficiency",
        "Tokens"
      ]
    },
    {
      "id": "dying_light",
      "name": "Dying Light",
      "genericVersion": false,
      "character": 5
    },
    {
      "id": "dark_arrogance",
      "name": "Dark Arrogance",
      "genericVersion": false,
      "character": 36,
      "patch": "9.2.0",
      "units": [
        4
      ],
      "values": [
        15,
        20,
        25
      ],
      "tags": [
        "ActionSpeed",
        "EffectDuration",
        "KillerBlind",
        "KillerStun",
        "Pallets",
        "Vaulting",
        "Windows"
      ],
      "mechanics": {
        "stunRecovery": "-15 %",
        "blindDuration": "+15 %"
      }
    },
    {
      "id": "dark_devotion",
      "name": "Dark Devotion",
      "genericVersion": false,
      "character": 15,
      "patch": "9.0.0",
      "units": [
        1
      ],
      "values": [
        35,
        40,
        45
      ],
      "tags": [
        "Deception",
        "Obsession",
        "Stealth",
        "TerrorRadius",
        "TerrorRadiusTransfer",
        "Undetectable"
      ],
      "mechanics": {
        "radius": "40 metres"
      }
    },
    {
      "id": "darkness_revealed",
      "name": "Darkness Revealed",
      "genericVersion": false,
      "character": 28,
      "patch": "8.1.0",
      "units": [
        1
      ],
      "values": [
        6,
        7,
        8
      ],
      "tags": [
        "Lockers",
        "Auras"
      ]
    },
    {
      "id": "dead_man_s_switch",
      "name": "Dead Man's Switch",
      "genericVersion": false,
      "character": 19,
      "patch": "9.2.0",
      "units": [
        1
      ],
      "values": [
        25,
        30,
        35
      ],
      "tags": [
        "Auras",
        "GenBlocker",
        "Generators",
        "Hooks"
      ]
    },
    {
      "id": "deathbound",
      "name": "Deathbound",
      "genericVersion": false,
      "character": 20,
      "patch": "8.6.0",
      "units": [
        3
      ],
      "values": [
        12,
        8,
        4
      ],
      "tags": [
        "AuraFlareUp",
        "Healing",
        "LoudNoiseNotifications",
        "Oblivious"
      ],
      "mechanics": {
        "healthState": 1
      }
    },
    {
      "id": "deerstalker",
      "name": "Deerstalker",
      "genericVersion": false,
      "patch": "9.2.0",
      "units": [
        1
      ],
      "values": [
        40,
        35,
        30
      ],
      "tags": [
        "Auras"
      ],
      "mechanics": {
        "duration": "3 seconds"
      }
    },
    {
      "id": "discordance",
      "name": "Discordance",
      "genericVersion": false,
      "character": 14,
      "units": [
        3
      ],
      "values": [
        64,
        96,
        128
      ],
      "tags": [
        "Auras",
        "Generators",
        "LoudNoiseNotifications"
      ]
    },
    {
      "id": "dissolution",
      "name": "Dissolution",
      "genericVersion": false,
      "character": 28,
      "units": [
        1
      ],
      "values": [
        12,
        16,
        20
      ],
      "tags": [
        "Pallets",
        "TerrorRadius",
        "Vaulting"
      ]
    },
    {
      "id": "distressing",
      "name": "Distressing",
      "genericVersion": false,
      "patch": "8.4.0",
      "units": [
        4
      ],
      "values": [
        20,
        25,
        30
      ],
      "tags": [
        "TerrorRadius"
      ]
    },
    {
      "id": "dominance",
      "name": "Dominance",
      "genericVersion": false,
      "character": 37,
      "patch": "8.4.0",
      "units": [
        1
      ],
      "values": [
        8,
        12,
        16
      ],
      "tags": [
        "Auras",
        "Chests",
        "ChestBlocker",
        "Totems",
        "TotemBlocker"
      ]
    },
    {
      "id": "dragon_s_grip",
      "name": "Dragon's Grip",
      "genericVersion": false,
      "character": 21,
      "patch": "9.1.0",
      "units": [
        1
      ],
      "values": [
        60,
        45,
        30
      ],
      "tags": [
        "Exposed",
        "Generators",
        "LoudNoiseNotifications",
        "Screams"
      ],
      "mechanics": {
        "activation": "30 seconds",
        "location": "4 seconds",
        "exposed": "60 seconds"
      }
    },
    {
      "id": "enduring",
      "name": "Enduring",
      "genericVersion": false,
      "character": 3,
      "patch": "5.6.1",
      "units": [
        4
      ],
      "values": [
        40,
        45,
        50
      ],
      "tags": [
        "KillerStun",
        "Pallets",
        "StunRecovery"
      ]
    },
    {
      "id": "eruption",
      "name": "Eruption",
      "genericVersion": false,
      "character": 24,
      "patch": "6.6.0",
      "units": [
        1
      ],
      "values": [
        8,
        10,
        12
      ],
      "tags": [
        "Auras",
        "Generators"
      ],
      "mechanics": {
        "penalty": "-10 %",
        "cooldown": "30 seconds"
      }
    },
    {
      "id": "fire_up",
      "name": "Fire Up",
      "genericVersion": false,
      "character": 10,
      "patch": "8.5.0",
      "units": [
        4,
        4
      ],
      "values": [
        4,
        5,
        6,
        20,
        25,
        30
      ],
      "tags": [
        "ActionSpeed",
        "Breaking",
        "Damaging",
        "Dropping",
        "PickingUp",
        "Tokens",
        "Vaulting"
      ]
    },
    {
      "id": "forced_hesitation",
      "name": "Forced Hesitation",
      "genericVersion": false,
      "character": 32,
      "patch": "7.0.0",
      "units": [
        1
      ],
      "values": [
        40,
        35,
        30
      ],
      "tags": [
        "Hindered"
      ],
      "mechanics": {
        "range": "16 metres",
        "hindered": "-20 %",
        "durationHindered": "10 seconds"
      }
    },
    {
      "id": "forced_penance",
      "name": "Forced Penance",
      "genericVersion": false,
      "character": 20,
      "units": [
        1
      ],
      "values": [
        60,
        70,
        80
      ],
      "tags": [
        "Broken",
        "ProtectionHits"
      ]
    },
    {
      "id": "forever_entwined",
      "name": "Forever Entwined",
      "genericVersion": false,
      "character": 39,
      "patch": "8.6.0",
      "units": [
        5,
        4
      ],
      "values": [
        6,
        7,
        8,
        24,
        28,
        32
      ],
      "tags": [
        "ActionSpeed",
        "Dropping",
        "Hooking",
        "PickingUp",
        "Tokens"
      ],
      "mechanics": {
        "tokenGain": "+1 Token",
        "bonus": "+4 %"
      }
    },
    {
      "id": "franklin_s_demise",
      "name": "Franklin's Demise",
      "genericVersion": false,
      "character": 9,
      "patch": "9.1.0",
      "units": [
        3
      ],
      "values": [
        32,
        48,
        64
      ],
      "tags": [
        "Auras",
        "ForcedItemDrop",
        "Items"
      ]
    },
    {
      "id": "friends_til_the_end",
      "name": "Friends 'til the End",
      "genericVersion": false,
      "character": 34,
      "units": [
        1
      ],
      "values": [
        6,
        8,
        10
      ],
      "tags": [
        "Auras",
        "Exposed",
        "Hooks",
        "LoudNoiseNotifications",
        "Obsession"
      ]
    },
    {
      "id": "furtive_chase",
      "name": "Furtive Chase",
      "genericVersion": false,
      "character": 16,
      "patch": "8.7.0",
      "units": [
        1
      ],
      "values": [
        14,
        16,
        18
      ],
      "tags": [
        "Haste",
        "Hooks",
        "Obsession",
        "Undetectable"
      ],
      "mechanics": {
        "haste": "+10 %"
      }
    },
    {
      "id": "game_afoot",
      "name": "Game Afoot",
      "genericVersion": false,
      "character": 31,
      "patch": "8.7.0",
      "units": [
        1
      ],
      "values": [
        8,
        9,
        10
      ],
      "tags": [
        "BreakableWalls",
        "Generators",
        "Haste",
        "Obsession",
        "Pallets"
      ],
      "mechanics": {
        "haste": "+7 %"
      }
    },
    {
      "id": "gearhead",
      "name": "Gearhead",
      "genericVersion": false,
      "character": 19,
      "patch": "6.7.0",
      "units": [
        1
      ],
      "values": [
        6,
        7,
        8
      ],
      "tags": [
        "Auras",
        "Generators",
        "SkillChecks"
      ],
      "mechanics": {
        "activation": "30 seconds"
      }
    },
    {
      "id": "genetic_limits",
      "name": "Genetic Limits",
      "genericVersion": false,
      "character": 32,
      "patch": "8.3.0",
      "units": [
        1
      ],
      "values": [
        6,
        7,
        8
      ],
      "tags": [
        "Exhausted"
      ]
    },
    {
      "id": "grim_embrace",
      "name": "Grim Embrace",
      "genericVersion": false,
      "character": 26,
      "patch": "8.0.0",
      "units": [
        1
      ],
      "values": [
        6,
        8,
        10
      ],
      "tags": [
        "Auras",
        "Generators",
        "GenBlocker",
        "Hooks",
        "Obsession",
        "Tokens"
      ]
    },
    {
      "id": "haywire",
      "name": "Haywire",
      "genericVersion": false,
      "character": 40,
      "patch": "9.0.0",
      "units": [
        4
      ],
      "values": [
        80,
        90,
        100
      ],
      "tags": [
        "ExitGates",
        "RegressionSpeed"
      ],
      "mechanics": {
        "threshold": "80 %"
      }
    },
    {
      "id": "help_wanted",
      "name": "Help Wanted",
      "genericVersion": false,
      "character": 40,
      "patch": "9.0.0",
      "units": [
        1
      ],
      "values": [
        40,
        50,
        60
      ],
      "tags": [
        "AttackCooldown",
        "Generators"
      ],
      "mechanics": {
        "cooldown": "+25 %"
      }
    },
    {
      "id": "hex_blood_favour",
      "name": "Hex: Blood Favour",
      "genericVersion": false,
      "character": 21,
      "patch": "5.3.0",
      "units": [
        3
      ],
      "values": [
        24,
        28,
        32
      ],
      "tags": [
        "Hex",
        "PalletBlocker",
        "Pallets",
        "Totems"
      ],
      "mechanics": {
        "block": "15 seconds"
      }
    },
    {
      "id": "hex_crowd_control",
      "name": "Hex: Crowd Control",
      "genericVersion": false,
      "character": 23,
      "patch": "9.5.0",
      "units": [
        7
      ],
      "values": [
        4,
        5,
        6
      ],
      "tags": [
        "Hex",
        "Totems",
        "Vaulting",
        "VaultLocations",
        "WindowBlocker"
      ],
      "mechanics": {
        "vaultSpeedBonus": "15 %",
        "vaultAuraRange": "24 metres"
      }
    },
    {
      "id": "hex_devour_hope",
      "name": "Hex: Devour Hope",
      "genericVersion": false,
      "character": 6,
      "patch": "2.6.0",
      "units": [
        4
      ],
      "values": [
        3,
        4,
        5
      ],
      "tags": [
        "Hex",
        "Exposed",
        "Killing",
        "Haste",
        "Hooks",
        "Tokens",
        "Totems"
      ],
      "mechanics": {
        "distance": "24 metres",
        "tokens": [
          "+1 Token",
          "5 Tokens"
        ],
        "durationHaste": "10 seconds",
        "delay": "10 seconds"
      }
    },
    {
      "id": "hex_face_the_darkness",
      "name": "Hex: Face the Darkness",
      "genericVersion": false,
      "character": 30,
      "patch": "6.4.0",
      "units": [
        1
      ],
      "values": [
        35,
        30,
        25
      ],
      "tags": [
        "Hex",
        "Auras",
        "LoudNoiseNotifications",
        "TerrorRadius"
      ],
      "mechanics": {
        "aura": "2 seconds"
      }
    },
    {
      "id": "hex_fortune_s_fool",
      "name": "Hex: Fortune's Fool",
      "formerName": "Hex: Plaything",
      "genericVersion": true,
      "patch": "9.0.0",
      "units": [
        3
      ],
      "values": [
        24,
        20,
        16
      ],
      "tags": [
        "Hex",
        "Auras",
        "Oblivious",
        "Totems"
      ],
      "mechanics": {
        "block": "90 seconds",
        "genericVersion": true
      }
    },
    {
      "id": "hex_plaything",
      "name": "Hex: Plaything",
      "genericVersion": false,
      "character": 25
    },
    {
      "id": "hex_haunted_ground",
      "name": "Hex: Haunted Ground",
      "genericVersion": false,
      "character": 13,
      "patch": "2.2.0",
      "units": [
        1
      ],
      "values": [
        40,
        50,
        60
      ],
      "tags": [
        "Hex",
        "Exposed",
        "Totems"
      ]
    },
    {
      "id": "hex_hive_mind",
      "name": "Hex: Hive Mind",
      "genericVersion": false,
      "character": 42,
      "patch": "9.4.0",
      "units": [
        4
      ],
      "values": [
        6,
        8,
        10
      ],
      "tags": [
        "Hex",
        "Auras",
        "Generators",
        "Regression",
        "ProgressionPenalty"
      ],
      "mechanics": {
        "penalty": "-10 %"
      }
    },
    {
      "id": "hex_huntress_lullaby",
      "name": "Hex: Huntress Lullaby",
      "genericVersion": false,
      "character": 8,
      "patch": "1.6.0",
      "units": [
        4
      ],
      "values": [
        2,
        4,
        6
      ],
      "tags": [
        "ActionNoise",
        "Hex",
        "Hooks",
        "ProgressionPenalty",
        "SkillChecks",
        "Tokens",
        "Totems"
      ],
      "mechanics": {
        "tokenGain": "+1 Token",
        "tokenMax": "5 Tokens",
        "penalties": [
          "-14 %",
          "-28 %",
          "-42 %",
          "-56 %"
        ]
      }
    },
    {
      "id": "hex_no_one_escapes_death",
      "name": "Hex: No One Escapes Death",
      "genericVersion": false,
      "patch": "6.1.0",
      "units": [
        4
      ],
      "values": [
        2,
        3,
        4
      ],
      "tags": [
        "ExitGates",
        "Exposed",
        "Haste",
        "Hex",
        "Totems"
      ],
      "mechanics": {
        "aura": [
          "4 metres",
          "24 metres",
          "30 seconds"
        ]
      }
    },
    {
      "id": "hex_nothing_but_misery",
      "name": "Hex: Nothing but Misery",
      "genericVersion": false,
      "character": 39,
      "patch": "8.6.0",
      "units": [
        1
      ],
      "values": [
        10,
        12.5,
        15
      ],
      "tags": [
        "Hex",
        "Hindered",
        "Totems"
      ],
      "mechanics": {
        "attacks": "8 times",
        "hindered": "-5 %"
      }
    },
    {
      "id": "hex_overture_of_doom",
      "name": "Hex: Overture of Doom",
      "genericVersion": false,
      "character": 41,
      "patch": "9.2.0",
      "units": [
        1
      ],
      "values": [
        20,
        25,
        30
      ],
      "tags": [
        "Auras",
        "Generators",
        "Hex",
        "TerrorRadius",
        "TerrorRadiusTransfer",
        "Totems",
        "Undetectable"
      ],
      "mechanics": {
        "trigger": "5 seconds",
        "radius": "32 metres"
      }
    },
    {
      "id": "hex_pentimento",
      "name": "Hex: Pentimento",
      "genericVersion": false,
      "character": 26,
      "patch": "8.7.0",
      "units": [
        4,
        4
      ],
      "values": [
        1,
        2,
        3,
        24,
        28,
        32
      ],
      "tags": [
        "ActionSpeed",
        "Auras",
        "HealingProficiency",
        "Hex",
        "RepairingProficiency",
        "Tokens",
        "TotemBlocker",
        "Totems"
      ],
      "mechanics": {
        "tokenGain": "+1 Token",
        "tokenLimit": "5 Tokens",
        "penalty": "-20 %",
        "range": "16 metres"
      }
    },
    {
      "id": "hex_retribution",
      "name": "Hex: Retribution",
      "genericVersion": false,
      "character": 19,
      "patch": "9.0.0",
      "units": [
        1
      ],
      "values": [
        40,
        50,
        60
      ],
      "tags": [
        "Auras",
        "Hex",
        "Oblivious",
        "Totems"
      ],
      "mechanics": {
        "duration": "20 seconds"
      }
    },
    {
      "id": "hex_ruin",
      "name": "Hex: Ruin",
      "genericVersion": false,
      "character": 6,
      "patch": "9.2.0",
      "units": [
        4
      ],
      "values": [
        100,
        125,
        150
      ],
      "tags": [
        "Generators",
        "Hex",
        "Regression",
        "Totems"
      ]
    },
    {
      "id": "hex_the_third_seal",
      "name": "Hex: The Third Seal",
      "genericVersion": false,
      "character": 6,
      "units": [
        7
      ],
      "values": [
        2,
        3,
        4
      ],
      "tags": [
        "Blindness",
        "Hex",
        "Totems"
      ]
    },
    {
      "id": "hex_thrill_of_the_hunt",
      "name": "Hex: Thrill of the Hunt",
      "genericVersion": false,
      "patch": "8.4.2",
      "units": [
        4,
        4
      ],
      "values": [
        8,
        10,
        12,
        40,
        50,
        60
      ],
      "tags": [
        "ActionSpeed",
        "Blessing",
        "Cleansing",
        "Hex",
        "Tokens",
        "Totems"
      ],
      "mechanics": {
        "tokenCount": "5 Tokens",
        "tokenLoss": "-1 Token"
      }
    },
    {
      "id": "hex_two_can_play",
      "name": "Hex: Two Can Play",
      "genericVersion": false,
      "character": 34,
      "units": [
        8
      ],
      "values": [
        4,
        3,
        2
      ],
      "tags": [
        "Hex",
        "KillerBlind",
        "KillerStun",
        "SurvivorBlind",
        "Totems"
      ]
    },
    {
      "id": "hex_undying",
      "name": "Hex: Undying",
      "genericVersion": false,
      "character": 21,
      "units": [
        3
      ],
      "values": [
        2,
        3,
        4
      ],
      "tags": [
        "Auras",
        "Hex",
        "Totems"
      ]
    },
    {
      "id": "hex_wretched_fate",
      "name": "Hex: Wretched Fate",
      "genericVersion": false,
      "character": 37,
      "patch": "8.2.0",
      "units": [
        4
      ],
      "values": [
        27,
        30,
        33
      ],
      "tags": [
        "Auras",
        "Generators",
        "Hex",
        "Obsession",
        "Totems"
      ]
    },
    {
      "id": "hoarder",
      "name": "Hoarder",
      "genericVersion": false,
      "character": 22,
      "units": [
        3
      ],
      "values": [
        32,
        48,
        64
      ],
      "tags": [
        "Chests",
        "Items",
        "LoudNoiseNotifications"
      ]
    },
    {
      "id": "hubris",
      "name": "Hubris",
      "genericVersion": false,
      "character": 30,
      "patch": "9.1.0",
      "units": [
        1
      ],
      "values": [
        20,
        25,
        30
      ],
      "tags": [
        "Exposed",
        "KillerStun"
      ],
      "mechanics": {
        "cooldown": "20 seconds"
      }
    },
    {
      "id": "human_greed",
      "name": "Human Greed",
      "genericVersion": false,
      "character": 37,
      "patch": "8.4.1",
      "units": [
        1
      ],
      "values": [
        3,
        4,
        5
      ],
      "tags": [
        "ActionSpeed",
        "Auras",
        "Chests"
      ],
      "mechanics": {
        "range": "8 metres",
        "cooldown": "10 seconds"
      }
    },
    {
      "id": "hysteria",
      "name": "Hysteria",
      "genericVersion": false,
      "character": 24,
      "patch": "8.6.0",
      "units": [
        1
      ],
      "values": [
        30,
        35,
        40
      ],
      "tags": [
        "Oblivious"
      ],
      "mechanics": {
        "cooldown": "20 seconds"
      }
    },
    {
      "id": "i_m_all_ears",
      "name": "I'm All Ears",
      "genericVersion": false,
      "character": 16,
      "patch": "8.1.0",
      "units": [
        1
      ],
      "values": [
        60,
        45,
        30
      ],
      "tags": [
        "Auras",
        "Vaulting"
      ],
      "mechanics": {
        "range": "48 metres",
        "duration": "8 seconds"
      }
    },
    {
      "id": "infectious_fright",
      "name": "Infectious Fright",
      "genericVersion": false,
      "character": 15,
      "units": [
        1
      ],
      "values": [
        4,
        5,
        6
      ],
      "tags": [
        "AuraFlareUp",
        "TerrorRadius",
        "LoudNoiseNotifications"
      ]
    },
    {
      "id": "insidious",
      "name": "Insidious",
      "genericVersion": false,
      "patch": "9.1.0",
      "units": [
        2
      ],
      "values": [
        3,
        2,
        1
      ],
      "tags": [
        "Deception",
        "Stealth",
        "Undetectable"
      ]
    },
    {
      "id": "iron_grasp",
      "name": "Iron Grasp",
      "genericVersion": false,
      "patch": "2.6.3",
      "units": [
        4
      ],
      "values": [
        4,
        8,
        12
      ],
      "tags": [
        "ActionTime",
        "Carrying",
        "Wiggle"
      ],
      "mechanics": {
        "wiggleEffects": "-75 %"
      }
    },
    {
      "id": "iron_maiden",
      "name": "Iron Maiden",
      "genericVersion": false,
      "character": 14,
      "patch": "4.5.0",
      "units": [
        4
      ],
      "values": [
        30,
        40,
        50
      ],
      "tags": [
        "ActionSpeed",
        "AuraFlareUp",
        "Exposed",
        "Lockers",
        "LoudNoiseNotifications"
      ],
      "mechanics": {
        "duration": "4 seconds",
        "exposed": "30 seconds"
      }
    },
    {
      "id": "keep_them_waiting",
      "name": "Keep Them Waiting",
      "formerName": "Save the Best for Last",
      "genericVersion": false,
      "patch": "7.5.0",
      "units": [
        5,
        4
      ],
      "values": [
        6,
        7,
        8,
        24,
        28,
        32
      ],
      "tags": [
        "AttackCooldown",
        "Obsession",
        "Tokens"
      ],
      "mechanics": {
        "tokenGain": "+1 Token",
        "tokenCost": "-2 Tokens",
        "cooldownStack": "-4 % per Token"
      }
    },
    {
      "id": "save_the_best_for_last",
      "name": "Save the Best for Last",
      "genericVersion": false,
      "character": 5
    },
    {
      "id": "knock_out",
      "name": "Knock Out",
      "genericVersion": false,
      "character": 9,
      "patch": "8.6.0",
      "units": [
        1
      ],
      "values": [
        3,
        4,
        5
      ],
      "tags": [
        "Hindered",
        "Pallets"
      ],
      "mechanics": {
        "range": "6 metres",
        "timer": "6 seconds",
        "hindered": "-5 %"
      }
    },
    {
      "id": "languid_touch",
      "name": "Languid Touch",
      "genericVersion": false,
      "character": 36,
      "patch": "8.4.0",
      "units": [
        1
      ],
      "values": [
        6,
        8,
        10
      ],
      "tags": [
        "Crows",
        "Exhausted"
      ],
      "mechanics": {
        "range": "36 metres",
        "cooldown": "5 seconds"
      }
    },
    {
      "id": "lethal_pursuer",
      "name": "Lethal Pursuer",
      "genericVersion": false,
      "character": 24,
      "patch": "6.1.0",
      "units": [
        1
      ],
      "values": [
        7,
        8,
        9
      ],
      "tags": [
        "Auras"
      ]
    },
    {
      "id": "leverage",
      "name": "Leverage",
      "genericVersion": false,
      "character": 31,
      "patch": "9.2.0",
      "units": [
        4
      ],
      "values": [
        20,
        25,
        30
      ],
      "tags": [
        "ActionSpeed",
        "Healing",
        "HealingProficiency",
        "Hooks"
      ],
      "mechanics": {
        "duration": "60 seconds"
      }
    },
    {
      "id": "lightborn",
      "name": "Lightborn",
      "genericVersion": false,
      "character": 3,
      "units": [
        1
      ],
      "values": [
        6,
        8,
        10
      ],
      "tags": [
        "Auras",
        "BlindingResistance"
      ]
    },
    {
      "id": "machine_learning",
      "name": "Machine Learning",
      "genericVersion": false,
      "character": 32,
      "patch": "9.0.0",
      "units": [
        1
      ],
      "values": [
        40,
        50,
        60
      ],
      "tags": [
        "Auras",
        "Generators",
        "Haste",
        "Undetectable"
      ],
      "mechanics": {
        "haste": "+8 %"
      }
    },
    {
      "id": "mad_grit",
      "name": "Mad Grit",
      "genericVersion": false,
      "character": 14,
      "units": [
        1
      ],
      "values": [
        2,
        3,
        4
      ],
      "tags": [
        "ActionPause",
        "AttackCooldown",
        "Carrying",
        "Wiggle"
      ]
    },
    {
      "id": "make_your_choice",
      "name": "Make Your Choice",
      "genericVersion": false,
      "character": 11,
      "units": [
        1
      ],
      "values": [
        40,
        50,
        60
      ],
      "tags": [
        "Exposed",
        "Hooks",
        "LoudNoiseNotifications"
      ]
    },
    {
      "id": "merciless_storm",
      "name": "Merciless Storm",
      "genericVersion": false,
      "character": 27,
      "units": [
        1
      ],
      "values": [
        16,
        18,
        20
      ],
      "tags": [
        "Generator",
        "SkillChecks"
      ]
    },
    {
      "id": "mindbreaker",
      "name": "Mindbreaker",
      "genericVersion": false,
      "character": 17,
      "patch": "7.3.3",
      "units": [
        1
      ],
      "values": [
        3,
        4,
        5
      ],
      "tags": [
        "Blindness",
        "Exhausted",
        "Generators"
      ]
    },
    {
      "id": "monitor_abuse",
      "name": "Monitor & Abuse",
      "genericVersion": false,
      "character": 7,
      "patch": "9.2.0",
      "units": [
        4,
        4
      ],
      "values": [
        5,
        10,
        15,
        15,
        20,
        25
      ],
      "tags": [
        "TerrorRadius"
      ]
    },
    {
      "id": "nemesis",
      "name": "Nemesis",
      "genericVersion": false,
      "character": 18,
      "patch": "8.6.0",
      "units": [
        1
      ],
      "values": [
        40,
        50,
        60
      ],
      "tags": [
        "Auras",
        "Blinding",
        "Lockers",
        "Oblivious",
        "Obsession",
        "Pallets",
        "KillerStun"
      ],
      "mechanics": {
        "aura": "8 seconds",
        "multiName": true
      }
    },
    {
      "id": "no_holds_barred",
      "name": "No Holds Barred",
      "formerName": "Deadlock",
      "genericVersion": false,
      "patch": "9.0.0",
      "units": [
        1
      ],
      "values": [
        15,
        20,
        25
      ],
      "tags": [
        "Auras",
        "GenBlocker",
        "Generators"
      ]
    },
    {
      "id": "deadlock",
      "name": "Deadlock",
      "genericVersion": false,
      "character": 25
    },
    {
      "id": "no_quarter",
      "name": "No Quarter",
      "genericVersion": false,
      "character": 38,
      "patch": "8.4.0",
      "units": [
        1
      ],
      "values": [
        20,
        25,
        30
      ],
      "tags": [
        "Broken",
        "Healing",
        "SkillChecks",
        "Self-Healing"
      ],
      "mechanics": {
        "threshold": "75 %"
      }
    },
    {
      "id": "no_way_out",
      "name": "No Way Out",
      "genericVersion": false,
      "character": 23,
      "patch": "5.1.0",
      "units": [
        1,
        1
      ],
      "values": [
        6,
        9,
        12,
        36,
        48,
        60
      ],
      "tags": [
        "ExitGates",
        "GateSwitchBlocker",
        "LoudNoiseNotifications",
        "Tokens"
      ],
      "mechanics": {
        "tokenGain": "+1 Token",
        "block": "12 seconds"
      }
    },
    {
      "id": "none_are_free",
      "name": "None Are Free",
      "genericVersion": false,
      "character": 39,
      "patch": "8.6.2",
      "units": [
        1,
        1
      ],
      "values": [
        12,
        14,
        16,
        48,
        56,
        64
      ],
      "tags": [
        "Generators",
        "PalletBlocker",
        "WindowBlocker"
      ],
      "mechanics": {
        "tokenGain": "+1 Token",
        "tokenMax": "4 Tokens"
      }
    },
    {
      "id": "nowhere_to_hide",
      "name": "Nowhere to Hide",
      "genericVersion": false,
      "character": 30,
      "patch": "6.4.0",
      "units": [
        1
      ],
      "values": [
        3,
        4,
        5
      ],
      "tags": [
        "Auras",
        "Generators"
      ]
    },
    {
      "id": "oppression",
      "name": "Oppression",
      "genericVersion": false,
      "character": 22,
      "patch": "9.2.0",
      "units": [
        1
      ],
      "values": [
        45,
        40,
        35
      ],
      "tags": [
        "Generators",
        "Regression",
        "SkillChecks"
      ],
      "mechanics": {
        "generators": 4
      }
    },
    {
      "id": "overcharge",
      "name": "Overcharge",
      "genericVersion": false,
      "character": 7,
      "patch": "6.7.0",
      "units": [
        4
      ],
      "values": [
        2,
        3,
        4
      ],
      "tags": [
        "Generators",
        "Regression",
        "ProgressionPenalty",
        "RegressionSpeed",
        "SkillChecks"
      ]
    },
    {
      "id": "overwhelming_presence",
      "name": "Overwhelming Presence",
      "genericVersion": false,
      "character": 7,
      "patch": "9.1.0",
      "units": [
        1
      ],
      "values": [
        2,
        3,
        4
      ],
      "tags": [
        "Auras",
        "Exhausted",
        "Items"
      ],
      "mechanics": {
        "activationRange": "32 metres",
        "exhausted": "15 seconds",
        "cooldown": "25 seconds"
      }
    },
    {
      "id": "phantom_fear",
      "name": "Phantom Fear",
      "genericVersion": false,
      "character": 40,
      "patch": "9.0.0",
      "units": [
        1
      ],
      "values": [
        80,
        70,
        60
      ],
      "tags": [
        "Auras",
        "TerrorRadius",
        "Screams"
      ],
      "mechanics": {
        "aura": "2 seconds"
      }
    },
    {
      "id": "pop_goes_the_weasel",
      "name": "Pop Goes the Weasel",
      "genericVersion": false,
      "character": 12,
      "patch": "9.5.0",
      "units": [
        1
      ],
      "values": [
        35,
        40,
        45
      ],
      "tags": [
        "Generators",
        "Hooks",
        "ProgressionPenalty"
      ],
      "mechanics": {
        "penalty": "+15 %",
        "totalPenalty": "20 %"
      }
    },
    {
      "id": "predator",
      "name": "Predator",
      "genericVersion": false,
      "character": 2,
      "patch": "8.3.2",
      "units": [
        1
      ],
      "values": [
        60,
        50,
        40
      ],
      "tags": [
        "Auras"
      ],
      "mechanics": {
        "duration": "4 seconds"
      }
    },
    {
      "id": "rancor",
      "name": "Rancor",
      "genericVersion": false,
      "character": 13,
      "patch": "6.4.0",
      "units": [
        1
      ],
      "values": [
        5,
        4,
        3
      ],
      "tags": [
        "Auras",
        "AuraFlareUp",
        "Exposed",
        "Generators",
        "Killing",
        "Obsession",
        "LoudNoiseNotifications"
      ],
      "mechanics": {
        "duration": "3 seconds"
      }
    },
    {
      "id": "rapid_brutality",
      "name": "Rapid Brutality",
      "genericVersion": false,
      "character": 33,
      "patch": "7.2.0",
      "units": [
        1
      ],
      "values": [
        8,
        9,
        10
      ],
      "tags": [
        "Bloodlust",
        "Haste"
      ]
    },
    {
      "id": "ravenous",
      "name": "Ravenous",
      "genericVersion": false,
      "character": 41,
      "patch": "9.2.0",
      "units": [
        1
      ],
      "values": [
        40,
        50,
        60
      ],
      "tags": [
        "Exposed",
        "Hooks",
        "Screams"
      ],
      "mechanics": {
        "tokens": [
          "+1 Token",
          "4 Tokens"
        ]
      }
    },
    {
      "id": "remember_me",
      "name": "Remember Me",
      "genericVersion": false,
      "character": 10,
      "patch": "8.5.0",
      "units": [
        5,
        1,
        1
      ],
      "values": [
        3,
        4,
        5,
        18,
        24,
        30,
        38,
        44,
        50
      ],
      "tags": [
        "ActionTime",
        "ExitGates",
        "Obsession",
        "Tokens"
      ],
      "mechanics": {
        "tokenGain": "+1 Token",
        "stack": "6 seconds",
        "gateDefault": "20 seconds"
      }
    },
    {
      "id": "scourge_hook_floods_of_rage",
      "name": "Scourge Hook: Floods of Rage",
      "genericVersion": false,
      "character": 27,
      "units": [
        1
      ],
      "values": [
        5,
        6,
        7
      ],
      "tags": [
        "ScourgeHooks",
        "Hooks",
        "Auras"
      ]
    },
    {
      "id": "scourge_hook_hangman_s_trick",
      "name": "Scourge Hook: Hangman's Trick",
      "genericVersion": false,
      "character": 11,
      "patch": "9.1.0",
      "units": [
        3
      ],
      "values": [
        12,
        14,
        16
      ],
      "tags": [
        "Auras",
        "Hooks",
        "LoudNoiseNotifications",
        "Sabotage",
        "ScourgeHooks",
        "LoudNoiseNotifications"
      ]
    },
    {
      "id": "scourge_hook_jagged_compass",
      "name": "Scourge Hook: Jagged Compass",
      "genericVersion": false,
      "character": 38,
      "patch": "8.4.0",
      "units": [
        1
      ],
      "values": [
        6,
        8,
        10
      ],
      "tags": [
        "Auras",
        "Generators",
        "Hooks",
        "ScourgeHooks"
      ]
    },
    {
      "id": "scourge_hook_monstrous_shrine",
      "name": "Scourge Hook: Monstrous Shrine",
      "genericVersion": false,
      "patch": "6.1.0",
      "units": [
        4
      ],
      "values": [
        10,
        15,
        20
      ],
      "tags": [
        "ActionSpeed",
        "Basement",
        "EntityProgression",
        "Hooks",
        "ScourgeHooks"
      ],
      "mechanics": {
        "distance": "24 metres"
      }
    },
    {
      "id": "scourge_hook_pain_resonance",
      "name": "Scourge Hook: Pain Resonance",
      "genericVersion": false,
      "character": 26,
      "patch": "8.0.0",
      "units": [
        4
      ],
      "values": [
        10,
        15,
        20
      ],
      "tags": [
        "ScourgeHooks",
        "Hooks",
        "Auras",
        "Generators",
        "ProgressionPenalty",
        "Regression"
      ]
    },
    {
      "id": "scourge_hook_weeping_wounds",
      "name": "Scourge Hook: Weeping Wounds",
      "formerName": "Scourge Hook: Gift of Pain",
      "genericVersion": false,
      "patch": "9.0.0",
      "units": [
        4
      ],
      "values": [
        10,
        13,
        16
      ],
      "tags": [
        "ActionSpeed",
        "Auras",
        "Haemorrhage",
        "HealingProficiency",
        "Hooks",
        "Mangled",
        "ScourgeHooks"
      ],
      "mechanics": {
        "haemorrhage": "90 seconds",
        "mangled": "90 seconds"
      }
    },
    {
      "id": "scourge_hook_gift_of_pain",
      "name": "Scourge Hook: Gift of Pain",
      "genericVersion": false,
      "character": 25
    },
    {
      "id": "secret_project",
      "name": "Secret Project",
      "genericVersion": false,
      "character": 42,
      "patch": "9.4.0",
      "units": [
        1
      ],
      "values": [
        20,
        25,
        30
      ],
      "tags": [
        "Totems",
        "GenBlocker",
        "Generators",
        "Stealth",
        "Undetectable",
        "Deception"
      ]
    },
    {
      "id": "see_how_they_run",
      "name": "See How They Run",
      "formerName": "Play with Your Food",
      "genericVersion": false,
      "patch": "3.7.0",
      "units": [
        4,
        4
      ],
      "values": [
        3,
        4,
        5,
        9,
        12,
        15
      ],
      "tags": [
        "Chase",
        "Haste",
        "Obsession",
        "Tokens"
      ],
      "mechanics": {
        "tokens": [
          "+1 Token",
          "3 Tokens",
          "-1 Token",
          "1 Token"
        ],
        "cooldown": "10 seconds"
      }
    },
    {
      "id": "play_with_your_food",
      "name": "Play with Your Food",
      "genericVersion": false,
      "character": 5
    },
    {
      "id": "septic_touch",
      "name": "Septic Touch",
      "genericVersion": false,
      "character": 28,
      "patch": "9.2.0",
      "units": [
        1
      ],
      "values": [
        20,
        25,
        30
      ],
      "tags": [
        "Healing",
        "TerrorRadius",
        "Blindness",
        "Exhausted"
      ]
    },
    {
      "id": "shadowborn",
      "name": "Shadowborn",
      "genericVersion": false,
      "character": 2,
      "patch": "7.5.0",
      "units": [
        4
      ],
      "values": [
        6,
        8,
        10
      ],
      "tags": [
        "Haste",
        "KillerBlind"
      ],
      "mechanics": {
        "durationHaste": "10 seconds"
      }
    },
    {
      "id": "shattered_hope",
      "name": "Shattered Hope",
      "genericVersion": false,
      "units": [
        1
      ],
      "values": [
        6,
        7,
        8
      ],
      "tags": [
        "Auras",
        "BoonDestroyer",
        "Totems"
      ]
    },
    {
      "id": "sloppy_butcher",
      "name": "Sloppy Butcher",
      "genericVersion": false,
      "patch": "7.6.0",
      "units": [
        1,
        4
      ],
      "values": [
        70,
        80,
        90,
        50,
        75,
        100
      ],
      "tags": [
        "Haemorrhage",
        "Mangled",
        "PoolsOfBlood"
      ],
      "mechanics": {
        "bleeding": "+25 %"
      }
    },
    {
      "id": "spies_from_the_shadows",
      "name": "Spies from the Shadows",
      "genericVersion": false,
      "patch": "2.6.0",
      "units": [
        3
      ],
      "values": [
        20,
        28,
        36
      ],
      "tags": [
        "LoudNoiseNotifications",
        "Crows"
      ],
      "mechanics": {
        "cooldown": "5 seconds"
      }
    },
    {
      "id": "spirit_fury",
      "name": "Spirit Fury",
      "genericVersion": false,
      "character": 13,
      "patch": "2.2.0",
      "units": [
        7
      ],
      "values": [
        4,
        3,
        2
      ],
      "tags": [
        "KillerStun",
        "Pallets"
      ]
    },
    {
      "id": "starstruck",
      "name": "Starstruck",
      "genericVersion": false,
      "character": 23,
      "patch": "4.6.0",
      "units": [
        1
      ],
      "values": [
        26,
        28,
        30
      ],
      "tags": [
        "TerrorRadius",
        "Exposed"
      ],
      "mechanics": {
        "cooldown": "60 seconds"
      }
    },
    {
      "id": "stridor",
      "name": "Stridor",
      "genericVersion": false,
      "character": 4,
      "patch": "8.1.1",
      "units": [
        4,
        4
      ],
      "values": [
        30,
        40,
        50,
        15,
        20,
        25
      ],
      "tags": [
        "Breathing",
        "GruntsOfPain"
      ]
    },
    {
      "id": "superior_anatomy",
      "name": "Superior Anatomy",
      "genericVersion": false,
      "character": 29,
      "patch": "9.0.0",
      "units": [
        4
      ],
      "values": [
        30,
        35,
        40
      ],
      "tags": [
        "ActionSpeed",
        "Pallets",
        "Vaulting",
        "VaultLocations"
      ],
      "mechanics": {
        "range": "12 metres",
        "cooldown": "25 seconds"
      }
    },
    {
      "id": "surge",
      "name": "Surge",
      "genericVersion": false,
      "character": 17,
      "patch": "6.1.0",
      "units": [
        4
      ],
      "values": [
        6,
        7,
        8
      ],
      "tags": [
        "Generators",
        "Regression",
        "ProgressionPenalty"
      ],
      "mechanics": {
        "range": "32 metres"
      }
    },
    {
      "id": "surveillance",
      "name": "Surveillance",
      "genericVersion": false,
      "character": 11,
      "patch": "5.0.0",
      "units": [
        1
      ],
      "values": [
        8,
        12,
        16
      ],
      "tags": [
        "ActionNoise",
        "Auras",
        "Generators"
      ],
      "mechanics": {
        "range": "+8 metres"
      }
    },
    {
      "id": "terminus",
      "name": "Terminus",
      "genericVersion": false,
      "character": 29,
      "patch": "9.5.0",
      "units": [
        1
      ],
      "values": [
        35,
        40,
        45
      ],
      "tags": [
        "Broken",
        "ExitGates"
      ]
    },
    {
      "id": "territorial_imperative",
      "name": "Territorial Imperative",
      "genericVersion": false,
      "character": 8,
      "patch": "7.1.0",
      "units": [
        1
      ],
      "values": [
        4,
        5,
        6
      ],
      "tags": [
        "Auras",
        "Basement"
      ],
      "mechanics": {
        "distance": "24 metres",
        "cooldown": "45 seconds"
      }
    },
    {
      "id": "thanatophobia",
      "name": "Thanatophobia",
      "genericVersion": false,
      "character": 4,
      "patch": "6.1.2 / 6.1.3",
      "units": [
        4,
        4,
        4
      ],
      "values": [
        1,
        1.5,
        2,
        4,
        6,
        8,
        16,
        18,
        20
      ],
      "tags": [
        "ActionSpeed",
        "RepairingProficiency",
        "SabotageProficiency",
        "Totems"
      ],
      "mechanics": {
        "penalty": "+12 %"
      }
    },
    {
      "id": "thrilling_tremors",
      "name": "Thrilling Tremors",
      "genericVersion": false,
      "character": 16,
      "patch": "9.0.0",
      "units": [
        1
      ],
      "values": [
        40,
        35,
        30
      ],
      "tags": [
        "Auras",
        "GenBlocker",
        "Generators"
      ],
      "mechanics": {
        "duration": "16 seconds"
      }
    },
    {
      "id": "thwack",
      "name": "THWACK!",
      "genericVersion": false,
      "character": 31,
      "patch": "9.0.0",
      "units": [
        1
      ],
      "values": [
        4,
        5,
        6
      ],
      "tags": [
        "Auras",
        "BreakableWalls",
        "Hooks",
        "LoudNoiseNotifications",
        "Pallets",
        "Screams",
        "Tokens"
      ],
      "mechanics": {
        "tokens": "3 Tokens",
        "radius": "36 metres"
      }
    },
    {
      "id": "tinkerer",
      "name": "Tinkerer",
      "genericVersion": false,
      "character": 3,
      "patch": "6.1.0",
      "units": [
        1
      ],
      "values": [
        12,
        14,
        16
      ],
      "tags": [
        "Deception",
        "Generators",
        "LoudNoiseNotifications",
        "Stealth",
        "Undetectable"
      ]
    },
    {
      "id": "trail_of_torment",
      "name": "Trail of Torment",
      "genericVersion": false,
      "character": 20,
      "patch": "8.1.0",
      "units": [
        1
      ],
      "values": [
        60,
        45,
        30
      ],
      "tags": [
        "Auras",
        "Deception",
        "Generators",
        "Stealth",
        "Undetectable"
      ]
    },
    {
      "id": "turn_back_the_clock",
      "name": "Turn Back the Clock",
      "genericVersion": false,
      "character": 42,
      "patch": "9.4.0",
      "units": [
        1
      ],
      "values": [
        40,
        50,
        60
      ],
      "tags": [
        "Generators",
        "Hooks",
        "ProgressionPenalty"
      ],
      "mechanics": {
        "penalty": "-10 %"
      }
    },
    {
      "id": "unbound",
      "name": "Unbound",
      "genericVersion": false,
      "character": 35,
      "patch": "9.0.0",
      "units": [
        1
      ],
      "values": [
        24,
        27,
        30
      ],
      "tags": [
        "Haste",
        "InjuredState",
        "Vaulting",
        "Windows"
      ],
      "mechanics": {
        "haste": "+7 %",
        "durationHaste": "10 seconds"
      }
    },
    {
      "id": "undone",
      "name": "Undone",
      "genericVersion": false,
      "character": 35,
      "patch": "7.6.0",
      "units": [
        5,
        4,
        1
      ],
      "values": [
        18,
        24,
        30,
        18,
        24,
        30,
        18,
        24,
        30
      ],
      "tags": [
        "Generators",
        "GenBlocker",
        "Regression",
        "SkillChecks",
        "Tokens"
      ],
      "mechanics": {
        "tokenGain": "+3 Tokens",
        "penalty": "-1 %",
        "duration": "1 second",
        "cooldown": "60 seconds"
      }
    },
    {
      "id": "unforeseen",
      "name": "Unforeseen",
      "genericVersion": false,
      "character": 35,
      "patch": "7.6.0",
      "units": [
        1
      ],
      "values": [
        22,
        26,
        30
      ],
      "tags": [
        "Deception",
        "Generators",
        "TerrorRadius",
        "TerrorRadiusTransfer",
        "Undetectable"
      ],
      "mechanics": {
        "radius": "32 metres",
        "cooldown": "30 seconds"
      }
    },
    {
      "id": "ultimate_weapon",
      "name": "Ultimate Weapon",
      "genericVersion": false,
      "character": 33,
      "patch": "9.2.0",
      "units": [
        1
      ],
      "values": [
        55,
        50,
        45
      ],
      "tags": [
        "Blindness",
        "Lockers",
        "LoudNoiseNotifications"
      ],
      "mechanics": {
        "range": "40 metres",
        "blindness": "30 seconds"
      }
    },
    {
      "id": "unnerving_presence",
      "name": "Unnerving Presence",
      "genericVersion": false,
      "character": 1,
      "patch": "3.6.0",
      "units": [
        4
      ],
      "values": [
        40,
        50,
        60
      ],
      "tags": [
        "SkillCheckDifficulty",
        "SkillCheckProbability",
        "SkillChecks",
        "TerrorRadius",
        "TriggerOdds"
      ],
      "mechanics": {
        "skillCheckChance": "+10 %"
      }
    },
    {
      "id": "unrelenting",
      "name": "Unrelenting",
      "genericVersion": false,
      "patch": "1.4.0",
      "units": [
        4
      ],
      "values": [
        20,
        25,
        30
      ],
      "tags": [
        "AttackCooldown"
      ]
    },
    {
      "id": "wandering_eye",
      "name": "Wandering Eye",
      "genericVersion": false,
      "character": 41,
      "patch": "9.2.0",
      "units": [
        1
      ],
      "values": [
        40,
        35,
        30
      ],
      "tags": [
        "Auras",
        "InjuredState"
      ],
      "mechanics": {
        "auras": [
          "20 metres",
          "5 seconds"
        ]
      }
    },
    {
      "id": "weave_attunement",
      "name": "Weave Attunement",
      "genericVersion": false,
      "character": 36,
      "patch": "8.4.1",
      "units": [
        1
      ],
      "values": [
        20,
        25,
        30
      ],
      "tags": [
        "Auras",
        "ForcedItemDrop",
        "Items",
        "Oblivious"
      ],
      "mechanics": {
        "range": "12 metres"
      }
    },
    {
      "id": "whispers",
      "name": "Whispers",
      "genericVersion": false,
      "patch": "1.0.5",
      "units": [
        3
      ],
      "values": [
        48,
        40,
        32
      ],
      "tags": [
        "Warning"
      ]
    },
    {
      "id": "zanshin_tactics",
      "name": "Zanshin Tactics",
      "genericVersion": false,
      "character": 18,
      "patch": "8.3.2",
      "units": [
        1
      ],
      "values": [
        3,
        4,
        5
      ],
      "tags": [
        "Auras",
        "Pallets",
        "Windows"
      ],
      "mechanics": {
        "radius": "32 metres"
      }
    },
    {
      "id": "hex_scared_to_death",
      "name": "Hex: Scared to Death",
      "genericVersion": false,
      "character": 43,
      "units": [
        4
      ],
      "values": [
        11,
        12,
        13
      ],
      "tags": [
        "Hindered"
      ],
      "mechanics": {
        "palletBreakHinderedRange": "13 metres",
        "palletBreakHinderedDuration": "3 seconds"
      }
    },
    {
      "id": "silent_shadow",
      "name": "Silent Shadow",
      "genericVersion": false,
      "character": 43,
      "patch": "10.0.0",
      "units": [
        1
      ],
      "values": [
        11,
        12,
        13
      ],
      "tags": [
        "Undetectable"
      ]
    },
    {
      "id": "rampage",
      "name": "Rampage",
      "genericVersion": false,
      "character": 43,
      "units": [
        1
      ],
      "values": [
        30,
        25,
        20
      ],
      "tags": [
        "Haste",
        "Pallets",
        "BreakableWalls"
      ],
      "mechanics": {
        "maxTokenAmount": "13",
        "blindedStunnedHasteStrength": "1 %",
        "blindedStunnedHasteDuration": "13 seconds"
      }
    }
  ],
  "survivorPerks": [
    {
      "id": "a_place_for_us",
      "name": "A Place For Us",
      "genericVersion": false,
      "character": 52,
      "patch": "9.5.0",
      "units": [
        1
      ],
      "values": [
        20,
        25,
        30
      ],
      "tags": [
        "Elusive",
        "Healing",
        "Obsession"
      ]
    },
    {
      "id": "ace_in_the_hole",
      "name": "Ace in the Hole",
      "genericVersion": false,
      "character": 7,
      "patch": "8.4.0",
      "units": [
        4
      ],
      "values": [
        50,
        75,
        100
      ],
      "tags": [
        "Add-ons",
        "Chests",
        "Items"
      ],
      "mechanics": {
        "addonCount": "1 to 2",
        "chance": "100 %"
      }
    },
    {
      "id": "adrenaline",
      "name": "Adrenaline",
      "genericVersion": false,
      "character": 2,
      "patch": "7.7.0",
      "units": [
        1
      ],
      "values": [
        60,
        50,
        40
      ],
      "tags": [
        "Exhausted",
        "Haste",
        "Healing"
      ],
      "mechanics": {
        "haste": "+50 %",
        "durationHaste": "3 seconds"
      }
    },
    {
      "id": "aftercare",
      "name": "Aftercare",
      "genericVersion": false,
      "character": 15,
      "patch": "5.3.0",
      "units": [
        7
      ],
      "values": [
        1,
        2,
        3
      ],
      "tags": [
        "Auras"
      ]
    },
    {
      "id": "alert",
      "name": "Alert",
      "genericVersion": false,
      "character": 9,
      "units": [
        1
      ],
      "values": [
        3,
        4,
        5
      ],
      "tags": [
        "Auras",
        "BreakableWalls",
        "Generators",
        "Pallets"
      ]
    },
    {
      "id": "any_means_necessary",
      "name": "Any Means Necessary",
      "genericVersion": false,
      "character": 20,
      "patch": "9.1.0",
      "units": [
        1
      ],
      "values": [
        5,
        4,
        3
      ],
      "tags": [
        "Auras",
        "Pallets"
      ]
    },
    {
      "id": "apocalyptic_ingenuity",
      "name": "Apocalyptic Ingenuity",
      "genericVersion": false,
      "character": 47,
      "patch": "9.1.0",
      "units": [
        3
      ],
      "values": [
        24,
        28,
        32
      ],
      "tags": [
        "Auras",
        "Chests",
        "FragilePallet",
        "Pallets"
      ],
      "mechanics": {
        "chests": 2,
        "duration": "4 seconds"
      }
    },
    {
      "id": "appraisal",
      "name": "Appraisal",
      "genericVersion": false,
      "character": 24,
      "patch": "9.1.0",
      "units": [
        4
      ],
      "values": [
        40,
        60,
        80
      ],
      "tags": [
        "ActionSpeed",
        "Chests",
        "Items",
        "RummageAbility"
      ],
      "mechanics": {
        "tokenCount": "4 Tokens",
        "tokenCost": "-1 Token",
        "rummageCount": "twice"
      }
    },
    {
      "id": "autodidact",
      "name": "Autodidact",
      "genericVersion": false,
      "character": 14,
      "patch": "8.1.0",
      "units": [
        5
      ],
      "values": [
        3,
        4,
        5
      ],
      "tags": [
        "BonusProgression",
        "Healing",
        "Regression",
        "SkillChecks",
        "Tokens"
      ]
    },
    {
      "id": "babysitter",
      "name": "Babysitter",
      "genericVersion": false,
      "character": 19,
      "patch": "9.0.0",
      "units": [
        1
      ],
      "values": [
        20,
        25,
        30
      ],
      "tags": [
        "Auras",
        "Haste",
        "ScratchMarks",
        "Stealth",
        "PoolsOfBlood"
      ],
      "mechanics": {
        "aura": "8 seconds",
        "haste": "+10 %"
      }
    },
    {
      "id": "background_player",
      "name": "Background Player",
      "genericVersion": false,
      "character": 36,
      "patch": "8.0.0",
      "units": [
        1
      ],
      "values": [
        30,
        25,
        20
      ],
      "tags": [
        "Exhausted",
        "Haste",
        "Hooks"
      ],
      "mechanics": {
        "activation": "10 seconds",
        "haste": "+50 %",
        "durationHaste": "5 seconds"
      }
    },
    {
      "id": "bada_bada_boom",
      "name": "Bada Bada Boom",
      "genericVersion": false,
      "character": 50,
      "patch": "9.4.0",
      "units": [
        1
      ],
      "values": [
        40,
        50,
        60
      ],
      "tags": [
        "Generators",
        "Trap",
        "VaultLocations",
        "Hindered",
        "Auras"
      ],
      "mechanics": {
        "hindered": "-50 %",
        "durationHindered": "6 seconds"
      }
    },
    {
      "id": "balanced_landing",
      "name": "Balanced Landing",
      "genericVersion": false,
      "character": 5,
      "patch": "3.4.0",
      "units": [
        1
      ],
      "values": [
        60,
        50,
        40
      ],
      "tags": [
        "ActionNoise",
        "Exhausted",
        "Haste",
        "Falling"
      ],
      "mechanics": {
        "stagger": "-75 %",
        "haste": "+50 %",
        "durationHaste": "3 seconds"
      }
    },
    {
      "id": "bardic_inspiration",
      "name": "Bardic Inspiration",
      "genericVersion": false,
      "character": 42,
      "patch": "8.0.0",
      "units": [
        1
      ],
      "values": [
        110,
        100,
        90
      ],
      "tags": [
        "BonusProgression",
        "Screams",
        "SkillChecks"
      ]
    },
    {
      "id": "better_than_new",
      "name": "Better than New",
      "genericVersion": false,
      "character": 33,
      "patch": "6.2.0",
      "units": [
        4
      ],
      "values": [
        12,
        14,
        16
      ],
      "tags": [
        "ActionSpeed",
        "Blessing",
        "Cleansing",
        "Chests",
        "Healing",
        "HealingProficiency",
        "Totems"
      ]
    },
    {
      "id": "better_together",
      "name": "Better Together",
      "genericVersion": false,
      "character": 18,
      "patch": "9.1.0",
      "units": [
        1
      ],
      "values": [
        20,
        25,
        30
      ],
      "tags": [
        "Auras",
        "Generators"
      ]
    },
    {
      "id": "bite_the_bullet",
      "name": "Bite the Bullet",
      "genericVersion": false,
      "character": 27,
      "units": [
        4
      ],
      "values": [
        3,
        2,
        1
      ],
      "tags": [
        "Healing",
        "SkillChecks",
        "LoudNoiseNotifications"
      ]
    },
    {
      "id": "blast_mine",
      "name": "Blast Mine",
      "genericVersion": false,
      "character": 26,
      "patch": "8.2.0",
      "units": [
        1
      ],
      "values": [
        100,
        110,
        120
      ],
      "tags": [
        "Auras",
        "Generators",
        "KillerBlind",
        "KillerStun",
        "SurvivorBlind",
        "Trap"
      ]
    },
    {
      "id": "blood_pact",
      "name": "Blood Pact",
      "genericVersion": false,
      "character": 22,
      "units": [
        4
      ],
      "values": [
        5,
        6,
        7
      ],
      "tags": [
        "Auras",
        "Haste",
        "Obsession"
      ]
    },
    {
      "id": "blood_rush",
      "name": "Blood Rush",
      "genericVersion": false,
      "character": 36,
      "patch": "8.3.0",
      "units": [
        1
      ],
      "values": [
        40,
        50,
        60
      ],
      "tags": [
        "Exhausted",
        "Healing",
        "Hooks"
      ]
    },
    {
      "id": "boil_over",
      "name": "Boil Over",
      "genericVersion": false,
      "character": 13,
      "units": [
        4
      ],
      "values": [
        60,
        70,
        80
      ],
      "tags": [
        "Auras",
        "Hooks",
        "Wiggle"
      ]
    },
    {
      "id": "boon_circle_of_healing",
      "name": "Boon: Circle of Healing",
      "genericVersion": false,
      "character": 28,
      "patch": "6.7.0",
      "units": [
        4
      ],
      "values": [
        50,
        75,
        100
      ],
      "tags": [
        "ActionSpeed",
        "Boon",
        "Healing",
        "HealingProficiency",
        "Totems"
      ]
    },
    {
      "id": "boon_dark_theory",
      "name": "Boon: Dark Theory",
      "genericVersion": false,
      "character": 30,
      "patch": "8.7.0",
      "units": [
        1
      ],
      "values": [
        2,
        3,
        4
      ],
      "tags": [
        "Boon",
        "Haste",
        "Totems"
      ],
      "mechanics": {
        "haste": "+3 %"
      }
    },
    {
      "id": "boon_exponential",
      "name": "Boon: Exponential",
      "genericVersion": false,
      "character": 29,
      "patch": "5.4.0",
      "units": [
        4
      ],
      "values": [
        90,
        95,
        100
      ],
      "tags": [
        "Boon",
        "RecoverySpeed",
        "Recovering",
        "Totems"
      ]
    },
    {
      "id": "boon_illumination",
      "name": "Boon: Illumination",
      "genericVersion": false,
      "character": 40,
      "patch": "7.5.0",
      "units": [
        4
      ],
      "values": [
        6,
        8,
        10
      ],
      "tags": [
        "Auras",
        "Blessing",
        "Boon",
        "Chests",
        "Cleansing",
        "Generators",
        "Totems"
      ]
    },
    {
      "id": "boon_shadow_step",
      "name": "Boon: Shadow Step",
      "genericVersion": false,
      "character": 28,
      "units": [
        1
      ],
      "values": [
        2,
        3,
        4
      ],
      "tags": [
        "Auras",
        "ScratchMarks",
        "Totems",
        "Boon"
      ]
    },
    {
      "id": "bond",
      "name": "Bond",
      "genericVersion": false,
      "character": 1,
      "units": [
        3
      ],
      "values": [
        20,
        28,
        36
      ],
      "tags": [
        "Auras"
      ]
    },
    {
      "id": "borrowed_time",
      "name": "Borrowed Time",
      "genericVersion": false,
      "character": 8,
      "patch": "6.1.0",
      "units": [
        1,
        1
      ],
      "values": [
        6,
        8,
        10,
        21,
        23,
        25
      ],
      "tags": [
        "ConspicuousActions",
        "Endurance",
        "Haste"
      ],
      "mechanics": {
        "effect": "+10 seconds",
        "haste": "25 seconds"
      }
    },
    {
      "id": "botany_knowledge",
      "name": "Botany Knowledge",
      "genericVersion": false,
      "character": 3,
      "patch": "9.0.0",
      "units": [
        4
      ],
      "values": [
        30,
        40,
        50
      ],
      "tags": [
        "ActionSpeed",
        "Healing",
        "HealingProficiency"
      ]
    },
    {
      "id": "bound_by_obsession",
      "name": "Bound by Obsession",
      "formerName": "Object of Obsession",
      "genericVersion": false,
      "patch": "4.7.0",
      "units": [
        4
      ],
      "values": [
        2,
        4,
        6
      ],
      "tags": [
        "ActionSpeeds",
        "Auras",
        "CleansingProficiency",
        "HealingProficiency",
        "Obsession",
        "RepairingProficiency"
      ],
      "mechanics": {
        "duration": "3 seconds",
        "interval": "30 seconds"
      }
    },
    {
      "id": "object_of_obsession",
      "name": "Object of Obsession",
      "genericVersion": false,
      "character": 6
    },
    {
      "id": "breakdown",
      "name": "Breakdown",
      "genericVersion": false,
      "character": 15,
      "patch": "9.3.2",
      "units": [
        1
      ],
      "values": [
        4,
        5,
        6
      ],
      "tags": [
        "Auras",
        "Hooks"
      ],
      "mechanics": {
        "timer": "180 seconds"
      }
    },
    {
      "id": "breakout",
      "name": "Breakout",
      "genericVersion": false,
      "character": 20,
      "patch": "8.7.0",
      "units": [
        4
      ],
      "values": [
        6,
        8,
        10
      ],
      "tags": [
        "ActionSpeed",
        "Haste",
        "Wiggle"
      ],
      "mechanics": {
        "range": "5 metres",
        "wiggling": "+25 %"
      }
    },
    {
      "id": "buckle_up",
      "name": "Buckle Up",
      "genericVersion": false,
      "character": 17,
      "patch": "8.0.0",
      "units": [
        1
      ],
      "values": [
        3,
        4,
        5
      ],
      "tags": [
        "Auras",
        "ConspicuousActions",
        "Exhausted",
        "Haste",
        "Recovering"
      ],
      "mechanics": {
        "haste": "+50 %"
      }
    },
    {
      "id": "built_to_last",
      "name": "Built to Last",
      "genericVersion": false,
      "character": 23,
      "patch": "9.1.0",
      "units": [
        1
      ],
      "values": [
        12,
        10,
        8
      ],
      "tags": [
        "Items",
        "Lockers",
        "ItemRecharge"
      ],
      "mechanics": {
        "recharges": [
          "99 %",
          "66 %",
          "33 %"
        ],
        "finalUse": "third time"
      }
    },
    {
      "id": "calm_spirit",
      "name": "Calm Spirit",
      "genericVersion": false,
      "character": 4,
      "patch": "6.1.0",
      "units": [
        4
      ],
      "values": [
        40,
        35,
        30
      ],
      "tags": [
        "ActionNoise",
        "ActionSpeed",
        "Stealth",
        "Chests",
        "Totems",
        "CleansingProficiency",
        "Screams",
        "Crows"
      ]
    },
    {
      "id": "camaraderie",
      "name": "Camaraderie",
      "genericVersion": false,
      "character": 19,
      "units": [
        1
      ],
      "values": [
        26,
        30,
        34
      ],
      "tags": [
        "EntityProgression",
        "Hooks",
        "Struggling"
      ]
    },
    {
      "id": "champion_of_light",
      "name": "Champion of Light",
      "genericVersion": false,
      "character": 40,
      "patch": "9.0.0",
      "units": [
        1
      ],
      "values": [
        60,
        50,
        40
      ],
      "tags": [
        "Flashlights",
        "Haste",
        "Hindered",
        "KillerBlind"
      ],
      "mechanics": {
        "haste": "+50 %",
        "hindered": "-20 %",
        "durationHindered": "6 seconds"
      }
    },
    {
      "id": "change_of_plan",
      "name": "Change of Plan",
      "genericVersion": false,
      "character": 50,
      "patch": "9.4.0",
      "units": [
        4
      ],
      "values": [
        80,
        90,
        100
      ],
      "tags": [
        "Items",
        "Lockers",
        "ItemRecharge",
        "Med-Kits",
        "Toolboxes"
      ],
      "mechanics": {
        "tokens": [
          "2 Tokens",
          "1 Token"
        ]
      }
    },
    {
      "id": "chemical_trap",
      "name": "Chemical Trap",
      "genericVersion": false,
      "character": 39,
      "patch": "8.2.0",
      "units": [
        1
      ],
      "values": [
        40,
        50,
        60
      ],
      "tags": [
        "Auras",
        "Generators",
        "Hindered",
        "Pallets"
      ],
      "mechanics": {
        "hindered": "-50 %",
        "durationHindered": "4 seconds"
      }
    },
    {
      "id": "come_and_get_me",
      "name": "Come and Get Me!",
      "genericVersion": false,
      "character": 47,
      "patch": "9.1.0",
      "units": [
        1
      ],
      "values": [
        10,
        12.5,
        15
      ],
      "tags": [
        "Auras",
        "GruntsOfPain",
        "PoolsOfBlood",
        "ScratchMarks",
        "Screams"
      ],
      "mechanics": {
        "range": "24 metres",
        "aura": "5 seconds"
      }
    },
    {
      "id": "conviction",
      "name": "Conviction",
      "genericVersion": false,
      "character": 48,
      "patch": "9.3.0",
      "units": [
        1
      ],
      "values": [
        20,
        25,
        30
      ],
      "tags": [
        "Broken",
        "Healing",
        "Recovering"
      ],
      "mechanics": {
        "recovery": "25 %"
      }
    },
    {
      "id": "corrective_action",
      "name": "Corrective Action",
      "genericVersion": false,
      "character": 29,
      "patch": "8.3.0",
      "units": [
        6
      ],
      "values": [
        1,
        2,
        3
      ],
      "tags": [
        "Auras",
        "SkillChecks",
        "Tokens"
      ],
      "mechanics": {
        "tokenGain": "+1 Token",
        "tokenCost": "-1 Token",
        "tokenLimit": "5 Tokens",
        "duration": "6 seconds"
      }
    },
    {
      "id": "counterforce",
      "name": "Counterforce",
      "genericVersion": false,
      "character": 26,
      "patch": "9.0.0",
      "units": [
        1
      ],
      "values": [
        10,
        12,
        14
      ],
      "tags": [
        "Totems"
      ],
      "mechanics": {
        "default": "125 %",
        "bonus": "+25 %"
      }
    },
    {
      "id": "clairvoyance",
      "name": "Clairvoyance",
      "genericVersion": false,
      "character": 28,
      "patch": "9.2.0",
      "units": [
        1
      ],
      "values": [
        10,
        11,
        12
      ],
      "tags": [
        "Auras",
        "Totems",
        "Hatch",
        "Generators",
        "Hooks",
        "Chests"
      ],
      "mechanics": {
        "range": "64 metres"
      }
    },
    {
      "id": "clean_break",
      "name": "Clean Break",
      "genericVersion": false,
      "character": 45,
      "patch": "8.4.0",
      "units": [
        1
      ],
      "values": [
        80,
        70,
        60
      ],
      "tags": [
        "AutoHeal",
        "Broken"
      ],
      "mechanics": {
        "healthState": 1
      }
    },
    {
      "id": "cut_loose",
      "name": "Cut Loose",
      "genericVersion": false,
      "character": 35,
      "patch": "6.6.0",
      "units": [
        1
      ],
      "values": [
        4,
        5,
        6
      ],
      "tags": [
        "LoudNoiseNotifications",
        "Stealth",
        "Vaulting"
      ],
      "mechanics": {
        "cooldown": "45 seconds"
      }
    },
    {
      "id": "dance_with_me",
      "name": "Dance With Me",
      "genericVersion": false,
      "character": 13,
      "patch": "8.6.0",
      "units": [
        1
      ],
      "values": [
        20,
        20,
        15
      ],
      "tags": [
        "Lockers",
        "Pallets",
        "ScratchMarks",
        "Stealth",
        "Vaulting"
      ],
      "mechanics": {
        "stealth": "5 seconds"
      }
    },
    {
      "id": "dark_sense",
      "name": "Dark Sense",
      "genericVersion": false,
      "patch": "6.1.0",
      "units": [
        1
      ],
      "values": [
        5,
        7,
        10
      ],
      "tags": [
        "Auras",
        "Generators"
      ],
      "mechanics": {
        "range": "24 metres"
      }
    },
    {
      "id": "dead_hard",
      "name": "Dead Hard",
      "genericVersion": false,
      "character": 10,
      "patch": "6.7.0",
      "units": [
        1
      ],
      "values": [
        60,
        50,
        40
      ],
      "tags": [
        "DeepWound",
        "Endurance",
        "Exhausted"
      ],
      "mechanics": {
        "endurance": "0.5 seconds"
      }
    },
    {
      "id": "deadline",
      "name": "Deadline",
      "genericVersion": false,
      "character": 40,
      "patch": "7.5.0",
      "units": [
        4
      ],
      "values": [
        6,
        8,
        10
      ],
      "tags": [
        "InjuredState",
        "Healing",
        "SkillCheckProbability",
        "SkillChecks",
        "Repairing"
      ]
    },
    {
      "id": "deception",
      "name": "Deception",
      "genericVersion": false,
      "character": 24,
      "patch": "8.6.0",
      "units": [
        1
      ],
      "values": [
        25,
        20,
        15
      ],
      "tags": [
        "Deception",
        "PoolsOfBlood",
        "Lockers",
        "LoudNoiseNotifications",
        "ScratchMarks",
        "Stealth"
      ],
      "mechanics": {
        "stealth": "5 seconds"
      }
    },
    {
      "id": "deja_vu",
      "name": "Déjà Vu",
      "genericVersion": false,
      "patch": "9.1.0",
      "units": [
        4
      ],
      "values": [
        4,
        5,
        6
      ],
      "tags": [
        "Auras",
        "ActionSpeed",
        "Generators"
      ],
      "mechanics": {
        "generatorCount": 3,
        "diacritics": true
      }
    },
    {
      "id": "deliverance",
      "name": "Deliverance",
      "genericVersion": false,
      "character": 14,
      "patch": "2.2.0",
      "units": [
        1
      ],
      "values": [
        100,
        80,
        60
      ],
      "tags": [
        "Broken",
        "Chance",
        "EscapeAttempt",
        "Hooks"
      ]
    },
    {
      "id": "desperate_measures",
      "name": "Desperate Measures",
      "genericVersion": false,
      "character": 23,
      "patch": "9.0.0",
      "units": [
        4,
        4
      ],
      "values": [
        16,
        18,
        20,
        64,
        72,
        80
      ],
      "tags": [
        "ActionSpeed",
        "Healing",
        "HealingProficiency"
      ]
    },
    {
      "id": "detective_s_hunch",
      "name": "Detective's Hunch",
      "genericVersion": false,
      "character": 12,
      "patch": "9.1.0",
      "units": [
        3
      ],
      "values": [
        32,
        48,
        64
      ],
      "tags": [
        "Auras",
        "Chests",
        "Generators",
        "Totems"
      ],
      "mechanics": {
        "duration": "20 seconds"
      }
    },
    {
      "id": "distortion",
      "name": "Distortion",
      "genericVersion": false,
      "character": 15,
      "patch": "8.3.2",
      "units": [
        1
      ],
      "values": [
        8,
        10,
        12
      ],
      "tags": [
        "Auras",
        "Chase",
        "ScratchMarks",
        "Stealth"
      ],
      "mechanics": {
        "tokens": [
          "1 Token",
          "-1 Token",
          "+1 Token",
          "15 seconds",
          "2 Tokens"
        ]
      }
    },
    {
      "id": "diversion",
      "name": "Diversion",
      "genericVersion": false,
      "character": 14,
      "patch": "8.2.0",
      "units": [
        1
      ],
      "values": [
        30,
        25,
        20
      ],
      "tags": [
        "Deception",
        "LoudNoiseNotifications",
        "ScratchMarks",
        "TerrorRadius"
      ],
      "mechanics": {
        "distance": "20 metres"
      }
    },
    {
      "id": "do_no_harm",
      "name": "Do No Harm",
      "genericVersion": false,
      "character": 46,
      "patch": "8.7.0",
      "units": [
        4,
        4
      ],
      "values": [
        30,
        40,
        50,
        60,
        80,
        100
      ],
      "tags": [
        "ActionSpeed",
        "BonusProgression",
        "HealingProficiency",
        "HookStates",
        "SkillChecks"
      ],
      "mechanics": {
        "bonusStack": "+3 %",
        "bonusMax": "+6 %"
      }
    },
    {
      "id": "down_to_the_last",
      "name": "Down to the Last",
      "formerName": "Sole Survivor",
      "genericVersion": false,
      "patch": "6.1.0",
      "units": [
        3,
        3
      ],
      "values": [
        20,
        22,
        24,
        60,
        66,
        72
      ],
      "tags": [
        "Auras",
        "ActionSpeed",
        "Generators",
        "ExitGates",
        "Hatch",
        "Obsession",
        "RepairingProficiency",
        "Stealth"
      ]
    },
    {
      "id": "sole_survivor",
      "name": "Sole Survivor",
      "genericVersion": false,
      "character": 6
    },
    {
      "id": "dramaturgy",
      "name": "Dramaturgy",
      "genericVersion": false,
      "character": 38,
      "patch": "7.1.0",
      "units": [
        1
      ],
      "values": [
        60,
        50,
        40
      ],
      "tags": [
        "Add-ons",
        "Exhausted",
        "Exposed",
        "Haste",
        "Items"
      ],
      "mechanics": {
        "activation": "0.5 seconds",
        "haste": "+25",
        "durationHaste": "2 seconds",
        "exposed": "12 seconds"
      }
    },
    {
      "id": "duty_of_care",
      "name": "Duty of Care",
      "genericVersion": false,
      "character": 46,
      "patch": "8.7.0",
      "units": [
        1
      ],
      "values": [
        4,
        5,
        6
      ],
      "tags": [
        "Haste",
        "ProtectionHits"
      ],
      "mechanics": {
        "range": "12 metres",
        "haste": "+25 %"
      }
    },
    {
      "id": "empathic_connection",
      "name": "Empathic Connection",
      "genericVersion": false,
      "character": 30,
      "patch": "9.0.0",
      "units": [
        4
      ],
      "values": [
        25,
        30,
        35
      ],
      "tags": [
        "ActionSpeed",
        "Auras",
        "Healing",
        "HealingProficiency",
        "InjuredState"
      ]
    },
    {
      "id": "empathy",
      "name": "Empathy",
      "genericVersion": false,
      "character": 3,
      "patch": "2.6.0",
      "units": [
        3
      ],
      "values": [
        64,
        96,
        128
      ],
      "tags": [
        "Auras",
        "InjuredState"
      ]
    },
    {
      "id": "eyes_of_belmont",
      "name": "Eyes of Belmont",
      "genericVersion": false,
      "character": 44,
      "patch": "8.2.0",
      "units": [
        1
      ],
      "values": [
        1,
        2,
        3
      ],
      "tags": [
        "Auras",
        "Generators"
      ]
    },
    {
      "id": "extrasensory_perception",
      "name": "Extrasensory Perception",
      "genericVersion": false,
      "character": 51,
      "patch": "9.4.0",
      "units": [
        1
      ],
      "values": [
        60,
        50,
        40
      ],
      "tags": [
        "Crouching",
        "Oblivious",
        "Stealth",
        "Auras",
        "Chests",
        "Generators",
        "Totems",
        "Hatch",
        "ExitGates",
        "Elusive"
      ],
      "mechanics": {
        "activationTime": "4 seconds",
        "maxRange": "44 meter",
        "maxDuration": "11 seconds"
      }
    },
    {
      "id": "exultation",
      "name": "Exultation",
      "genericVersion": false,
      "character": 44,
      "patch": "9.0.0",
      "units": [
        1
      ],
      "values": [
        30,
        25,
        20
      ],
      "tags": [
        "Charges",
        "KillerStun",
        "Pallets",
        "RarityUpgrade"
      ],
      "mechanics": {
        "chargeBonus": "+75 %"
      }
    },
    {
      "id": "fast_track",
      "name": "Fast Track",
      "genericVersion": false,
      "character": 25,
      "patch": "9.6.0",
      "units": [
        6,
        5
      ],
      "values": [
        1,
        2,
        3
      ],
      "tags": [
        "BonusProgression",
        "Generators",
        "SkillChecks",
        "Tokens"
      ],
      "mechanics": {
        "maxTokens": "9",
        "chargeReduction": "5 charges"
      }
    },
    {
      "id": "finesse",
      "name": "Finesse",
      "genericVersion": false,
      "character": 43,
      "patch": "8.1.0",
      "units": [
        1
      ],
      "values": [
        40,
        35,
        30
      ],
      "tags": [
        "ActionSpeed",
        "Vaulting"
      ]
    },
    {
      "id": "fixated",
      "name": "Fixated",
      "genericVersion": false,
      "character": 18,
      "patch": "7.3.3",
      "units": [
        4
      ],
      "values": [
        10,
        15,
        20
      ],
      "tags": [
        "Haste",
        "ScratchMarks"
      ]
    },
    {
      "id": "five_moves_ahead",
      "name": "Five Moves Ahead",
      "genericVersion": false,
      "character": 52,
      "patch": "9.5.0",
      "units": [
        1
      ],
      "values": [
        40,
        35,
        30
      ],
      "tags": [
        "Pallets",
        "Auras",
        "Chase"
      ],
      "mechanics": {
        "palletDropSpeedBonus": "50 %",
        "auraMaxAmount": "5"
      }
    },
    {
      "id": "flashbang",
      "name": "Flashbang",
      "genericVersion": false,
      "character": 27,
      "patch": "8.2.0",
      "units": [
        4
      ],
      "values": [
        50,
        45,
        40
      ],
      "tags": [
        "FlashGrenades",
        "Generators",
        "Lockers"
      ]
    },
    {
      "id": "flip_flop",
      "name": "Flip-Flop",
      "genericVersion": false,
      "character": 17,
      "patch": "2.6.3",
      "units": [
        4
      ],
      "values": [
        40,
        45,
        50
      ],
      "tags": [
        "Conversion",
        "Recovering",
        "Wiggle"
      ],
      "mechanics": {
        "conversion": "50 %"
      }
    },
    {
      "id": "flow_state",
      "name": "Flow State",
      "genericVersion": false,
      "character": 52,
      "patch": "9.5.0",
      "units": [
        4
      ],
      "values": [
        8,
        9,
        10
      ],
      "tags": [
        "ActionSpeed",
        "Healing",
        "Unhooking",
        "Cleansing",
        "Blessing"
      ]
    },
    {
      "id": "fogwise",
      "name": "Fogwise",
      "genericVersion": false,
      "character": 34,
      "patch": "6.4.0",
      "units": [
        1
      ],
      "values": [
        4,
        5,
        6
      ],
      "tags": [
        "Auras",
        "Generators",
        "SkillChecks"
      ]
    },
    {
      "id": "for_the_people",
      "name": "For the People",
      "genericVersion": false,
      "character": 21,
      "units": [
        1
      ],
      "values": [
        80,
        70,
        60
      ],
      "tags": [
        "Broken",
        "DeepWound",
        "Healing",
        "Obsession"
      ]
    },
    {
      "id": "friendly_competition",
      "name": "Friendly Competition",
      "genericVersion": false,
      "character": 35,
      "patch": "9.2.0",
      "units": [
        1
      ],
      "values": [
        100,
        110,
        120
      ],
      "tags": [
        "ActionSpeed",
        "Generators",
        "RepairingProficiency"
      ],
      "mechanics": {
        "effect": "+5 %"
      }
    },
    {
      "id": "ghost_notes",
      "name": "Ghost Notes",
      "genericVersion": false,
      "character": 49,
      "patch": "9.2.0",
      "units": [
        4
      ],
      "values": [
        5,
        7.5,
        10
      ],
      "tags": [
        "Exhausted",
        "ScratchMarks"
      ],
      "mechanics": {
        "effect": "+50 %"
      }
    },
    {
      "id": "hardened",
      "name": "Hardened",
      "genericVersion": false,
      "character": 43,
      "patch": "8.1.0",
      "units": [
        1
      ],
      "values": [
        3,
        4,
        5
      ],
      "tags": [
        "Auras",
        "Chests",
        "Screams",
        "Totems"
      ]
    },
    {
      "id": "head_on",
      "name": "Head On",
      "genericVersion": false,
      "character": 16,
      "patch": "9.0.0",
      "units": [
        1
      ],
      "values": [
        60,
        50,
        40
      ],
      "tags": [
        "Exhausted",
        "Lockers",
        "KillerStun"
      ],
      "mechanics": {
        "charge": "3 seconds",
        "stun": [
          "2.5 metres",
          "3 seconds"
        ]
      }
    },
    {
      "id": "hope",
      "name": "Hope",
      "genericVersion": false,
      "patch": "9.2.0",
      "units": [
        4
      ],
      "values": [
        3,
        4,
        5
      ],
      "tags": [
        "ExitGates",
        "Haste"
      ]
    },
    {
      "id": "hyperfocus",
      "name": "Hyperfocus",
      "genericVersion": false,
      "character": 33,
      "patch": "6.2.0",
      "units": [
        4,
        4
      ],
      "values": [
        10,
        20,
        30,
        60,
        120,
        180
      ],
      "tags": [
        "BonusProgression",
        "RotationSpeed",
        "SkillCheckDifficulty",
        "SkillCheckProbability",
        "SkillChecks",
        "TriggerOdds"
      ]
    },
    {
      "id": "inner_focus",
      "name": "Inner Focus",
      "genericVersion": false,
      "character": 31,
      "patch": "8.3.2",
      "units": [
        1
      ],
      "values": [
        6,
        8,
        10
      ],
      "tags": [
        "Auras",
        "ScratchMarks"
      ]
    },
    {
      "id": "inner_strength",
      "name": "Inner Strength",
      "genericVersion": false,
      "character": 18,
      "patch": "7.3.3",
      "units": [
        1
      ],
      "values": [
        10,
        9,
        8
      ],
      "tags": [
        "Broken",
        "DeepWound",
        "Healing",
        "Lockers",
        "Totems"
      ]
    },
    {
      "id": "invocation_treacherous_crows",
      "name": "Invocation: Treacherous Crows",
      "genericVersion": false,
      "character": 45,
      "patch": "8.4.0",
      "units": [
        1
      ],
      "values": [
        1,
        1.5,
        2
      ],
      "tags": [
        "Auras",
        "Basement",
        "Broken",
        "Crows",
        "InjuredState",
        "Invocation",
        "Killer",
        "TerrorRadius"
      ]
    },
    {
      "id": "invocation_weaving_spiders",
      "name": "Invocation: Weaving Spiders",
      "genericVersion": false,
      "character": 41,
      "patch": "8.0.0",
      "units": [
        9
      ],
      "values": [
        8,
        9,
        10
      ],
      "tags": [
        "Auras",
        "Basement",
        "Broken",
        "InjuredState",
        "Invocation",
        "Generators",
        "RepairRequirement"
      ]
    },
    {
      "id": "iron_will",
      "name": "Iron Will",
      "genericVersion": false,
      "character": 4,
      "patch": "8.1.0",
      "units": [
        4
      ],
      "values": [
        80,
        90,
        100
      ],
      "tags": [
        "Exhausted",
        "GruntsOfPain",
        "Stealth"
      ]
    },
    {
      "id": "kindred",
      "name": "Kindred",
      "genericVersion": false,
      "patch": "3.4.0",
      "units": [
        3
      ],
      "values": [
        8,
        12,
        16
      ],
      "tags": [
        "Auras",
        "KillerAura",
        "Hooks"
      ]
    },
    {
      "id": "last_stand",
      "name": "Last Stand",
      "genericVersion": false,
      "character": 48,
      "patch": "9.1.0",
      "units": [
        1
      ],
      "values": [
        120,
        105,
        90
      ],
      "tags": [
        "KillerStun",
        "Pallets",
        "TerrorRadius",
        "Vaulting",
        "Windows"
      ],
      "mechanics": {
        "stun": "3 seconds",
        "range": "2.5 metres"
      }
    },
    {
      "id": "leader",
      "name": "Leader",
      "genericVersion": false,
      "character": 1,
      "patch": "2.5.0",
      "units": [
        4
      ],
      "values": [
        20,
        25,
        30
      ],
      "tags": [
        "ActionSpeed",
        "ExitGates",
        "HealingProficiency",
        "SabotageProficiency",
        "CleansingProficiency",
        "Chests"
      ],
      "mechanics": {
        "radius": "10 metres",
        "linger": "15 seconds"
      }
    },
    {
      "id": "left_behind",
      "name": "Left Behind",
      "genericVersion": false,
      "character": 8,
      "patch": "3.2.0",
      "units": [
        3
      ],
      "values": [
        24,
        28,
        32
      ],
      "tags": [
        "Auras",
        "Hatch"
      ],
      "mechanics": {
        "multiName": true
      }
    },
    {
      "id": "light_footed",
      "name": "Light-Footed",
      "genericVersion": false,
      "character": 39,
      "patch": "9.0.0",
      "units": [
        1
      ],
      "values": [
        14,
        12,
        10
      ],
      "tags": [
        "Stealth"
      ]
    },
    {
      "id": "lightweight",
      "name": "Lightweight",
      "genericVersion": false,
      "patch": "6.1.0",
      "units": [
        1
      ],
      "values": [
        3,
        4,
        5
      ],
      "tags": [
        "ScratchMarks",
        "Stealth"
      ],
      "mechanics": {
        "spawnChance": "-60 %"
      }
    },
    {
      "id": "lithe",
      "name": "Lithe",
      "genericVersion": false,
      "character": 9,
      "patch": "2.6.0",
      "units": [
        1
      ],
      "values": [
        60,
        50,
        40
      ],
      "tags": [
        "Exhausted",
        "Haste",
        "Pallets",
        "Vaulting"
      ],
      "mechanics": {
        "haste": "+50 %",
        "durationHaste": "3 seconds"
      }
    },
    {
      "id": "low_profile",
      "name": "Low Profile",
      "genericVersion": false,
      "character": 32,
      "patch": "6.2.0",
      "units": [
        1
      ],
      "values": [
        70,
        80,
        90
      ],
      "tags": [
        "PoolsOfBlood",
        "ScratchMarks"
      ]
    },
    {
      "id": "lucky_break",
      "name": "Lucky Break",
      "genericVersion": false,
      "character": 20,
      "patch": "6.1.0",
      "units": [
        1
      ],
      "values": [
        40,
        50,
        60
      ],
      "tags": [
        "PoolsOfBlood",
        "ScratchMarks",
        "Stealth"
      ]
    },
    {
      "id": "lucky_star",
      "name": "Lucky Star",
      "genericVersion": false,
      "character": 39,
      "patch": "9.2.0",
      "units": [
        1
      ],
      "values": [
        35,
        30,
        25
      ],
      "tags": [
        "Auras",
        "Generators",
        "GruntsOfPain",
        "Lockers",
        "PoolsOfBlood",
        "Stealth"
      ],
      "mechanics": {
        "duration": "30 seconds"
      }
    },
    {
      "id": "made_for_this",
      "name": "Made for This",
      "genericVersion": false,
      "character": 37,
      "patch": "7.4.0",
      "units": [
        1,
        4
      ],
      "values": [
        6,
        8,
        10,
        1,
        2,
        3
      ],
      "tags": [
        "ConspicuousActions",
        "DeepWound",
        "Endurance",
        "Haste",
        "Healing"
      ]
    },
    {
      "id": "mettle_of_man",
      "name": "Mettle of Man",
      "genericVersion": false,
      "character": 17,
      "patch": "6.2.0",
      "units": [
        3
      ],
      "values": [
        12,
        14,
        16
      ],
      "tags": [
        "Auras",
        "Obsession",
        "ProtectionHits"
      ],
      "mechanics": {
        "counter": "third"
      }
    },
    {
      "id": "mirrored_illusion",
      "name": "Mirrored Illusion",
      "genericVersion": false,
      "character": 42,
      "patch": "8.2.0",
      "units": [
        1
      ],
      "values": [
        40,
        50,
        60
      ],
      "tags": [
        "Chests",
        "ExitGates",
        "Generators",
        "Totems"
      ]
    },
    {
      "id": "moment_of_glory",
      "name": "Moment of Glory",
      "genericVersion": false,
      "character": 44,
      "patch": "8.2.0",
      "units": [
        1
      ],
      "values": [
        80,
        70,
        60
      ],
      "tags": [
        "AutoHeal",
        "Broken",
        "Chests",
        "Healing"
      ]
    },
    {
      "id": "no_mither",
      "name": "No Mither",
      "genericVersion": false,
      "character": 10,
      "patch": "9.2.0",
      "units": [
        4
      ],
      "values": [
        15,
        20,
        25
      ],
      "tags": [
        "Broken",
        "GruntsOfPain",
        "PoolsOfBlood",
        "Recovering",
        "Stealth"
      ]
    },
    {
      "id": "no_one_left_behind",
      "name": "No One Left Behind",
      "genericVersion": false,
      "patch": "8.7.0",
      "units": [
        4
      ],
      "values": [
        50,
        75,
        100
      ],
      "tags": [
        "ActionSpeed",
        "Auras",
        "EffectDuration",
        "ExitGates",
        "Haste",
        "HealingProficiency"
      ],
      "mechanics": {
        "effect": "+10 %",
        "bonus": "+5 seconds",
        "haste": "20 %",
        "durationHaste": "15 seconds"
      }
    },
    {
      "id": "off_the_record",
      "name": "Off the Record",
      "genericVersion": false,
      "character": 21,
      "patch": "9.2.2",
      "units": [
        1
      ],
      "values": [
        30,
        35,
        40
      ],
      "tags": [
        "Auras",
        "GruntsOfPain",
        "Hooks"
      ]
    },
    {
      "id": "one_two_three_four",
      "name": "One-Two-Three-Four!",
      "genericVersion": false,
      "character": 49,
      "patch": "9.2.0",
      "units": [
        1
      ],
      "values": [
        110,
        100,
        90
      ],
      "tags": [
        "Healing",
        "Repairing",
        "SkillCheckProbability",
        "SkillChecks"
      ],
      "mechanics": {
        "performance": [
          "15 seconds",
          "16 metres",
          "90 seconds"
        ],
        "bonus": "+20 %"
      }
    },
    {
      "id": "open_handed",
      "name": "Open-Handed",
      "genericVersion": false,
      "character": 7,
      "units": [
        3
      ],
      "values": [
        8,
        12,
        16
      ],
      "tags": [
        "Auras",
        "Vision"
      ]
    },
    {
      "id": "overcome",
      "name": "Overcome",
      "genericVersion": false,
      "character": 29,
      "patch": "5.4.0",
      "units": [
        1
      ],
      "values": [
        60,
        50,
        40
      ],
      "tags": [
        "MovementSpeed",
        "Exhausted"
      ],
      "mechanics": {
        "effect": "+2 seconds"
      }
    },
    {
      "id": "overzealous",
      "name": "Overzealous",
      "genericVersion": false,
      "character": 31,
      "patch": "6.7.0",
      "units": [
        4,
        4
      ],
      "values": [
        8,
        9,
        10,
        16,
        18,
        20
      ],
      "tags": [
        "ActionSpeed",
        "Generators",
        "RepairingProficiency",
        "Totems"
      ]
    },
    {
      "id": "parental_guidance",
      "name": "Parental Guidance",
      "genericVersion": false,
      "character": 30,
      "patch": "5.6.0",
      "units": [
        1
      ],
      "values": [
        5,
        6,
        7
      ],
      "tags": [
        "ScratchMarks",
        "PoolsOfBlood",
        "GruntsOfPain"
      ]
    },
    {
      "id": "pharmacy",
      "name": "Pharmacy",
      "genericVersion": false,
      "character": 11,
      "patch": "9.2.0",
      "units": [
        4
      ],
      "values": [
        75,
        100,
        125
      ],
      "tags": [
        "ActionNoise",
        "ActionSpeed",
        "Chests",
        "Med-Kits",
        "Items"
      ],
      "mechanics": {
        "noiseRange": "-12 metres"
      }
    },
    {
      "id": "plot_twist",
      "name": "Plot Twist",
      "genericVersion": false,
      "character": 38,
      "patch": "9.2.0",
      "units": [
        1
      ],
      "values": [
        2,
        3,
        4
      ],
      "tags": [
        "DyingState",
        "GruntsOfPain",
        "Haste",
        "Healing",
        "PoolsOfBlood",
        "SelfRecovery"
      ],
      "mechanics": {
        "recovery": "+25 %",
        "haste": "+50 %"
      }
    },
    {
      "id": "plunderer_s_instinct",
      "name": "Plunderer's Instinct",
      "genericVersion": false,
      "patch": "8.4.0",
      "units": [
        3
      ],
      "values": [
        32,
        48,
        64
      ],
      "tags": [
        "Auras",
        "Chests",
        "Items"
      ],
      "mechanics": {
        "chance": "+50 %"
      }
    },
    {
      "id": "poised",
      "name": "Poised",
      "genericVersion": false,
      "character": 16,
      "patch": "9.2.0",
      "units": [
        1
      ],
      "values": [
        20,
        25,
        30
      ],
      "tags": [
        "Auras",
        "Generators",
        "ScratchMarks",
        "Stealth"
      ],
      "mechanics": {
        "duration": "8 seconds"
      }
    },
    {
      "id": "potential_energy",
      "name": "Potential Energy",
      "genericVersion": false,
      "character": 34,
      "patch": "9.1.0",
      "units": [
        5
      ],
      "values": [
        10,
        15,
        20
      ],
      "tags": [
        "Generators",
        "BonusProgression",
        "SkillChecks",
        "Tokens"
      ],
      "mechanics": {
        "conversion": [
          "1 Token",
          "1 %",
          "+1 %"
        ],
        "threshold": "1 Token",
        "penalty": [
          "-20 %",
          "-10 %"
        ]
      }
    },
    {
      "id": "power_struggle",
      "name": "Power Struggle",
      "genericVersion": false,
      "character": 24,
      "patch": "5.5.0",
      "units": [
        4
      ],
      "values": [
        25,
        20,
        15
      ],
      "tags": [
        "Pallets",
        "KillerStun",
        "Wiggle"
      ]
    },
    {
      "id": "premonition",
      "name": "Premonition",
      "genericVersion": false,
      "patch": "2.6.2",
      "units": [
        1
      ],
      "values": [
        60,
        45,
        30
      ],
      "tags": [
        "Warning"
      ],
      "mechanics": {
        "cone": "45 °",
        "range": "36 metres"
      }
    },
    {
      "id": "prove_thyself",
      "name": "Prove Thyself",
      "genericVersion": false,
      "character": 1,
      "patch": "7.1.0",
      "units": [
        4,
        4
      ],
      "values": [
        6,
        8,
        10,
        18,
        24,
        30
      ],
      "tags": [
        "ActionSpeed",
        "Generators",
        "RepairingProficiency"
      ]
    },
    {
      "id": "quick_quiet",
      "name": "Quick & Quiet",
      "genericVersion": false,
      "character": 2,
      "patch": "8.6.0",
      "units": [
        1
      ],
      "values": [
        25,
        20,
        15
      ],
      "tags": [
        "Lockers",
        "LoudNoiseNotifications",
        "Pallets",
        "RepairingProficiency",
        "Stealth",
        "Vaulting"
      ]
    },
    {
      "id": "quick_gambit",
      "name": "Quick Gambit",
      "genericVersion": false,
      "character": 34,
      "patch": "9.2.0",
      "units": [
        4
      ],
      "values": [
        3,
        4,
        5
      ],
      "tags": [
        "Auras",
        "ActionSpeed",
        "Chase",
        "RepairingProficiency"
      ],
      "mechanics": {
        "cooldown": "40 seconds"
      }
    },
    {
      "id": "rapid_response",
      "name": "Rapid Response",
      "genericVersion": false,
      "character": 46,
      "patch": "8.7.0",
      "units": [
        1
      ],
      "values": [
        30,
        25,
        20
      ],
      "tags": [
        "Auras",
        "Exhausted",
        "Lockers"
      ],
      "mechanics": {
        "aura": "2 seconds"
      }
    },
    {
      "id": "reactive_healing",
      "name": "Reactive Healing",
      "genericVersion": false,
      "character": 32,
      "patch": "6.2.0",
      "units": [
        4
      ],
      "values": [
        40,
        45,
        50
      ],
      "tags": [
        "BonusProgression",
        "Healing"
      ]
    },
    {
      "id": "reassurance",
      "name": "Reassurance",
      "genericVersion": false,
      "character": 33,
      "patch": "6.2.0",
      "units": [
        1
      ],
      "values": [
        20,
        25,
        30
      ],
      "tags": [
        "ActionPause",
        "EntityProgression",
        "Hooks"
      ],
      "mechanics": {
        "range": "6 metres",
        "limit": "once"
      }
    },
    {
      "id": "red_herring",
      "name": "Red Herring",
      "genericVersion": false,
      "character": 21,
      "patch": "8.6.0",
      "units": [
        1
      ],
      "values": [
        25,
        20,
        15
      ],
      "tags": [
        "Auras",
        "Deception",
        "Generators",
        "Lockers",
        "LoudNoiseNotifications"
      ],
      "mechanics": {
        "activation": "1 second"
      }
    },
    {
      "id": "repressed_alliance",
      "name": "Repressed Alliance",
      "genericVersion": false,
      "character": 22,
      "units": [
        1
      ],
      "values": [
        55,
        50,
        45
      ],
      "tags": [
        "Auras",
        "GenBlocker",
        "Generators"
      ]
    },
    {
      "id": "residual_manifest",
      "name": "Residual Manifest",
      "genericVersion": false,
      "character": 31,
      "units": [
        1
      ],
      "values": [
        20,
        25,
        30
      ],
      "tags": [
        "Blindness",
        "Chests",
        "Items",
        "KillerBlind"
      ]
    },
    {
      "id": "resilience",
      "name": "Resilience",
      "genericVersion": false,
      "patch": "1.0.0",
      "units": [
        4
      ],
      "values": [
        3,
        6,
        9
      ],
      "tags": [
        "ActionSpeed",
        "Blessing",
        "Chests",
        "Cleansing",
        "ExitGates",
        "Generators",
        "Healing",
        "Hooks",
        "Opening",
        "Repairing",
        "Sabotaging",
        "Searching",
        "Totems",
        "Unhooking",
        "Vaulting",
        "Windows"
      ]
    },
    {
      "id": "resurgence",
      "name": "Resurgence",
      "genericVersion": false,
      "character": 26,
      "patch": "8.1.0",
      "units": [
        4
      ],
      "values": [
        50,
        60,
        70
      ],
      "tags": [
        "BonusProgression",
        "Healing",
        "Hooks"
      ]
    },
    {
      "id": "road_life",
      "name": "Road Life",
      "genericVersion": false,
      "character": 49,
      "patch": "9.2.0",
      "units": [
        5
      ],
      "values": [
        6,
        5,
        4
      ],
      "tags": [
        "ActionSpeed",
        "Broken",
        "Generators",
        "HealingProficiency",
        "SkillChecks",
        "Tokens"
      ],
      "mechanics": {
        "tokens": [
          "+1 Token",
          "0 Tokens",
          "-1 Token"
        ],
        "healing": "+100 %"
      }
    },
    {
      "id": "rookie_spirit",
      "name": "Rookie Spirit",
      "genericVersion": false,
      "character": 27,
      "units": [
        7
      ],
      "values": [
        5,
        4,
        3
      ],
      "tags": [
        "Auras",
        "Generators",
        "SkillChecks"
      ]
    },
    {
      "id": "saboteur",
      "name": "Saboteur",
      "genericVersion": false,
      "character": 4,
      "patch": "7.1.0",
      "units": [
        1
      ],
      "values": [
        70,
        65,
        60
      ],
      "tags": [
        "ActionSpeed",
        "Auras",
        "Hooks",
        "Sabotage",
        "ScourgeHookAuras"
      ],
      "mechanics": {
        "radius": "56 metres",
        "speed": "+30 %"
      }
    },
    {
      "id": "scavenger",
      "name": "Scavenger",
      "genericVersion": false,
      "character": 37,
      "patch": "7.0.0",
      "units": [
        1
      ],
      "values": [
        40,
        35,
        30
      ],
      "tags": [
        "Chests",
        "Items",
        "SkillChecks",
        "Tokens"
      ]
    },
    {
      "id": "scene_partner",
      "name": "Scene Partner",
      "genericVersion": false,
      "character": 38,
      "patch": "8.4.0",
      "units": [
        1
      ],
      "values": [
        4,
        5,
        6
      ],
      "tags": [
        "Auras",
        "Screams",
        "TerrorRadius"
      ],
      "mechanics": {
        "aura": "+2 seconds",
        "chance": "50 %",
        "cooldown": "40 seconds"
      }
    },
    {
      "id": "second_wind",
      "name": "Second Wind",
      "genericVersion": false,
      "character": 19,
      "patch": "7.3.3",
      "units": [
        1
      ],
      "values": [
        28,
        24,
        20
      ],
      "tags": [
        "Broken",
        "Healing",
        "Hooks"
      ]
    },
    {
      "id": "self_care",
      "name": "Self-Care",
      "genericVersion": false,
      "character": 3,
      "patch": "6.1.0",
      "units": [
        4
      ],
      "values": [
        25,
        30,
        35
      ],
      "tags": [
        "ActionSpeed",
        "Efficiency",
        "Healing",
        "HealingProficiency",
        "SelfHealing"
      ]
    },
    {
      "id": "self_preservation",
      "name": "Self-Preservation",
      "genericVersion": false,
      "character": 25,
      "patch": "9.5.0",
      "units": [
        1
      ],
      "values": [
        20,
        25,
        30
      ],
      "tags": [
        "GruntsOfPain",
        "PoolsOfBlood",
        "ScratchMarks",
        "Stealth",
        "Elusive"
      ]
    },
    {
      "id": "shoulder_the_burden",
      "name": "Shoulder the Burden",
      "genericVersion": false,
      "character": 45,
      "patch": "8.4.0",
      "units": [
        1
      ],
      "values": [
        60,
        50,
        40
      ],
      "tags": [
        "Exposed",
        "HookStates",
        "Screams"
      ]
    },
    {
      "id": "slippery_meat",
      "name": "Slippery Meat",
      "genericVersion": false,
      "patch": "4.3.0",
      "units": [
        4
      ],
      "values": [
        2,
        3,
        4
      ],
      "tags": [
        "Chance",
        "EscapeAttempts",
        "Hooks"
      ],
      "mechanics": {
        "attempts": "+3"
      }
    },
    {
      "id": "small_game",
      "name": "Small Game",
      "genericVersion": false,
      "patch": "4.7.0",
      "units": [
        3,
        1
      ],
      "values": [
        8,
        10,
        12,
        14,
        12,
        10
      ],
      "tags": [
        "KillerTraps",
        "Totems",
        "Warning"
      ],
      "mechanics": {
        "coneDefault": "45 °",
        "tokenGain": "+1 Token",
        "tokenLimit": "5 Tokens",
        "coneReduction": "-5 °",
        "coneLimit": "-25 °"
      }
    },
    {
      "id": "smash_hit",
      "name": "Smash Hit",
      "genericVersion": false,
      "character": 25,
      "patch": "7.1.0",
      "units": [
        1
      ],
      "values": [
        30,
        25,
        20
      ],
      "tags": [
        "Exhausted",
        "Haste",
        "Pallets",
        "KillerStun"
      ],
      "mechanics": {
        "haste": "+50 %",
        "durationHaste": "4 seconds"
      }
    },
    {
      "id": "solidarity",
      "name": "Solidarity",
      "genericVersion": false,
      "character": 16,
      "patch": "8.1.0",
      "units": [
        4
      ],
      "values": [
        50,
        60,
        70
      ],
      "tags": [
        "Conversion",
        "Healing"
      ]
    },
    {
      "id": "soul_guard",
      "name": "Soul Guard",
      "genericVersion": false,
      "character": 22,
      "patch": "4.7.0",
      "units": [
        1
      ],
      "values": [
        4,
        6,
        8
      ],
      "tags": [
        "ConspicuousActions",
        "Cursed",
        "DeepWound",
        "Endurance",
        "SelfRecovery"
      ],
      "mechanics": {
        "cooldown": "30 seconds"
      }
    },
    {
      "id": "specialist",
      "name": "Specialist",
      "genericVersion": false,
      "character": 43,
      "patch": "8.1.0",
      "units": [
        9,
        9
      ],
      "values": [
        2,
        3,
        4,
        12,
        18,
        24
      ],
      "tags": [
        "Chests",
        "Generators",
        "RepairRequirement",
        "SkillChecks",
        "Tokens"
      ]
    },
    {
      "id": "spine_chill",
      "name": "Spine Chill",
      "genericVersion": false,
      "patch": "7.1.0",
      "units": [
        4
      ],
      "values": [
        2,
        4,
        6
      ],
      "tags": [
        "ActionSpeed",
        "ExitGates",
        "HealingProficiency",
        "RepairingProficiency",
        "SabotageProficiency",
        "CleansingProficiency",
        "SkillCheckDifficulty",
        "Warning",
        "Chests",
        "Totems",
        "Blessing"
      ],
      "mechanics": {
        "range": "36 metres",
        "linger": "0.5 seconds"
      }
    },
    {
      "id": "sprint_burst",
      "name": "Sprint Burst",
      "genericVersion": false,
      "character": 2,
      "patch": "2.1.0",
      "units": [
        1
      ],
      "values": [
        60,
        50,
        40
      ],
      "tags": [
        "Exhausted",
        "Haste"
      ],
      "mechanics": {
        "haste": "+50 %",
        "durationHaste": "3 seconds"
      }
    },
    {
      "id": "stake_out",
      "name": "Stake Out",
      "genericVersion": false,
      "character": 12,
      "patch": "3.7.0",
      "units": [
        5
      ],
      "values": [
        2,
        3,
        4
      ],
      "tags": [
        "SkillChecks",
        "TerrorRadius",
        "Tokens"
      ],
      "mechanics": {
        "tokenChargeTime": "15 seconds",
        "tokenGain": "+1 Token",
        "tokenCost": "-1 Token",
        "bonus": "+1 %"
      }
    },
    {
      "id": "still_sight",
      "name": "Still Sight",
      "genericVersion": false,
      "character": 42,
      "patch": "9.1.0",
      "units": [
        1
      ],
      "values": [
        4,
        3,
        2
      ],
      "tags": [
        "Auras",
        "Chests",
        "Generators",
        "KillerAura"
      ],
      "mechanics": {
        "range": "24 meters"
      }
    },
    {
      "id": "streetwise",
      "name": "Streetwise",
      "genericVersion": false,
      "character": 5,
      "patch": "9.1.0",
      "units": [
        4
      ],
      "values": [
        60,
        70,
        80
      ],
      "tags": [
        "Auras",
        "Charges",
        "Chests",
        "Items",
        "KillerAura"
      ],
      "mechanics": {
        "activation": "first time",
        "aura": "8 seconds"
      }
    },
    {
      "id": "strength_in_shadows",
      "name": "Strength in Shadows",
      "genericVersion": false,
      "character": 41,
      "patch": "7.6.0",
      "units": [
        1
      ],
      "values": [
        6,
        8,
        10
      ],
      "tags": [
        "ActionSpeed",
        "Auras",
        "Basement",
        "Efficiency",
        "Healing",
        "HealingProficiency",
        "SelfHealing"
      ]
    },
    {
      "id": "teamwork_collective_stealth",
      "name": "Teamwork: Collective Stealth",
      "genericVersion": false,
      "character": 36,
      "patch": "8.3.0",
      "units": [
        3
      ],
      "values": [
        8,
        12,
        16
      ],
      "tags": [
        "Healing",
        "ScratchMarks",
        "Stealth",
        "Teamwork"
      ],
      "mechanics": {
        "duration": "4 seconds"
      }
    },
    {
      "id": "teamwork_full_circuit",
      "name": "Teamwork: Full Circuit",
      "genericVersion": false,
      "character": 50,
      "patch": "9.4.0",
      "units": [
        4
      ],
      "values": [
        15,
        20,
        25
      ],
      "tags": [
        "Generators",
        "SkillChecks",
        "SkillCheckDifficulty",
        "ActionSpeed",
        "Teamwork"
      ],
      "mechanics": {
        "repairSpeed": "5 %"
      }
    },
    {
      "id": "teamwork_power_of_two",
      "name": "Teamwork: Power of Two",
      "genericVersion": false,
      "character": 35,
      "patch": "8.3.0",
      "units": [
        3
      ],
      "values": [
        8,
        12,
        16
      ],
      "tags": [
        "Haste",
        "Healing",
        "Teamwork"
      ],
      "mechanics": {
        "haste": "+5 %",
        "duration": "4 seconds"
      }
    },
    {
      "id": "teamwork_soft_spoken",
      "name": "Teamwork: Soft-Spoken",
      "genericVersion": false,
      "character": 51,
      "patch": "9.4.0",
      "units": [
        4
      ],
      "values": [
        15,
        20,
        25
      ],
      "tags": [
        "Generators",
        "ActionNoise",
        "ActionSpeed",
        "Teamwork"
      ],
      "mechanics": {
        "repairSpeed": "5 %"
      }
    },
    {
      "id": "teamwork_throw_down",
      "name": "Teamwork: Throw Down",
      "genericVersion": false,
      "character": 48,
      "patch": "9.1.0",
      "units": [
        1
      ],
      "values": [
        6,
        8,
        10
      ],
      "tags": [
        "Auras",
        "Endurance",
        "KillerBlind",
        "KillerStun",
        "Pallets",
        "Teamwork"
      ],
      "mechanics": {
        "range": "24 metres"
      }
    },
    {
      "id": "teamwork_toughen_up",
      "name": "Teamwork: Toughen Up",
      "genericVersion": false,
      "character": 47,
      "patch": "9.1.0",
      "units": [
        1
      ],
      "values": [
        20,
        25,
        30
      ],
      "tags": [
        "GruntsOfPain",
        "KillerBlind",
        "KillerStun",
        "Pallets",
        "PoolsOfBlood",
        "ScratchMarks",
        "Teamwork"
      ],
      "mechanics": {
        "range": "24 metres"
      }
    },
    {
      "id": "technician",
      "name": "Technician",
      "genericVersion": false,
      "character": 9,
      "patch": "4.3.0",
      "units": [
        4
      ],
      "values": [
        5,
        4,
        3
      ],
      "tags": [
        "ActionNoise",
        "Generators",
        "ProgressionPenalty",
        "SkillChecks",
        "LoudNoiseNotifications"
      ],
      "mechanics": {
        "range": "-8 metres"
      }
    },
    {
      "id": "tenacity",
      "name": "Tenacity",
      "genericVersion": false,
      "character": 12,
      "patch": "9.3.0",
      "units": [
        4
      ],
      "values": [
        30,
        40,
        50
      ],
      "tags": [
        "Auras",
        "GruntsOfPain",
        "Haste",
        "Recovering"
      ],
      "mechanics": {
        "volume": "-75 %"
      }
    },
    {
      "id": "this_is_not_happening",
      "name": "This Is Not Happening",
      "genericVersion": false,
      "patch": "3.6.0",
      "units": [
        4
      ],
      "values": [
        10,
        20,
        30
      ],
      "tags": [
        "SkillCheckDifficulty",
        "SkillChecks"
      ]
    },
    {
      "id": "troubleshooter",
      "name": "Troubleshooter",
      "genericVersion": false,
      "character": 37,
      "patch": "7.0.0",
      "units": [
        1,
        1
      ],
      "values": [
        4,
        5,
        6,
        6,
        8,
        10
      ],
      "tags": [
        "Auras",
        "Chase",
        "Generators",
        "Pallets"
      ]
    },
    {
      "id": "unbreakable",
      "name": "Unbreakable",
      "genericVersion": false,
      "character": 8,
      "patch": "1.4.2",
      "units": [
        4
      ],
      "values": [
        25,
        30,
        35
      ],
      "tags": [
        "Recovering",
        "RecoverySpeed",
        "SelfRecovery"
      ],
      "mechanics": {
        "limit": "once"
      }
    },
    {
      "id": "up_the_ante",
      "name": "Up the Ante",
      "genericVersion": false,
      "character": 7,
      "patch": "9.0.0",
      "units": [
        4,
        4
      ],
      "values": [
        1,
        2,
        3,
        3,
        6,
        9
      ],
      "tags": [
        "Chance",
        "EscapeAttempts"
      ],
      "mechanics": {
        "tokenGain": "+1 Token"
      }
    },
    {
      "id": "urban_evasion",
      "name": "Urban Evasion",
      "genericVersion": false,
      "character": 5,
      "units": [
        4
      ],
      "values": [
        90,
        95,
        100
      ],
      "tags": [
        "Crouching",
        "Haste"
      ]
    },
    {
      "id": "vigil",
      "name": "Vigil",
      "genericVersion": false,
      "character": 11,
      "patch": "9.2.0",
      "units": [
        4
      ],
      "values": [
        43,
        55,
        66
      ],
      "tags": [
        "Blindness",
        "Broken",
        "Exposed",
        "Exhausted",
        "Haemorrhage",
        "Hindered",
        "Mangled",
        "Oblivious",
        "RecoverySpeed"
      ],
      "mechanics": {
        "range": "16 metres",
        "linger": "15 seconds"
      }
    },
    {
      "id": "visionary",
      "name": "Visionary",
      "genericVersion": false,
      "character": 23,
      "units": [
        1
      ],
      "values": [
        20,
        18,
        16
      ],
      "tags": [
        "Auras",
        "Generators"
      ],
      "mechanics": {
        "range": "32 metres"
      }
    },
    {
      "id": "wake_up",
      "name": "Wake Up!",
      "genericVersion": false,
      "character": 11,
      "patch": "8.5.0",
      "units": [
        4,
        4
      ],
      "values": [
        8,
        10,
        12.5,
        32,
        40,
        50
      ],
      "tags": [
        "ActionSpeed",
        "Auras",
        "ExitGates"
      ],
      "mechanics": {
        "range": "128 metres"
      }
    },
    {
      "id": "we_see_you",
      "name": "We See You",
      "genericVersion": false,
      "character": 51,
      "patch": "9.4.0",
      "units": [
        1
      ],
      "values": [
        10,
        12.5,
        15
      ],
      "tags": [
        "Auras",
        "KillerAura"
      ],
      "mechanics": {
        "maxTokens": "4 tokens",
        "tokenCooldown": "10-second"
      }
    },
    {
      "id": "we_ll_make_it",
      "name": "We'll Make It",
      "genericVersion": false,
      "patch": "4.0.2",
      "units": [
        1
      ],
      "values": [
        30,
        60,
        90
      ],
      "tags": [
        "ActionSpeed",
        "Healing",
        "HealingProficiency"
      ],
      "mechanics": {
        "effect": "+100 %"
      }
    },
    {
      "id": "we_re_gonna_live_forever",
      "name": "We're Gonna Live Forever",
      "genericVersion": false,
      "character": 10,
      "patch": "8.3.2",
      "units": [
        1
      ],
      "values": [
        6,
        8,
        10
      ],
      "tags": [
        "ActionSpeed",
        "ConspicuousActions",
        "DeepWound",
        "Endurance",
        "Healing",
        "HealingProficiency"
      ],
      "mechanics": {
        "healing": "+100 %",
        "cooldown": "30 seconds"
      }
    },
    {
      "id": "wicked",
      "name": "Wicked",
      "genericVersion": false,
      "character": 41,
      "patch": "9.3.2",
      "units": [
        1
      ],
      "values": [
        16,
        18,
        20
      ],
      "tags": [
        "Auras",
        "Basement",
        "Chance",
        "EscapeAttempt",
        "Hooks"
      ],
      "mechanics": {
        "chance": "100 %"
      }
    },
    {
      "id": "will_to_live",
      "name": "Will to Live",
      "formerName": "Decisive Strike",
      "genericVersion": false,
      "patch": "8.0.0",
      "units": [
        1
      ],
      "values": [
        40,
        50,
        60
      ],
      "tags": [
        "Obsession",
        "SkillChecks",
        "KillerStun"
      ]
    },
    {
      "id": "decisive_strike",
      "name": "Decisive Strike",
      "genericVersion": false,
      "character": 6
    },
    {
      "id": "windows_of_opportunity",
      "name": "Windows of Opportunity",
      "genericVersion": false,
      "character": 13,
      "units": [
        3
      ],
      "values": [
        24,
        28,
        32
      ],
      "tags": [
        "Auras",
        "BreakableWalls",
        "Pallets",
        "VaultLocations"
      ]
    },
    {
      "id": "wiretap",
      "name": "Wiretap",
      "genericVersion": false,
      "character": 32,
      "patch": "8.2.0",
      "units": [
        1
      ],
      "values": [
        100,
        110,
        120
      ],
      "tags": [
        "Auras",
        "Generators",
        "Trap"
      ],
      "mechanics": {
        "activation": "40 %",
        "range": "14 metres"
      }
    },
    {
      "id": "wide_open_throttle",
      "name": "Wide Open Throttle",
      "genericVersion": false,
      "character": 53,
      "units": [
        4
      ],
      "values": [
        10,
        12.5,
        15
      ],
      "tags": [
        "Haste",
        "Pallets"
      ],
      "mechanics": {
        "vaultHasteDuration": "3 seconds",
        "palletResetDuration": "60 seconds",
        "cooldown": "60 second"
      }
    },
    {
      "id": "lend_a_hand",
      "name": "Lend a Hand",
      "genericVersion": false,
      "character": 53,
      "units": [
        7
      ],
      "values": [
        2,
        3,
        4
      ],
      "tags": [
        "Healing"
      ]
    },
    {
      "id": "cross_examination",
      "name": "Cross-Examination",
      "genericVersion": false,
      "character": 53,
      "units": [
        1
      ],
      "values": [
        3,
        4,
        5
      ],
      "tags": [
        "Elusive"
      ],
      "mechanics": {
        "lightMarkDuration": "10 seconds"
      }
    }
  ]
}
